import { Component, OnInit, NgZone, AfterViewChecked } from '@angular/core';
import { bmxurl, getAccess } from 'src/globals';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AvailableTimes, AvailabilityReq, Payment, Customer } from '../../PackageClasses';
import { customer } from 'src/types/customer';
import { booking } from 'src/types/booking';
import { booking_returndata } from 'src/types/booking_returndata';
import { seriesbooking } from 'src/types/seriesbooking';
import { seriesdiscountvalidate, seriesopendiscount } from 'src/types/seriesdiscount';
import { seriesvouchervalidate } from 'src/types/seriesvoucher';
import { seriespayment } from 'src/types/seriespayment';
import { MessageService } from 'primeng/api';
import { cExtra } from 'src/types/extra';
import { cPackageExtra } from 'src/types/packageExtra';
import { cResource, resource } from 'src/types/resource';
import { v4 as uuidv4  } from 'uuid';
import { BusyService } from '../_services/busy.service';
import { admission } from 'src/types/admission';
import { cBookingfee } from 'src/types/bookingfee';
import { paymenttypes_returndata } from 'src/types/paymenttypes_returndata';
import { bookingsummary, cBookingsummary } from 'src/types/bookingsummary';
import { DomSanitizer } from '@angular/platform-browser';
import { packagegroups_returndata } from 'src/types/packagegroup_returndata';
import { cPackagegroups } from 'src/types/packagegroups';
import { cDiscountvalidate, cOpenDiscountvalidate } from 'src/types/discountvailidate';
import { conf_returndata } from 'src/types/conf_returndata';
import { users_returndata } from 'src/types/user_returndata';
import { birthdayanswers, questionanswers } from 'src/types/questionanswers';
import { bookingquestionitem } from 'src/types/bookingquestion';
import { BehaviorSubject, Subscription, timer } from 'rxjs';
import { cVouchervalidate } from 'src/types/vouchervalidate';
import { venueclosings_returndata } from 'src/types/venueclosings_returndata';
import { venuesettings_returndata } from 'src/types/venuesettings_returndata';
import { GlobalService } from '../_services/global.service';
import { availabletimes_returndata } from 'src/types/availabletimes_returndata';
import { packageabupgrade, packageupgrade } from 'src/types/packageupgrade';
import { map, takeWhile, throwIfEmpty } from 'rxjs/operators';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { SafeHtmlPipe } from 'ngx-spinner/lib/safe-html.pipe';
import { membership } from 'src/types/memberships';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { AuthService } from '@auth0/auth0-angular';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-makeabooking',
  templateUrl: './makeabooking.component.html',
  styleUrls: ['./makeabooking.component.css']
})
export class MakeabookingComponent implements OnInit, AfterViewChecked {

  //#region  Variables
  id: string;
  BookingComplete: boolean = false;
  packages: any[] = [];
  packages1: any[] = [];
  SelectedPackage: any;
  SelectedResources: any[] = []
  SelectedDate: Date;
  startTimes: any;
  startTimesFiltered: any;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  CreateCustomer: any;
  PaymentTypes: any = [];
  selectedPayment: any;
  packageExtras: cPackageExtra[];
  selectedPackageExtras: cExtra[];

  BookingDateAndTime: string = "";
  BookingPackage: string = "";
  BookingAdmissions: string = "";
  BookingAddress: string = "";
  BookingEmail: string = "";
  BookingMobile: string = "";
  BookingValue: string = "";
  Itinerary: string = "";
  bookingExtras: string = "";

  paymentValueValid: boolean = true;
  paymentTypeValid: boolean = true;
  paymentValueExceededValid: boolean = true;
  paymentDepositValid: boolean = true;
  validPaymentAmount: number = 0;

  AllValid: boolean =true;
  CustomerAllValid: boolean =true;

  PackageAdmissions: admission[];
  SelectedAdmissions: admission[];

  PackageHeader: string = "Select a Package";
  CalendarHeader: string = "Select a Date";
  AdmissionHeader: string = "Select your Admissions";
  TimeHeader: string = "Select a Time";
  CustomerHeader: string = "Create a Customer";
  PaymentHeader: string = "Add a Payment";
  ExtrasHeader: string = "Select Extras";
  SelResourceHeader: string = "Please Select";

  packageSelected: Boolean;
  admissionsSelected: Boolean;
  dateSelected: Boolean;
  timeSelected: Boolean;
  customerSelected:Boolean;
  paymentSelected:Boolean;
  extraSelected: Boolean;
  notesSelected: Boolean;
  partyroomsSelected: Boolean;
  bookingQuestionsSelected: Boolean;
  upgradeSelected: Boolean;

  packageActive: Boolean;
  admissionsActive: Boolean;
  dateActive: Boolean;
  timeActive: Boolean;
  customerActive:Boolean;
  paymentActive:Boolean;
  extraActive: Boolean;
  notesActive: Boolean;
  partyroomsActive: Boolean;
  partyroomsVisible: Boolean;
  bookingQuestionsActive: Boolean;
  upgradeActive: Boolean;

  //Customer
  firstName: string = "";
  lastName: string = "";
  address1: string = "";
  address2: string = "";
  town: string = "";
  postCode: string = "";
  email: string = "";
  mobile: string = "";
  dob: Date = new Date(1900, 1, 1);

  firstNameValid: boolean = true;
  lastNameValid: boolean = true;
  Address1Valid: boolean = true;
  TownValid: boolean = true;
  PostCodeValid: boolean = true;
  EmailValid: boolean = true;
  MobileValid: boolean = true;
  NewBooking = {} as booking;

  EmailFormatValid: boolean = true;
  MobileFormatValid: boolean = true;

  stateOptions: any[];
  stateOptionsMin: any[];
  statePayOptions: any[];

  ProvideMinimalPersonalData: string = "LIMITED";

  BookingResponse: any;

  //payment
  paymentAmount: number;
  maxPayment: number;

  searchCriteria: string;
  customersResult: any;

  disgnosticsMode: boolean = true;
  ShowCustomerDetails: boolean = false;

  makeABookingHeader: string = "Make a Booking"

  UpgradeHeader: string = "Select an Upgrade";
  showUpgrade: boolean = false;

  OptionalUpgradeHeader: string = "Select an Add On";
  showOptionalUpgrade: boolean = false;

  notes: string;

  SelectedSeletableResource: any[] = [];
  SelectedSeletableResourceBool: boolean[] = [];

  customerSelectedResources: any[] = [];
  includesComplexResources: boolean = false;
  includesOptionalResources: boolean = false;

  systemChoosesAllResources: boolean = true;

  validselection: boolean[] = [];

  totalAdmissions: number = 0;

  maxadmissions: number = 0;
  minadmissions: number = 0;

  totalAdmissionInRange: boolean;
  PackageHasExtras: boolean;

  MinimumValidPayment:number = 0;
  MustIncludePass: boolean = true;

  httpResponse: any;
  BookingFee: cBookingfee;
  BookingSummary: bookingsummary;
  packageGroups: any[];

  checked: any[] = [];
  popular: any;

  showDiscount: boolean = false;
  discountCode: string = "";

  BookingFeeAdddedOn: number = 0;
  DiscountTakenOff: number = 0;

  showPrintConfirmations: boolean = false;
  confHTML: string = "";

  TotalExtras: number = 0;
  minimumDiscount: number = 0;

  BookingPayments: Payment[] = [];
  totalPayments: number;

  terminalHubConnection: HubConnection | null = null;
  awaitingTerminalPayment: boolean = false;
  showPaymentFailedDialog: boolean = false;
  paymentFailedMessage: string = '';
  showTerminalBusyDialog: boolean = false;
  private pendingTerminalPayload: any = null;
  private pendingTerminalRetry: (() => void) | null = null;
  private terminalPaymentResolved: boolean = false;
  private terminalPollingIntervalId: ReturnType<typeof setInterval> | null = null;
  private pendingScrollToFirstTime: boolean = false;

  showDeferReason: boolean = false;
  deferNotes: string = "";
  AvailabilityReq = {} as AvailabilityReq;
  AvailabilityReq2 = {} as AvailabilityReq;
  AvailabilityReq3 = {} as AvailabilityReq;

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;
  stateOptionAllergy: any[];

  mustanswerallergies: boolean[] = [];
  mustanswerage: boolean[] = [];
  mustanswerbirthdays: boolean[] = [];
  mustanswernumber: boolean[] = [];
  mustanswerfreetext: boolean[] = [];
  mustanswermultichoicesingleanswer: boolean[] = [];
  mustanswermultichoicemultianswer: boolean[] = [];
  mustanswerdate: boolean[] = [];

  questionAnswers: questionanswers[] = [];
  questionAnswer: questionanswers;

  bookingFreeTextAnswer: string = "";
  bookingallergyanswer: string = "";
  bookingnumberanswer: number = 0;
  bookingdateanswer: Date = null;
  allergyAnswer:boolean[] = [];
  bookingmultichoicesingleanswer: bookingquestionitem = null;
  bookingmultichoicemultianswer: bookingquestionitem[] = [];
  showVoucher: boolean = false;
  voucherCode: string = "";
  voucherpin: string = "";

  timetobetried: string = "";

  //Repeatable packages. One entry per upcoming date of the package.
  seriesDates: seriesdate[] = [];
  //ALL - every date at one preferred time, SOME - chosen dates, "" - not chosen yet.
  seriesMode: string = "";
  //Fixed blocks. One entry per block the package runs, with the dates in it resolved against
  //the availability already fetched for every date.
  seriesBlocks: seriesblock[] = [];
  seriesChosenBlockId: string = "";
  seriesPreferredTime: string = "";
  seriesLoading: boolean = false;
  seriesHolding: boolean = false;
  seriesId: string = null;
  //Every held date in date order, once they are all held. The first is also NewBooking.
  seriesBookings: any[] = [];
  //The API's own record of the series - total, payments and outstanding across every date. Null
  //until it has been fetched, and the figures fall back to adding up the dates while it is.
  seriesRecord: seriesbooking = null;

  CurrencySymbol: string = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;

  allergyOptions: any[] = [{ name: 'Yes', value: true }, { name: 'No', value: false}];

  CurrentDate = new Date();//new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0,0,0,0);

  VoucherComplete: boolean = false;

  SummaryItinerary: boolean = false;

  allQuestionsValid: boolean = true;
  linkedAdmissionMessageShown: boolean = false;
  showWarning: boolean = false;
  WarningMessage: string = "";
  totalDiscount: number = 0;

  paymentButtonLocked: boolean = false;

  stateOptionOpenDiscount: any[];
  stateGenderOptions: any[];

  openDiscount: boolean = false;

  chosenDiscountAmount: number = 0;

  showVCWarning: boolean = false;
  VCWarningMessage: string = "";

  venueClosings: any[] = [];

  caldays: any[] = [];
  calmonths: any[] = [];
  calyears: any[] = [];

  DOBDay: any[] = [];
  DOBMonth: any[] = [];
  DOBYear: any[] = [];

  DOBIsValid: boolean = true;
  dobage: any[] = [];
  private ageOptionCache: Map<string, any[]> = new Map<string, any[]>();


  oldDepositValue: number = 0;

  UseIntervalAvailability: boolean = false;

  NewAllowedMin: number = 0;

  availablePackageUpgrades: packageupgrade[] = [];
  availablePackageOptionalUpgrades: packageabupgrade[] = [];

  upgradeavaibilitydone: boolean[] = [false,false,false];
  showTheUpgradeScreen: boolean[] = [false,false,false];

  optioanlUpgradeavaibilitydone: boolean[] = [false,false,false];
  showTheOptionalUpgradeScreen: boolean[] = [false,false,false];
  

  upgradesComplete: boolean = false;
  showUpgradesScreen: boolean = false;

  showOptionalUpgradesScreen: boolean = false;
  optionalUpgradesComplete: boolean = false;

  UpgradeForTime: any;
  MembershipID: string;

  showTimer: boolean = false;

  ActualTimeRemaining: number = 0;
  timeoutTime: number = 30;

  PBWStartTime: Date;

  BookingTimeElasped: boolean = false;

  timeRemaining$: any;
  timerSubscription: Subscription;

  MembershipPIN: string = "";
  customerMemberships: membership[] = [];

  optionalUpgradeSelected: Boolean = false;
  optionalUpgradeActive: Boolean = false;
  globalTimeSlot: AvailableTimes;

  qbook: string = "";

  // Bound method for the pipe to prevent continuous function calls
  getOptionalUpgradeQuantities = (pu: any) => {
    let NumberList: any[] = [];
    let Numbers = {}
    for(var i = 0; i <= pu.quantityremaining; i++)
    {
      Numbers = { "name": i.toString(), value: i };
      NumberList.push(Numbers);
    }
    return NumberList;
  }
  NoAvailabilityMessage: string = "Unfortunately we are fully booked on this date and time for your group size - please try another date";

  //#endregion

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private messageService: MessageService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private busyService: BusyService, private globalService: GlobalService,
    private auth: AuthService, private ngZone: NgZone) {
      this.stateOptions = [{ label: 'Use full personal details', value: "FULL" }, { label: 'Use limited personal details', value: "LIMITED"}, { label: 'Walk In', value: "WALKIN" }]; 
      this.stateOptionsMin = [{ label: 'Use full personal details', value: "FULL" }, { label: 'Use limited personal details', value: "LIMITED"}];    
      this.stateOptionAllergy = [{ label: 'Yes', value: true }, { label: 'No', value: false}];  
      this.stateOptionOpenDiscount = [{ label: 'Enter Discount Value', value: true }, { label: 'Enter Discount Code', value: false}]; 
      this.stateGenderOptions =  [{ label: 'Rather not say', value: 'NOT STATED' }, { label: 'Male', value: 'MALE'}, {label: 'Female', value: 'FEMALE'}]; 
      
      this.dobage = [
        {name:'0 to 3 months', value:'0 to 3 months'},
        {name:'4 to 6 months', value:'4 to 6 months'},
        {name:'6 to 12 months', value:'6 to 12 months'},
        {name:'1', value:'1'},
        {name:'2', value:'2'},
        {name:'3', value:'3'},
        {name:'4', value:'4'},
        {name:'5', value:'5'},
        {name:'6', value:'6'},
        {name:'7', value:'7'},
        {name:'8', value:'8'},
        {name:'9', value:'9'},
        {name:'10', value:'10'},
        {name:'11', value:'11'},
        {name:'12', value:'12'},
        {name:'13', value:'13'},
        {name:'14', value:'14'},
        {name:'15', value:'15'},
        {name:'16', value:'16'},
        {name:'17', value:'17'},
        {name:'18', value:'18'},
        {name:'Over 18', value:'Over 18'}
      ];

      this.caldays =  [
        {name: '01', value:'01'},
        {name: '02', value:'02'},
        {name: '03', value:'03'},
        {name: '04', value:'04'},
        {name: '05', value:'05'},
        {name: '06', value:'06'},
        {name: '07', value:'07'},
        {name: '08', value:'08'},
        {name: '09', value:'09'},
        {name: '10', value:'10'},
        {name: '11', value:'11'},
        {name: '12', value:'12'},
        {name: '13', value:'13'},
        {name: '14', value:'14'},
        {name: '15', value:'15'},
        {name: '16', value:'16'},
        {name: '17', value:'17'},
        {name: '18', value:'18'},
        {name: '19', value:'19'},
        {name: '20', value:'20'},
        {name: '21', value:'21'},
        {name: '22', value:'22'},
        {name: '23', value:'23'},
        {name: '24', value:'24'},
        {name: '25', value:'25'},
        {name: '26', value:'26'},
        {name: '27', value:'27'},
        {name: '28', value:'28'},
        {name: '29', value:'29'},
        {name: '30', value:'30'},
        {name: '31', value:'31'}
      ];
          
      this.calmonths = [
        {name: '01', value:'01'},
        {name: '02', value:'02'},
        {name: '03', value:'03'},
        {name: '04', value:'04'},
        {name: '05', value:'05'},
        {name: '06', value:'06'},
        {name: '07', value:'07'},
        {name: '08', value:'08'},
        {name: '09', value:'09'},
        {name: '10', value:'10'},
        {name: '11', value:'11'},
        {name: '12', value:'12'}
      ];
      
      for(let i = 2050; i > 1920; i--)
        {
          let thisYear = new Date().getFullYear();
          if(i <= thisYear)
          {
            this.calyears.push({name: i.toString(), value: i.toString()});
          }
        }

      this.SummaryItinerary = localStorage.getItem("SummaryItineraryVenue") == "true" ? true : false;

      this.globalService.upgradesComplete$.subscribe((value) => {
        this.upgradesComplete = value;
      });

      this.globalService.upgradeScreen$.subscribe((value) => {
        this.showUpgradesScreen = value;
      });

      this.globalService.optionalUpgradesComplete$.subscribe((value) => {
        this.optionalUpgradesComplete = value;
      });

      this.globalService.optionalUpgradeScreen$.subscribe((value) => {
        this.showOptionalUpgradesScreen = value;
      });
  
  }

  restartTimer(_inTime: any){
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }

    this.PBWStartTime = new Date();
    this.BookingTimeElasped = false;

    this.timeRemaining$ = timer(0, 1000).pipe(
      map(n => (this.timeoutTime - n) * 1000),
      takeWhile(n => n >= 0)
    );

    this.timerSubscription = this.timeRemaining$.subscribe(
      () => this.CheckValue(),
      () => null,
      () => {
          this.BookingTimeElasped = true;
      }
    );
  }

  //html2canvas(document.getElementById('invoice-panel'), { letterRendering: 1, allowTaint: true, onrendered: function (canvas) {                 } });

  generatePDF() {
    const data = document.getElementById('confToPrint');

    html2canvas(data).then(canvas => {
      const imgWidth = 210;
      const pageHeight = 295;
      const imgHeight = canvas.height * imgWidth / canvas.width;
      const heightLeft = imgHeight;

      const contentDataURL = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4'); 

      let position = 0;
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
      pdf.save('Confimation-' + this.NewBooking.bookingIdHR + new Date().toISOString() + '.pdf');
    });

  }

  CheckValue()
  {
    let StartingTimeAmount = this.timeoutTime * 1000
    let NowTime = new Date().getTime();
    this.ActualTimeRemaining = this.PBWStartTime.getTime() - NowTime + StartingTimeAmount;

    if (this.ActualTimeRemaining <= 0) 
    {
      this.BookingTimeElasped = true;
      this.abandonSeriesBookings();
      if(this.NewBooking.bookingId != null)
      {
        let abandonBooking: any = {
          bookingid: this.NewBooking.bookingId,
          jwt: null
        }
        //Booking Exists, abandon it
        this.http.post(bmxurl + "abandonbooking/", abandonBooking).subscribe(response => {
          this.NewBooking = (response as booking_returndata).data;

        }, error => {
          this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to abandon booking.'});
        });
      }
    }
  }

  WarningContinue(){

    this.showWarning = false;
  }

  admitall(){
    this.http.get(bmxurl + "BookingCheckin/" + this.VenueID + "/" + this.NewBooking.bookingId).subscribe(response => {
      this.httpResponse = response
      if(this.httpResponse.succeeded)
      {
        this.messageService.add({severity:'success', summary:'Admitted', detail:'All customers admitted for this booking.'});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Admitted', detail: 'An error occurred admitting all customers for this booking'});
    })
  }

  getToManageWaivers(bookingId)
  {
    this.router.navigate(['/managewaivers', bookingId], {
      queryParams: { returnDate: this.dateSelected }
    });
  }

  admitAndReturn()
  {
    if (this.SelectedPackage?.waiverrequired) {
      this.getToManageWaivers(this.NewBooking.bookingId);
      return;
    }

    this.http.get(bmxurl + "BookingCheckin/" + this.VenueID + "/" + this.NewBooking.bookingId).subscribe(response => {
      this.httpResponse = response;
      if (this.httpResponse.succeeded) {
        this.messageService.add({severity:'success', summary:'Admitted', detail:'All customers admitted for this booking.'});
        const today = new Date();
        const dateStr = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0');
        this.router.navigateByUrl('/ataglance/' + dateStr);
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Admitted', detail: 'An error occurred admitting all customers for this booking'});
    });
  }

  //Birthday and register both ask for a list of people and keep them in the same place, so the
  //grid, the validation and the add and delete buttons are shared between them.
  isPersonListQuestion(questiontype: string): boolean {
    return questiontype == "BIRTHDAY" || questiontype == "REGISTER";
  }

  //Where an entry in the age list sits, in months. The list opens with three month bands and
  //closes with Over 18, so a plain number is only part of it.
  private ageInMonths(value: string): number {
    if(value == "0 to 3 months") return 0;
    if(value == "4 to 6 months") return 4;
    if(value == "6 to 12 months") return 6;
    if(value == "Over 18") return 228;

    const years = Number(value);
    return isNaN(years) ? 0 : years * 12;
  }

  //A birthday or register question can be set up for a range of ages, held in months. The list
  //is filtered down to that range and kept, so the dropdown is handed the same array on every
  //change detection run rather than a freshly built one.
  ageOptionsFor(question: any): any[] {
    const min = question.minage == null ? 0 : question.minage;
    const max = question.maxage == null ? 0 : question.maxage;

    if(min == 0 && max == 0)
      return this.dobage;

    const key = min + "-" + max;

    if(!this.ageOptionCache.has(key))
    {
      this.ageOptionCache.set(key, this.dobage.filter(option => {
        const months = this.ageInMonths(option.value);
        return months >= min && (max == 0 || months <= max);
      }));
    }

    return this.ageOptionCache.get(key);
  }

  //Each birthday question keeps its own list of people, so adding a row to one question leaves
  //the others alone.
  addBirthdayRow(question: any){

    if(question.answers.birthdayanswers == null)
      question.answers.birthdayanswers = [];

    question.answers.birthdayanswers.push({
      index: question.answers.birthdayanswers.length,
      id: uuidv4(),
      name: "",
      age: "",
      birthdate: "",
      gender: "NOT STATED",
      interests: "",
      showage: question.showage,
      showdob: question.showdob,
      showgender: question.showgender,
      showinterests: question.showinterests,
      dobday: "",
      dobmonth: "",
      dobyear: ""
    });
  }

  //Splicing inside a forEach skips the row after the one taken out, so the row is found first
  //and then removed once.
  deleteBirthdayRow(question: any, inId){

    if(question.answers.birthdayanswers == null)
      return;

    const index = question.answers.birthdayanswers.findIndex(element => element.id == inId);

    if(index > -1)
      question.answers.birthdayanswers.splice(index, 1);
  }

  sendPaymentLink(){

    this.NewBooking.payments = null;
    this.NewBooking.inProgress = false;
    this.NewBooking.awaitingpayment = true;
    this.stampSeries();

    this.http.post<any>(bmxurl + "/Payment", this.NewBooking).subscribe(response => {
     this.BookingResponse = response
     this.BookingDateAndTime = new Date(this.BookingResponse.data.startTime).getUTCDate().toString().padStart(2, '0') + "/" + new Date(this.BookingResponse.data.startTime).getUTCMonth().toString().padStart(2, '0') + "/" + new Date(this.BookingResponse.data.startTime).getUTCFullYear() + " " + new Date(this.BookingResponse.data.startTime).getUTCHours().toString().padStart(2, '0') + ":" + new Date(this.BookingResponse.data.startTime).getUTCMinutes().toString().padStart(2, '0');

     this.BookingPackage = this.BookingResponse.data.packageName;

     //The link is sent for the first date and covers the series, but every date still has to come
     //out of progress or it is cleared away while the customer is deciding.
     this.finishSeriesSiblings(null, null, null, { awaitingpayment: true }, () => {});

     this.http.get<any>(bmxurl + "sendpaymentlink/" + this.VenueID + "/" + this.NewBooking.bookingId).subscribe(response => {
      this.httpResponse = response;

      if(!this.httpResponse.succeeded)
      {
        this.messageService.add({severity:'error', summary:'Failure', detail: this.httpResponse.messages[0]});
      }
      else
      {
        if(this.BookingResponse.data.payments != null)
        {
          if(this.BookingResponse.data.payments.length > 0)
          {
            this.messageService.add({severity:'success', summary:'Success', detail: 'Payment link sent'});
          }
          else
          {
            this.messageService.add({severity:'success', summary:'Success', detail: 'Payment link sent, the customer will have 4 hours to respond to this link otherwise the booking will be cancelled. Cancelled bookings cannot be paid.'});
          }
        }
        else
        {
          this.messageService.add({severity:'success', summary:'Success', detail: 'Payment link sent, the customer will have 4 hours to respond to this link otherwise the booking will be cancelled. Cancelled bookings cannot be paid.'});
        }
        this.DoSummary(this.BookingResponse.data);
      }

    }, error => {
      this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to send the Email'});
    })

    }, error => {
      this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to defer payment'});
    })

  }

  doneBookingQuestions(){
    let AllValid = true;

    this.SelectedPackage.questionnaire.bookingquestions.forEach(question => {
      if(question.questiontype == "ALLERGY")
      {
        if(question.answers.allergyanswer.allergypresent == true)
        {
          if(question.answers.allergyanswer.allergytext == "" && question.mandatory)
          {
            AllValid = false;
            this.mustanswerallergies[question.listorder] = false;
          }
          else
          {
            this.mustanswerallergies[question.listorder] = true;
          }
        }
        else
        {
          this.mustanswerallergies[question.listorder] = true;
        }
      }
      else if(question.questiontype == "AGE")
      {
        if(question.answers.numberanswer == null && question.mandatory)
        {
          AllValid = false;
          this.mustanswerage[question.listorder] = false;
        }
        else
        {
          this.mustanswerage[question.listorder] = true;
        }
      }
      else if(this.isPersonListQuestion(question.questiontype))
      {
        this.mustanswerbirthdays[question.listorder] = true;

        (question.answers.birthdayanswers ?? []).forEach(person => {

          if(question.showdob)
            person.birthdate = person.dobday + "/" + person.dobmonth + "/" + person.dobyear;
          else
            person.birthdate = "";

          if(question.mandatory)
          {
            //Every field the question was set up to ask for has to be answered - the extra field
            //on a register included. Read off the question rather than the saved row, so a field
            //switched on after an answer was saved is still enforced; the grid decides what to
            //show on the same basis.
            let missing = person.name == "" || person.name == null
              || ((person.age == "" || person.age == null) && question.showage)
              || ((person.birthdate == "" || person.birthdate == null) && question.showdob)
              || ((person.interests == "" || person.interests == null) && question.showinterests);

            if(missing)
            {
              AllValid = false;
              this.mustanswerbirthdays[question.listorder] = false;
            }
          }
        });
      }
      else if(question.questiontype == "NUMBER")
      {
        if(question.answers.numberanswer == null && question.mandatory)
        {
          AllValid = false;
          this.mustanswernumber[question.listorder] = false
        }
        else
        {
          this.mustanswernumber[question.listorder] = true
        }
      }
      else if(question.questiontype == "FREETEXT")
      {
        if((question.answers.freetextanswer == null || question.answers.freetextanswer == "") && question.mandatory)
        {
          AllValid = false;
          this.mustanswerfreetext[question.listorder] = false;
        }
        else
        {
          this.mustanswerfreetext[question.listorder] = true;
        }
      }
      else if(question.questiontype == "DATE")
      {
        if(question.answers.dateanswer == null && question.mandatory)
        {
          AllValid = false;
          this.mustanswerdate[question.listorder] = false;
        }
        else
        {
          this.mustanswerdate[question.listorder] = true;
        }
      }
      else if(question.questiontype == "MULTICHOICESINGLE")
      {
        if(question.answers.multichoicesingleanswer.id == null && question.mandatory)
        {
          AllValid = false;
          this.mustanswermultichoicesingleanswer[question.listorder] = false;
        }
        else
        {
          this.mustanswermultichoicesingleanswer[question.listorder] = true;
        }

      }
      else if(question.questiontype == "MULTICHOICEMULTIPLE")
      {
        if(question.answers.multichoicemultianswer.length == 0 && question.mandatory)
        {
          AllValid = false;
          this.mustanswermultichoicemultianswer[question.listorder] = false;
        }
        else
        {
          this.mustanswermultichoicemultianswer[question.listorder] = true;
        }

      }
    });
   
    if(AllValid)  
    {
      this.SelectedPackage.questionnaire.bookingid = this.NewBooking.bookingId;
      
      this.SelectedPackage.questionnaire.bookingquestions.forEach(question => {
        if(question.questiontype != "ALLERGY")
        {
          question.answers.allergypresent = false;
          question.answers.allergytext = "";
          question.answers.allergyanswer.allergypresent = false;
        }
        
      });

      this.http.post<booking_returndata>(bmxurl + "/questionanswers", this.SelectedPackage.questionnaire).subscribe(response => {
        this.httpResponse = response
        if (this.httpResponse.succeeded == true) {
          //this.setTab(Sections.Notes);

          if(this.packageExtras.length == 0)
            {
              this.setTab(Sections.Customer);
            }
            else
            {
              this.setTab(Sections.Extras);
            }
        }
        else
        {
          this.messageService.add({ severity: 'error', summary: 'Issue with birthday information:', detail:(this.httpResponse.messages[0])});
        }
      }, error => {
        this.messageService.add({ severity: 'error', summary: 'Not Added', detail: error.messages[0] });
      })
    }
  }

  isValidDate(dateString: string): boolean {
     //check if date is valid
      let date = new Date(dateString);
      return date instanceof Date && !isNaN(date.getTime());
  }

  IsToday()
  {
    var today = new Date();
    var selected = new Date(this.SelectedDate);
    return today.getDate() == selected.getDate() && today.getMonth() == selected.getMonth() && today.getFullYear() == selected.getFullYear();
  }

  IsDiscountValid(p)
  {
    if(p.earlybirddiscount)
    {
      if(p.discountrangetype == 0)
      {
        let dstartdate: Date = new Date(p.discountstart);
        let dstartend: Date = new Date(p.discountend);

        //if(dstartdate.getTime() <= this.CurrentDate.getTime() && dstartend.getTime() <= this.CurrentDate.getTime())
        if(this.CurrentDate.getTime() >= dstartdate.getTime() && this.CurrentDate.getTime() < dstartend.getTime())
        {
          return true;
        }
        else
        {
          return false;
        }
      }
      else
      {
        let today = new Date();
        today = new Date(today.toDateString());
        let bookingdate = new Date(this.SelectedDate);
        let diff = bookingdate.getTime() - today.getTime();
        let days = diff / (1000 * 3600 * 24);
        if(days >= p.discountdaysbefore)
        {
          return true;
        }
        else
        {
          return false;
        }
      }

    }
    else
    {
      return false;
    }

  }

  doReferralNote(){
    this.showDeferReason = false;

    this.NewBooking.inProgress = false;

    this.NewBooking.payments = null;
    this.NewBooking.deferredpayment = true;

    this.NewBooking.notes = (this.NewBooking.notes ?? "") + "DEFERRAL REASON: " + this.deferNotes;
    this.stampSeries();

    this.http.post<customer>(bmxurl + "/deferpayment", this.NewBooking).subscribe(response => {
      this.BookingResponse = response
      this.BookingDateAndTime = new Date(this.BookingResponse.data.startTime).getUTCDate().toString().padStart(2, '0') + "/" + new Date(this.BookingResponse.data.startTime).getUTCMonth().toString().padStart(2, '0') + "/" + new Date(this.BookingResponse.data.startTime).getUTCFullYear() + " " + new Date(this.BookingResponse.data.startTime).getUTCHours().toString().padStart(2, '0') + ":" + new Date(this.BookingResponse.data.startTime).getUTCMinutes().toString().padStart(2, '0');

      this.BookingPackage = this.BookingResponse.data.packageName;

      //Deferring covers the whole series, so the other dates are completed as deferred too.
      this.finishSeriesSiblings(null, null, null, { deferredpayment: true }, () => this.DoSummary(this.BookingResponse.data));

    }, error => {
    })

  }

  genRandomNum()
  {
    return Math.floor((Math.random()*10000)+1).toString();
  }

  changedPGSelection(selectedButton){
    this.packages = [];

    this.packageGroups.forEach(pg => {
      if(this.checked[pg.packagegroupid] != null)
      {
        if(this.checked[pg.packagegroupid] == true)
        {
          pg.packages.forEach(packagesInPG => {

            let found = false;  
            this.packages.forEach(pkg => {
              if(pkg.packageId == packagesInPG.packageId)
                found = true;
            });

            if(!found)
            {
              //if(new Date(packagesInPG.endDate).getTime() < new Date().getTime())
              //{
                this.packages.push(packagesInPG)
              //}
            }

            // if(!this.packages.includes(packagesInPG))
            //   this.packages.push(packagesInPG)
          });
        }
      }
    });
  }

  doneDiscount(){
    //A series is discounted as a whole, not on its first date.
    if(this.isSeriesBooking)
    {
      const request: seriesdiscountvalidate = {
        discountcode: this.discountCode.trim(),
        venueid: this.VenueID,
        seriesid: this.seriesId
      };

      this.sendSeriesDiscount("/SeriesDiscountValidate", request);
      return;
    }

    //send discount to server
    let dv: cDiscountvalidate = {
      booking: this.NewBooking,
      discountcode: this.discountCode.trim()
    }

    this.http.post<booking_returndata>(bmxurl + "/DiscountValidate", dv).subscribe(response => {
      this.httpResponse = response
      if (this.httpResponse.succeeded == true) {
        this.messageService.add({ severity: 'success', summary: 'Discount Added', detail: 'Your discount has been added' });

        this.showDiscount = false;
        this.discountCode = "";

        this.NewBooking = (response as booking_returndata).data;

        if(this.NewBooking.PublicBooking)
        {
          this.validPaymentAmount = this.NewBooking.totalpublicdeposit;

          if(this.NewBooking.totalpayments >= this.NewBooking.totalpublicdeposit)
            {
              this.completeWithoutPayment();
            }
            this.busyService.idle();
        }
        else{
          this.validPaymentAmount = this.NewBooking.totalvenuedeposit;

          if(this.NewBooking.totalpayments >= this.NewBooking.totalvenuedeposit)
            {
              this.completeWithoutPayment();
            }
            this.busyService.idle();
        }

      }
      else
      {
        this.messageService.add({ severity: 'error', summary: 'Not Added', detail:(this.httpResponse.messages[0])});
      }
    }, error => {
      this.messageService.add({ severity: 'error', summary: 'Not Added', detail: error.messages[0] });
    })
  }

  doneOpenDiscount(){
        //A series is discounted as a whole, not on its first date.
        if(this.isSeriesBooking)
        {
          const request: seriesopendiscount = {
            value: Math.round((Number(this.chosenDiscountAmount) || 0) * 100) / 100,
            venueid: this.VenueID,
            seriesid: this.seriesId
          };

          this.sendSeriesDiscount("/SeriesOpenDiscount", request);
          return;
        }

        //send discount to server
        let dv: cOpenDiscountvalidate = {
          booking: this.NewBooking,
          value : this.chosenDiscountAmount
        }
    
        this.http.post<booking_returndata>(bmxurl + "/opendiscount", dv).subscribe(response => {
          this.httpResponse = response
          if (this.httpResponse.succeeded == true) {
            this.messageService.add({ severity: 'success', summary: 'Discount Added', detail: 'Your discount has been added' });
    
            this.showDiscount = false;
            this.discountCode = "";
    
            this.NewBooking = (response as booking_returndata).data;

            this.totalPayments = 0;
            this.BookingPayments.forEach(element => {
              this.totalPayments += element.amount;
            });
    
            if(this.NewBooking.PublicBooking)
            {
              this.validPaymentAmount = this.NewBooking.totalpublicdeposit;
            }
            else{
              this.validPaymentAmount = this.NewBooking.totalvenuedeposit;
            }

            if(this.NewBooking.totalvenuedeposit <= 0)
            {
              this.completeWithoutPayment();
            }
    
          }
          else
          {
            this.messageService.add({ severity: 'error', summary: 'Not Added', detail:(this.httpResponse.messages[0])});
          }
        }, error => {
          this.messageService.add({ severity: 'error', summary: 'Not Added', detail: error.messages[0] });
        })
  }

  doneVoucher()
  {  
    //A series takes the voucher as a whole, not date by date.
    if(this.isSeriesBooking)
    {
      this.sendSeriesVoucher();
      return;
    }

    this.busyService.busy();

    let newCustomer: any;

    newCustomer = this.NewBooking.customer;
    
    let dv: cVouchervalidate = {
      booking: this.NewBooking,
      vouchercode: this.voucherCode.trim(),
      voucherpin : this.voucherpin 
    }

    this.http.post<booking_returndata>(bmxurl + "/VoucherValidate", dv).subscribe(response => {
      this.httpResponse = response
      if (this.httpResponse.succeeded == true) {
        this.messageService.add({ severity: 'success', summary: 'Voucher Added', detail: 'Your voucher has been added' });

        this.showDiscount = false;
        this.discountCode = "";

        this.showVoucher = false;
        this.voucherCode = "";

        this.NewBooking = (response as booking_returndata).data;

        this.BookingPayments = this.NewBooking.payments;

        this.totalPayments = 0;
          this.BookingPayments.forEach(element => {
            this.totalPayments += element.amount;
          });

        this.NewBooking.customer = newCustomer;

        if(this.NewBooking.PublicBooking)
        {
          this.validPaymentAmount = this.NewBooking.totalpublicdeposit;
        }
        else{
          this.validPaymentAmount = this.NewBooking.totalvenuedeposit;
        }

        // if(this.NewBooking.totalpayments >= this.NewBooking.totalpublicdeposit)
        // {
        //   this.DoSummary(this.NewBooking);
        //   this.BookingComplete = true;
        // }
        // this.busyService.idle();

        if(this.NewBooking.totalvenuedeposit <= 0)
        {
          this.completeWithoutPayment();
        }

        this.busyService.idle();
      }
      else
      {
        this.busyService.idle();
        this.messageService.add({ severity: 'error', summary: 'Not Added', detail:(this.httpResponse.messages[0])});
      }
    }, error => {
      this.busyService.idle();
      this.messageService.add({ severity: 'error', summary: 'Not Added', detail: error.error.messages[0] });
    })
  }

  displayDiscount(){
    this.showDiscount = !this.showDiscount;
  }

  displayVoucher(){
    this.showVoucher = !this.showVoucher;
  }
  
  donePartyRooms()
  {
    this.SelResourceHeader = "You selected: ";
    this.customerSelectedResources = [];
    
    let index = 0;
    this.SelectedResources.forEach(packResOriginal => {

      let packRes = JSON.parse(JSON.stringify(packResOriginal));

      if(packRes.optional == true)
      {
        if(this.SelectedSeletableResourceBool[index] == true)
        {
          packRes.ignore = false;
          if(packRes.resources.length > 0)
          {
              if(packRes.isconstructed && packRes.isresourcecontainer)
              {
                let resourceToSave: resource;
                packRes.resources.forEach(selectedRes => {
                  if(selectedRes != null)
                  {
                    if (selectedRes.id == this.SelectedSeletableResource[index])
                    {
                      resourceToSave = selectedRes;
                    }
                  }
                });
                
                packRes.resources = [];
                packRes.resources.push(resourceToSave);
              }
              this.customerSelectedResources.push(packRes);
              this.validselection[index] = true;
          }
          else
          {
            packRes.ignore = false;
            this.customerSelectedResources.push(packRes);
            this.SelResourceHeader += packRes.name + ", ";
          }
        }
        else
        {
          packRes.ignore = true;
          this.customerSelectedResources.push(packRes);
        }
      }
      else
      {
        if (this.SelectedSeletableResource[index] != null)
        {
          //if(packRes.selectionmode != "ANY" && packRes.selectionmode != "SYSTEMANY")
          //{
            let resourceToSave: resource;
            packRes.resources.forEach(selectedRes => {
              if (selectedRes.id == this.SelectedSeletableResource[index])
              {
                resourceToSave = selectedRes;
              }
            });
            
            packRes.resources = [];
            packRes.resources.push(resourceToSave);

            this.customerSelectedResources.push(packRes);
            this.validselection[index] = true;
        }
        else
        {
          this.customerSelectedResources.push(packRes);
          if(packRes.mode != "SIMPLE")
            this.validselection[index] = true;
        }
      }
      index++;
    });

    let validationPassed = true;
    
    //Check validation:
    index = 0;
    this.customerSelectedResources.forEach(innerPackageRes => {
      if(innerPackageRes != null)
      {
        if(innerPackageRes.optional == true)
        {
          if (this.SelectedSeletableResourceBool[index] == true)
          {
            if(innerPackageRes.resources.length > 0)
            {
              if(innerPackageRes.resources[0] == null)
                this.validselection[index] = false;
              else
                this.validselection[index] = true;
            }
          }
          else
          {
            this.validselection[index] = true;
          }
        }
      }
      index++;
    });

    this.validselection.forEach(element => {
      if (element == false)
        validationPassed = false;
    });
    
    if (!validationPassed)
      return;


    this.SelectedPackage.resources = []

    this.customerSelectedResources.forEach(element => {
      if(!element.ignore)
      {
        this.SelectedPackage.resources.push(element);
        if(element.resources.length == 0)
        {
          if(element.mode != "SIMPLE")
            this.SelResourceHeader += element.name + ", ";
        }
        else
        {
          if(element.isresourcecontainer && !element.isconstructed)
          {
            if(element.mode != "SIMPLE")
              this.SelResourceHeader += element.name + ", ";
          }
          else
          {
            if(element.mode != "SIMPLE")
            {
              if(element.resources[0] != null)
                this.SelResourceHeader += element.resources[0].name + ", ";
            }
          }
        }
      }
    });
    

    if(this.SelResourceHeader.length > 2)
      this.SelResourceHeader = this.SelResourceHeader.substring(0, this.SelResourceHeader.length - 2)

      this.setTab(4);
      this.getAvailability();
  }

  addselectedCustomer(passCustomer){
    this.searchCriteria = "";

    this.CustomerHeader = "Customer: " +  passCustomer.firstName + "  " + passCustomer.lastName;

    let newCustomer: Customer = {
      id: passCustomer.id,
      customerid: passCustomer.customerid,
      firstName: passCustomer.firstName,
      lastName: passCustomer.lastName,
      fullName: passCustomer.firstName + " " + passCustomer.lastName,
      address1: passCustomer.address1,
      address2: passCustomer.address2,
      townCity: passCustomer.townCity,
      postCode: passCustomer.postCode,
      email: passCustomer.email,
      mobile: passCustomer.mobile,
      dob: this.dob,
      venueId: this.VenueID,
      disabled: false,
      bookingid: null
    }

    this.NewBooking.customer = newCustomer;


    this.busyService.idle();
    this.savebooking();

    this.setTab(Sections.Notes);
    
    this.customersResult = null;
    this.searchCriteria = "";
  }

  savebooking()
  {
    this.busyService.busy();
    this.http.post<booking_returndata>(bmxurl + "/savebooking", this.NewBooking).subscribe(response => {
      this.httpResponse = (response as booking_returndata);      

      if(this.httpResponse.succeeded)
      {
        this.busyService.idle();
        this.BookingResponse = this.httpResponse.data
        
        this.NewBooking = this.BookingResponse.bookingObj;

        let NumPeople: number = 0;
        this.NewBooking.resources[0].admissions.forEach(adm => {
          NumPeople += adm.noofpeople;
        });
  
        this.paymentAmount = this.BookingResponse.bookingObj.total;

        if(this.NewBooking.PublicBooking)
        {
          this.validPaymentAmount = this.NewBooking.totalpublicdeposit - this.NewBooking.totalpayments;
        }
        else{
          this.validPaymentAmount = this.NewBooking.totalvenuedeposit - this.NewBooking.totalpayments;
        }
  
        const formatter = new Intl.NumberFormat('en-GB', {
          style: 'currency',
          currency: this.CurrencySymbol});
  
        this.makeABookingHeader = "Make a Booking - Sales Value: " + formatter.format(this.paymentAmount);

        if (this.NewBooking.customer != null)
        {
          this.CustomerHeader = "Customer: " + this.NewBooking.customer.firstName + "  " + this.NewBooking.customer.lastName;
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Error', detail: "No customer found"});
        }

        this.busyService.idle();
        this.setTab(Sections.Notes);

        if (this.SelectedPackage?.earlybirddiscount &&
            this.IsDiscountValid(this.SelectedPackage) &&
            this.SelectedPackage.discountcode &&
            this.NewBooking.totaldiscounts === 0) {
          this.applyEarlyBirdDiscount();
        }

      }
      else
      {
        //this.getAvailability();

        this.messageService.add({severity:'error', summary:'Error', detail: this.httpResponse.messages});
        this.busyService.idle();

        this.returnHome();
      }
    }, error => {
      this.busyService.idle();
      this.messageService.add({severity:'error', summary:'Error', detail: error.message});

      this.returnHome();
    })
  }

  applyEarlyBirdDiscount(): void {
    const dv: cDiscountvalidate = {
      booking: this.NewBooking,
      discountcode: this.SelectedPackage.discountcode
    };

    this.http.post<booking_returndata>(bmxurl + "/DiscountValidate", dv).subscribe(response => {
      this.httpResponse = response;
      if (this.httpResponse.succeeded) {
        this.NewBooking = (this.httpResponse as booking_returndata).data;

        if (this.NewBooking.PublicBooking) {
          this.validPaymentAmount = this.NewBooking.totalpublicdeposit - this.NewBooking.totalpayments;
        } else {
          this.validPaymentAmount = this.NewBooking.totalvenuedeposit - this.NewBooking.totalpayments;
        }

        const formatter = new Intl.NumberFormat('en-GB', { style: 'currency', currency: this.CurrencySymbol });
        this.makeABookingHeader = "Make a Booking - Sales Value: " + formatter.format(this.NewBooking.total);
      }
    });
  }

  showMemberships(data)
  {
    let mshipd = document.getElementById("div-" + data.id);
    mshipd.style.display = mshipd.style.display === "none" ? "" : "none";
  }

  addselectedMember(passMember)
  {
    this.http.get(bmxurl + "/validatemembership/" + this.NewBooking.bookingId + "/" + passMember.salesid + "/" + passMember.membershippin).subscribe(response => {
    this.httpResponse =  (response as any);

    if(this.httpResponse.succeeded)
      {
        this.NewBooking = this.httpResponse.data;

        this.CustomerHeader = "Customer: " +  this.firstName + "  " + this.lastName;

        this.messageService.add({severity:'success', summary:'Success', detail: this.httpResponse.messages});

        if(this.NewBooking.PublicBooking)
        {
          this.paymentAmount = this.NewBooking.totalpublicdeposit;
        }
        else
        {
          this.paymentAmount = this.NewBooking.totalvenuedeposit;
        }

        if (this.NewBooking.customer != null)
        {
          this.CustomerHeader = "Customer: " + this.NewBooking.customer.firstName + "  " + this.NewBooking.customer.lastName;
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Error', detail: "No customer found"});
        }

        this.setTab(Sections.Notes);
        this.busyService.idle();

      }
      else
      {
        this.messageService.add({severity:'error', summary:'Error', detail: this.httpResponse.messages[0]});
        this.busyService.idle();
      }
    });
  }

  addCustomer(){
    //Check Search field for postcode

    if(this.valid_postcode(this.searchCriteria))
    {
      this.postCode = this.searchCriteria
    }
    else if(this.valid_mobile(this.searchCriteria))
    {
      //Check Telephone number
      this.mobile = this.searchCriteria
    }
    else if(this.searchCriteria.includes("@"))
    {
      this.email = this.searchCriteria
    }
    else
    {
      this.lastName = this.searchCriteria
    }


    this.ShowCustomerDetails = true;
    //this.ProvideMinimalPersonalData = "FULL";
  }

  doWalkin(){
    this.customersResult = null;
    this.ProvideMinimalPersonalData = "WALKIN";
    this.lastName = this.searchCriteria;
    this.ShowCustomerDetails = true;
  }

  valid_postcode(postcode) {
    postcode = postcode.replace(/\s/g, "");
    var regex = /^[A-Z]{1,2}[0-9]{1,2} ?[0-9][A-Z]{2}$/i;
    return regex.test(postcode);
  }

  valid_mobile(postcode) {
    postcode = postcode.replace(/\s/g, "");
    var regex = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
    return regex.test(postcode);
  }

  ngAfterViewChecked(): void {
    if (this.pendingScrollToFirstTime) {
      const firstTime = document.querySelector('.times');
      if (firstTime) {
        this.pendingScrollToFirstTime = false;
        firstTime.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }

  ngOnInit(): void {

    //get payment types
    this.PaymentTypes = JSON.parse(localStorage.getItem("PaymentTypes"));

    this.globalService.setSmallScreenMenu(false);

    localStorage.removeItem("screenMemoryBookingss");
    localStorage.removeItem("screenMemoryEvents");

    let userid = localStorage.getItem("SmartUserID");
    
    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        if(getAccess("MAKEABOOKING", user)){
          this.AccessAllowed = true;

          let inputtedDate = "";
          this.route.queryParams
            .subscribe(params => {
              inputtedDate = params.bookingDate + "UTC";
            }
          );
      
          this.BookingPayments = [];
          this.totalPayments = 0;
      
          this.partyroomsVisible = true;
          this.id = this.route.snapshot.paramMap.get('id');

          this.qbook = this.route.snapshot.paramMap.get('qbook');

          this.packages = [];
          this.customerSelectedResources = [];
          this.SelectedResources = [];
      
          this.checked = [];

          this.http.get(bmxurl + "venuesettings/" + this.VenueID).subscribe(response => {
            this.httpResponse = (response as venuesettings_returndata)
            if(this.httpResponse.succeeded)
            {
              this.httpResponse.data.venueSettings.forEach(element => {
                if (element.name == "UseIntervalAvailability") {
                  this.UseIntervalAvailability = element.value;
                }
                if (element.name == "NoAvailabilityMessage") {
                  this.NoAvailabilityMessage = element.value;
                }
              });
            }
            else
            {
              this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to get Venue Settings.'});
            }
          }, error => {
            this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to get Venue Settings.'});
          })
      
          if(this.id == "0")
          {
            if(inputtedDate != undefined && inputtedDate != "" && inputtedDate != "undefined" && inputtedDate != "undefinedUTC")
            {
              this.SelectedDate = this.DatifyString(inputtedDate);
              this.timetobetried = inputtedDate.substring(11, 16);

              inputtedDate = "";
              this.dateSelected = true;
              this.packageSelected = false;
              this.admissionsSelected = false;
              this.doneDate();
            }
            else
            {
              if (this.qbook != "true")
              {
                this.dateSelected = true;
                this.packageSelected = false;
                this.admissionsSelected = false;
                this.setTab(Sections.Date);
              }
              else
              {
                this.SelectedDate = new Date();
                this.doneDate();
                this.setTab(Sections.Package);
              }
            }
          }
          else
          {
            this.http.get(bmxurl + "booking/" + this.VenueID + "/" + this.id).subscribe(response => {
              this.NewBooking = (response as booking_returndata).data;
              if((response as booking_returndata).succeeded)
              {
                this.SelectedDate  = new Date(this.NewBooking.startTime);
              }
              else{
                this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to get Booking.'});
              }
            }, error => {
              this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to get Booking.'});
            })
      
            this.dateSelected = true;
            this.setTab(Sections.Date);
      
            this.dateActive = false;
            this.packageActive = false;
            this.admissionsActive = false;
            this.timeActive = false;
            this.customerActive = false;
            this.paymentActive = false;
            this.extraActive = false;
            this.notesActive = false;
          }
        }

        this.CompletedLoading = true;

      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });

  }

  DatifyString(date: string): Date
  {
    let returnDate = new Date();

    returnDate.setUTCFullYear(Number(date.substring(0, 4)));
    returnDate.setUTCMonth(Number(date.substring(5, 7)) - 1);
    returnDate.setUTCDate(Number(date.substring(8, 10)));
    returnDate.setUTCHours(0);
    returnDate.setUTCMinutes(0);
    returnDate.setUTCSeconds(0);

    return returnDate;
  }

  Selectpopular(){
    //Get Popular Group
    let PopularGroup: cPackagegroups;
    this.packageGroups.forEach(pkgrp => {
      if(pkgrp.packagegroupname == 'Popular')
        PopularGroup = pkgrp;
    });

    this.packages1.forEach(pkg => {
      PopularGroup.packages.forEach(PGPgs => {
        if(PGPgs.packageId == pkg.packageId)
          this.packages.push(pkg)
      });
    });
    
    this.checked[PopularGroup.packagegroupid] = true;
  }

  sumAdmissions(){

    this.doLinkedDiscounts();

    this.doLinkedAdmissions();

    this.maxadmissions = 0;
    this.minadmissions = 0;
    this.totalAdmissions = 0;

    this.SelectedAdmissions.forEach(adm => {
      if(adm.countstowardsmin || adm.countstowardsmin == null)
      {
        this.minadmissions += Number(adm.noofpeople);
        this.totalAdmissions += Number(adm.noofpeople);
      }

    });

    if((this.totalAdmissions > this.SelectedPackage.max && this.SelectedPackage.max > 0) || (this.minadmissions < this.SelectedPackage.min && this.SelectedPackage.min > 0))
    {
      this.totalAdmissionInRange = false;
    }
    else
    {
      this.totalAdmissionInRange = true;
    }
  }

  doLinkedDiscounts()
  {
    this.totalDiscount = 0;

    let totalNumberOfLinkedDiscounts = 0;

    this.SelectedAdmissions.forEach(adm => {

      if(adm.linkeddiscounts != null)
      {
        adm.linkeddiscounts.forEach(ladm => {
          let linkedDis = this.SelectedAdmissions.find(a => a.admissionid == ladm.admissionid);

          if(linkedDis != null)
          {
            if(linkedDis.noofpeople >= ladm.threshold)
            {
              let numberOfPeopleForDiscount = Math.floor(linkedDis.noofpeople / ladm.threshold);

              if(adm.noofpeople < numberOfPeopleForDiscount)
              {
                numberOfPeopleForDiscount = adm.noofpeople;
              }

              this.totalDiscount += Number(adm.price * numberOfPeopleForDiscount) * Number(ladm.percentagediscount / 100);
            }
          }
        });
      }
    });
  }

  doLinkedAdmissions() {
  this.SelectedAdmissions.forEach(adm => {
    if (adm.linkedadmissions && adm.linkedadmissions.length > 0) {
      let totalNumberOfLinked = 0;

      adm.linkedadmissions.forEach(ladm => {
        const matching = this.SelectedAdmissions.find(innerAdm => innerAdm.admissionid === ladm.admissionid);
        if (matching) {
          totalNumberOfLinked += Number(matching.noofpeople);
        }
      });

      if (adm.onlysetmax) {
        adm.max = Number(totalNumberOfLinked);

        if (adm.max < adm.min) {
          adm.max = adm.min;
        }

        if (Number(adm.noofpeople) > adm.max) {
          adm.noofpeople = adm.max;
        }

        adm.fixed = false;
      } else {
        adm.noofpeople = Number(totalNumberOfLinked);
        adm.fixed = true;
      }
    }
  });
}

  // doLinkedAdmissions2()
  // {
  //   let totalNumberOfLinked = 0;

  //   this.SelectedAdmissions.forEach(adm => {

  //     if(adm.linkedadmissions != null && adm.linkedadmissions.length > 0)
  //     {
  //       adm.linkedadmissions.forEach(ladm => {
  //         totalNumberOfLinked = 0;
  //         this.SelectedAdmissions.forEach(innerAdm => {
  //           if(ladm.admissionid == innerAdm.admissionid)
  //           {
  //             totalNumberOfLinked += Number(innerAdm.noofpeople);
  //           }
  //         });
  //       });

  //       if(adm.onlysetmax)
  //       {
  //         adm.max = Number(totalNumberOfLinked);
  //         if (adm.max < adm.min)
  //         {
  //           adm.max = adm.min;
  //         }
  //         if(Number(adm.noofpeople) > Number(totalNumberOfLinked))
  //         {
  //           adm.noofpeople = Number(totalNumberOfLinked);
  //         }
  //         adm.fixed = false;
  //       }
  //       else
  //       {
  //         adm.noofpeople = Number(totalNumberOfLinked);
  //         adm.fixed = true;
  //       }
  //     }
  //   });

  // }

  // doLinkedAdmissions()
  // {
  //   if(this.VenueID == 'ebfc03ad-d3f8-4289-8d65-055c93a7f56d')
  //   {
  //     this.doLinkedAdmissions2();
  //   }
  //   else
  //   {
  //     let totalNumberOfLinked = 0;

  //     this.SelectedAdmissions.forEach(adm => {

  //       let OldNoOfPeople = adm.min;

  //       if(adm.linkedadmissions != null)
  //       {
  //         adm.linkedadmissions.forEach(ladm => {
  //           let linkedAdm = this.SelectedAdmissions.find(a => a.admissionid == ladm.admissionid);

  //           if(linkedAdm != null)
  //           {
  //             totalNumberOfLinked += Number(linkedAdm.noofpeople);
  //           }
  //         });

  //         if(adm.onlysetmax)
  //         {
  //           adm.max = Number(totalNumberOfLinked);
  //           if (adm.max < adm.min)
  //           {
  //             adm.max = adm.min;
  //           }
  //           if(Number(adm.noofpeople) > Number(totalNumberOfLinked))
  //           {
  //             if(Number(OldNoOfPeople) > Number(totalNumberOfLinked))
  //             {
  //               adm.noofpeople = Number(OldNoOfPeople);
  //             }
  //             else
  //             {
  //               adm.noofpeople = Number(totalNumberOfLinked);
  //             }
  //           }
  //           adm.fixed = false;
  //         }
  //         else
  //         {
  //           adm.noofpeople = Number(totalNumberOfLinked);
  //           adm.fixed = true;
  //         }
  //       }
  //     });
  //   }
  // }

  applyCustomer(passCustomer)
  {
    this.ShowCustomerDetails = true;
    this.firstName = passCustomer.firstName;
    this.lastName = passCustomer.lastName;
    this.address1 = passCustomer.address1;
    this.address2 = passCustomer.address2;
    this.town = passCustomer.townCity;
    this.postCode = passCustomer.postCode;
    this.email = passCustomer.email;
    this. mobile = passCustomer.mobile;

    this.customersResult = null;
    this.searchCriteria = "";

  }

  // GetCustomerMemberships(data){
  //   this.http.get(bmxurl + "Customer/Memberships/" + this.VenueID + "/" + data.customerid).subscribe(response => {
  //     this.customerMemberships = ((response as any).data) as membership[];
  //   }, error => {
  //   });
  // }

  searchCustomer(){
    this.http.get(bmxurl + "customer/search/" + this.VenueID + "/" + this.searchCriteria).subscribe(response => {
      this.customersResult = (response as customer[])
      }, error => {
        })

  }

  VCContinue()
  {
    this.showVCWarning = false;
  }

  doneDate()
  {
    this.busyService.busy();
    this.CalendarHeader = "You selected: " + this.SelectedDate.toDateString();
    this.packages = [];

    this.http.get(bmxurl + "PackageGroupList/" + this.VenueID + "/false/" + 
    ('00' + this.SelectedDate.getDate()).slice(-2)+
    ('00' + (Number(this.SelectedDate.getMonth() + 1).toString())).slice(-2)
    +this.SelectedDate.getFullYear().toString().substr(-2)
    ).subscribe(response => {
      this.packageGroups = (response as packagegroups_returndata).data;
      this.busyService.idle();
      
    }, error => {
      this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to get Package Groups.'});
    })

    //Does a current booking exist for this date?
    if(this.NewBooking.bookingId != null)
    {
      // let abandonBooking: any = {
      //   bookingid: this.NewBooking.bookingId,
      //   jwt: null
      // }
      // //Booking Exists, abandon it
      // this.http.post(bmxurl + "abandonbooking/", abandonBooking).subscribe(response => {
      //   this.NewBooking = (response as booking_returndata).data;

      // }, error => {
      //   this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to abandon booking.'});
      // });

      this.SelectedPackage = null;
      this.SelectedAdmissions = [];
      this.SelectedResources = [];
      this.customerSelectedResources = [];
      
      this.PackageHeader = "Select a Package";
      this.CalendarHeader = "Select a Date";
      this.AdmissionHeader = "Select your Admissions";
      this.TimeHeader = "Select a Time";
      this.CustomerHeader = "Create a Customer";
      this.PaymentHeader = "Add a Payment";
      this.ExtrasHeader = "Select Extras";

      this.NewBooking.id = null;
      this.NewBooking.bookingId = null;

    }

    let BookingDateYear = this.SelectedDate.getFullYear().toString().substr(-2);
    let BookingDateMonth = ('00' + (this.SelectedDate.getMonth() + 1)).slice(-2);
    let BookingDateDay = ('00' + this.SelectedDate.getDate()).slice(-2);

    let dateChosen = BookingDateDay + BookingDateMonth + BookingDateYear;

    this.http.get<venueclosings_returndata>(bmxurl + "/VenueClosingList/" + this.VenueID + "/false/" + dateChosen).subscribe(response => {
      this.venueClosings = (response as venueclosings_returndata).data;

      if(this.venueClosings != null)
      {
        this.venueClosings.forEach(element => {
            if(element.venueMessage != null && element.venueMessage != "")
            {
              this.VCWarningMessage += element.venueMessage + "<BR>";
              this.showVCWarning = true;
            }
        });
      }
      else
      {
        this.showVCWarning = false;
      }
    });

    this.AbandonBooking();
    this.checked = [];
    
    this.setTab(Sections.Package);
  }

  toggleMore(inDiv)
  {
    let collapsedDiv = document.getElementById(inDiv + "collapse") as HTMLElement;
    let expandeddDiv = document.getElementById(inDiv + "expanded") as HTMLElement;
    let toggleButton = document.getElementById(inDiv + "toggleButton") as HTMLButtonElement;

    if(collapsedDiv.hidden == true)
    {
      collapsedDiv.hidden = false
      collapsedDiv.style.display = "false";
    }
    else
    {
      collapsedDiv.hidden = true
      collapsedDiv.style.display = "true";
    }

    if(expandeddDiv.hidden == true)
    {
      expandeddDiv.hidden = false
      expandeddDiv.style.display = "false";
    }
    else
    {
      expandeddDiv.hidden = true
      expandeddDiv.style.display = "true";
    }

    if(toggleButton.value == "Show More...")
    {
      toggleButton.value = "Show Less..."
      toggleButton.textContent = "Show Less..."
    }
    else
    {
      toggleButton.value = "Show More..."
      toggleButton.textContent = "Show More..."
    }
  }

  donePackage(inPackage)
  {
    this.SelectedPackage = inPackage;

    if(this.SelectedPackage.questionnaire != null)
    {
      for(var i = 0; i < this.SelectedPackage.questionnaire.bookingquestions.length; i++)
      {
        this.mustanswerallergies[i] = true;
        this.mustanswerbirthdays[i] = true;
        this.mustanswernumber[i] = true;  
        this.mustanswerfreetext[i] = true;
        this.mustanswermultichoicesingleanswer[i] = true;
        this.mustanswermultichoicemultianswer[i] = true;
        this.mustanswerdate[i] = true;
        this.allergyAnswer[i] = true;  
        this.mustanswerage[i] = true;
      }
    }

    this.timeoutTime = this.SelectedPackage.bookingtimeout;

    this.customerSelectedResources = [];
    this.SelectedResources = [];
    
    this.PackageHeader = "You selected: " + this.SelectedPackage.name;

    this.SelectedAdmissions = [];

    this.SelectedPackage.admissions.forEach(adm => {
      var newAdm: admission = {
        id: adm.id,
        admissionid: adm.admissionid,
        classid: adm.classid,
        noofpeople: adm.min,
        price: adm.price,
        name: adm.name,
        index: adm.index,
        max: adm.max,
        min: adm.min,
        venueid: adm.venueid,
        disabled: adm.disabled,
        admissionClass: adm.admissionClass,
        bookingwizardtext: adm.bookingwizardtext,
        fixedPrice: adm.fixedPrice,
        participant: adm.participant,
        mustinclude: adm.mustinclude,
        eventtickettype: adm.eventtickettype,
        counter: [],
        uselinkeddiscounts: adm.uselinkeddiscounts,
        linkedadmissions: adm.linkedadmissions,
        linkeddiscounts: adm.linkeddiscounts,
        uselinkedadmissions: adm.uselinkedadmissions,
        maxlinkeddiscounts: adm.maxlinkeddiscounts,
        maxlinkedadmissions:adm.maxlinkedadmissions,
        countstowardsmax: adm.countstowardsmax,
        countstowardsmin: adm.countstowardsmin,
        message: adm.message,
        fixed: adm.fixed,
        onlysetmax: adm.onlysetmax,
        //A repeatable package's prices for its Dates and Times buttons, which are worked out from
        //these copies - leave them off and every choice is offered at nothing.
        allsessionsprice: adm.allsessionsprice,
        persessionprice: adm.persessionprice
    }

    this.doLinkedAdmissions();


    this.SelectedAdmissions.push(newAdm);
    });

    this.SelectedPackage.resources.forEach(res => {

      let selectableinnerresources: any[] = [];
      if(res.selectableresources != null && res.selectableresources.length > 0)
      {
        res.selectableresources.forEach(innerRes => {
          if(innerRes.disabled != true)
          {
            selectableinnerresources.push(innerRes);
          }
        });
      }

      var newRes: cResource = {
        groupname: uuidv4(),
        id: res.id,
        resourceId: res.resourceId,   
        name: res.name,
        useClasses: res.useClasses,
        exclusive: res.exclusive,
        eventid: res.eventid,
        concurrentUses: res.concurrentUses,
        maxConcurrent: res.maxConcurrent,
        disabled: res.disabled,
        venueId: res.venueId,
        colour: res.colour,
        orderindex: res.orderindex,
        length: res.length,
        classes:  res.classes,
        showonbooking:res.showonbooking,
        resources: selectableinnerresources,
        isresourcecontainer: res.isresourcecontainer,
        isconstructed: res.isconstructed,
        resourcegroupname: res.resourcegroupname,
        price: res.price,
        fixedprice: res.fixedprice,
        tags: res.tags,
        resourcegroup: res.resourcegroup,
        selectionmode: res.selectionmode,
        selectableresources: res.selectableresources,
        startwhen: res.startwhen,
        startTimeOffset: res.startTimeOffset,
        optional: res.optional,
        quantityselector: res.quantityselector,
        quantity: res.quantity,
        mode: res.mode,
        inline: res.inline,
        ignore: res.ignore,
        admissions: res.admissions,
        inProgress: res.inProgress,
        originatingid: res.originatingid,
        wasoptional: res.wasoptional,
        wasselected: res.wasselected,
        isupgrade: res.isupgrade,
        packageupgradeid: res.packageupgradeid,
        showinitinerary: res.showinitinerary,
        showondaysheet: res.showondaysheet,
        cansplit: res.cansplit
    }

    this.SelectedResources.push(newRes);
    });

    //Get day for selected date.
    let day = this.SelectedDate.getDay();

    this.packageExtras = [];

    if(this.SelectedPackage.extras != null)
    {
      switch (day)
      {
        case 0:
          this.packageExtras = this.SelectedPackage.extras.filter(obj => obj.sunday == true);
          break;
        case 1:
          this.packageExtras = this.SelectedPackage.extras.filter(obj => obj.monday == true);
          break;
        case 2:
          this.packageExtras = this.SelectedPackage.extras.filter(obj => obj.tuesday == true);
          break;
        case 3:
          this.packageExtras = this.SelectedPackage.extras.filter(obj => obj.wednesday == true);
          break;
        case 4:
          this.packageExtras = this.SelectedPackage.extras.filter(obj => obj.thursday == true);
          break;
        case 5:
          this.packageExtras = this.SelectedPackage.extras.filter(obj => obj.friday == true);
          break;
        case 6:
          this.packageExtras = this.SelectedPackage.extras.filter(obj => obj.saturday == true);
          break;
        default:
          this.packageExtras = this.SelectedPackage.extras.filter(obj => obj.sunday == true);
          break;
      }
    }

    this.packageExtras = this.packageExtras.filter(ext => ext.disabled == false)

    this.packageExtras.forEach(ext => {
      ext.qty = 0;
     });

     if(this.packageExtras.length > 0)
        this.PackageHasExtras = true;

    this.SelectedResources.forEach(element => {
      if(element.mode == "COMPLEX")
      {
        if(element.selectionmode == "SYSTEMANY" || element.selectionmode == "SYSTEMLIST" || element.selectionmode == "") 
        {
          this.includesComplexResources = false;
        }
        else{
          this.includesComplexResources = true;
        }
        
      }
      else{
        this.includesComplexResources = false;
      }
      if(element.selectionmode != "SYSTEMANY" && element.selectionmode != "SYSTEMLIST")
      { 
        this.systemChoosesAllResources = false;
      }
      else
      {
        this.systemChoosesAllResources = true;
      }

      if(element.optional)
      {
        this.includesOptionalResources = true;
      }
    });

    if(!this.includesComplexResources || this.systemChoosesAllResources)
    {
      this.customerSelectedResources = this.SelectedPackage.resources;
    }

    if(this.includesComplexResources)
    {
      this.partyroomsVisible = true;
    }
    else
    {
      this.partyroomsVisible = false;
    }

    this.sumAdmissions();
    this.AbandonBooking();
    this.setTab(Sections.Admissions);

    if(this.SelectedPackage.warning != null)
      {
        if(this.SelectedPackage.warning.venuemessage != null && this.SelectedPackage.warning.venuemessage != "")
        {
          this.showWarning = true;
          this.WarningMessage = this.SelectedPackage.warning.venuemessage;
        }
      }
  }

  doneAdmissions()
  {

   this.busyService.busy();

   let dropOut = false;
   let HasMustIncludes = false;
   let HasSelectedMustIncludes = false;

   this.SelectedAdmissions.forEach(element => {
       if(element.mustinclude)
       {
        HasMustIncludes = true;
       }
       if(element.mustinclude && element.noofpeople > 0)
       {
        HasSelectedMustIncludes = true;
       }
   });

   if(HasMustIncludes && !HasSelectedMustIncludes)
    {
      this.MustIncludePass = false;
      this.messageService.add({severity:'warn', summary:'Must include', detail:'You must include at least 1 of the admissions with an asterix'});
      this.busyService.idle(); 
    }
    else
    {
      this.MustIncludePass = true;
    }

    if(this.totalAdmissionInRange)
    {
      if(this.MustIncludePass)
      {
        let AdmissionsList: string = "";

        this.SelectedAdmissions.forEach(adm => {
          if(adm.noofpeople > 0)
            AdmissionsList += adm.noofpeople + " x " +  adm.name + ", ";
        });

        if(AdmissionsList.length > 2)
        AdmissionsList = AdmissionsList.substring(0, AdmissionsList.length - 2);

        this.AdmissionHeader = "You selected: " + AdmissionsList;

        this.AbandonBooking();

        
        if(this.SelectedPackage.questionnaire != null)
          {
            this.SelectedPackage.questionnaire.bookingquestions.forEach(question => {
      
              let bQuestions = [];
              if(this.isPersonListQuestion(question.questiontype) && !question.linkedtoparticipants)
              {
                //The rows belong to this question alone. They used to be poured into one
                //array shared by every birthday question, so a second question overwrote the
                //first and both then showed the same people.
                bQuestions.push({
                  index: 0, 
                  id: uuidv4(), 
                  name: "", 
                  age: 0, 
                  birthdate: "",
                  gender: "NOT STATED",
                  interests: "",
                  showage: question.showage,
                  showdob: question.showdob,
                  showgender: question.showgender,
                  showinterests: question.showinterests,
                  dobday: question.dobday,
                  dobmonth: question.dobmonth,
                  dobyear: question.dobyear
                });
              }
              else if(this.isPersonListQuestion(question.questiontype) && question.linkedtoparticipants)
              {
                let totalAllowed = 0;
  
                this.SelectedAdmissions.forEach(admission => {
                  if (admission.participant)
                  {
                    totalAllowed += admission.noofpeople;
                  }
                });
  
                let index = 0;
  
                for(var i = 0; i < totalAllowed; i++){
                  bQuestions.push({
                    index: index, 
                    id: uuidv4(), 
                    name: "", 
                    age: 0, 
                    birthdate: new Date(),
                    gender: "NOT STATED",
                    interests: "",
                    showage: question.showage,
                    showdob: question.showdob,
                    showgender: question.showgender,
                    showinterests: question.showinterests,
                    dobday: question.dobday,
                    dobmonth: question.dobmonth,
                    dobyear: question.dobyear
                  });
  
                  index++;
                }
              }


              question.answers = {
                bookingid: "",
                bookingquestionnaireid:  null,
                bookingquestionid: question.bookingquestionid,
                birthdayanswers: bQuestions,
                allergyanswer: {
                  id: null,
                  allergypresent: null,
                  allergytext: ""
                },
                freetextanswer: "",
                numberanswer: null,
                dateanswer:  null,
                multichoicesingleanswer: {
                  id: null,
                  listitemtext: ""
                },
                multichoicemultianswer: []
              }
            });
        }
  

        //Party room choices are made against one date and time, so they aren't offered on a
        //repeatable package yet.
        if(!this.isRepeatable && ((this.includesComplexResources && !this.systemChoosesAllResources) || this.includesOptionalResources))
        {
          this.busyService.idle();  
          this.setTab(Sections.Partyroom);
        }
        else{
          this.setTab(Sections.Time);

          if(this.isRepeatable)
          {
            this.loadSeriesAvailability();
          }
          else
          {
            this.getAvailability();
          }
        }
      }
    }
    else
    {
      this.busyService.idle();  

      if (this.totalAdmissions > this.SelectedPackage.max)
      {
        this.messageService.add({severity:'warn', summary:'Admissions', detail:'There are too many admissions, please reduce the admissions to ' + this.SelectedPackage.max + ' or less.'});
      }
      if (this.totalAdmissions < this.SelectedPackage.min)
      {
        this.messageService.add({severity:'warn', summary:'Admissions', detail:'There are too few admissions, please increase the admissions to ' + this.SelectedPackage.min + ' or more not including any excluded admissions'});
      }
    }

    this.linkedAdmissionMessageShown = false;
  }

  Checkfortoday()
  {
    var today = new Date();
    var selected = new Date(this.SelectedDate);
    return today.getDate() == selected.getDate() && today.getMonth() == selected.getMonth() && today.getFullYear() == selected.getFullYear();
  }

  bookSlot(timeslot: AvailableTimes)
  {
    this.globalTimeSlot = timeslot;

    this.restartTimer(this.SelectedPackage.bookingtimeout);
    this.showTimer = true;

    this.PBWStartTime = new Date();

    if(timeslot != null)
    {
      this.busyService.busy();
      this.TimeHeader = "You selected: " + new Date(timeslot.time).getUTCHours().toString().padStart(2, '0') + ":" + new Date(timeslot.time).getUTCMinutes().toString().padStart(2, '0');

      var instanceID: any = "BMP1"
      var id:any = this.VenueID;
      var todaysDate: Date = new Date(timeslot.time);
      var venueDate: any =  id + "_" + timeslot.time.toString().substring(0, 10).replace(/-/g, "");

      this.SelectedPackage.resources.forEach(adm => {
        adm.admissions = this.SelectedAdmissions;
      });

      let totalNoOfPeople: number = 0;
      this.NewBooking.bookingIdHR = null;
      this.NewBooking.venuedate = venueDate;
      this.NewBooking.packageId = this.SelectedPackage.packageId;
      this.NewBooking.guests =  totalNoOfPeople;
      this.NewBooking.startTime = timeslot.time;
      this.NewBooking.PackageName = this.SelectedPackage.name;
      this.NewBooking.venueId = this.VenueID;
      this.NewBooking.payments = null;
      this.NewBooking.customer = null;
      this.NewBooking.resources = timeslot.resources; //this.SelectedPackage.resources;
      this.NewBooking.Disabled = false;
      this.NewBooking.outstanding = 0;
      this.NewBooking.name = "";
      this.NewBooking.inProgress = true;
      this.NewBooking.availabilityreq = this.AvailabilityReq;
      this.NewBooking.initialbooking = true;
      this.NewBooking.salestype = 0;
      this.NewBooking.currency = this.CurrencySymbol;

      if(this.SelectedPackage.bookingtimeout == 0)
      {
        this.NewBooking.bookingtimeout = 300;
      }
      else
      {
        this.NewBooking.bookingtimeout = this.SelectedPackage.bookingtimeout;
      }

      this.NewBooking.resources.forEach(element => {
        element.inProgress = true;
      });

      this.http.post<booking_returndata>(bmxurl + "/savebooking", this.NewBooking).subscribe(response => {
        this.httpResponse = (response as booking_returndata);      

        if(this.httpResponse.succeeded)
        {
          this.BookingResponse = this.httpResponse.data
          
          this.NewBooking = this.BookingResponse.bookingObj;

          let NumPeople: number = 0;
          this.NewBooking.resources[0].admissions.forEach(adm => {
            NumPeople += adm.noofpeople;
          });
    
          this.paymentAmount = this.BookingResponse.bookingObj.total;

          if(this.NewBooking.PublicBooking)
          {
            this.validPaymentAmount = this.NewBooking.totalpublicdeposit - this.NewBooking.totalpayments;
          }
          else{
            this.validPaymentAmount = this.NewBooking.totalvenuedeposit - this.NewBooking.totalpayments;
          }
    
          const formatter = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: this.CurrencySymbol});
    
          this.makeABookingHeader = "Make a Booking - Sales Value: " + formatter.format(this.paymentAmount);
          
          if(this.SelectedPackage.packageupgrades != null && this.SelectedPackage.packageupgrades.length > 0)
          {
            let timedate = this.SelectedDate.getFullYear() + "-" +  (this.SelectedDate.getMonth() + 1).toString().padStart(2, '0') + "-" +  this.SelectedDate.getDate().toString().padStart(2, '0') + "T"+ timeslot.timeString + ":00.000Z"

            this.getUpgradeAvailability(this.SelectedPackage.packageupgrades, timedate);
          }
          else
          {
            if(this.SelectedPackage.packageabupgrades != null && this.SelectedPackage.packageabupgrades.length > 0)
            {
              let timedate = this.SelectedDate.getFullYear() + "-" +  (this.SelectedDate.getMonth() + 1).toString().padStart(2, '0') + "-" +  this.SelectedDate.getDate().toString().padStart(2, '0') + "T"+ timeslot.timeString + ":00.000Z"

              this.getOptionalUpgradeAvailability(this.SelectedPackage.packageabupgrades, timedate);
            }
            else
            {
              if(this.packageExtras.length == 0 && this.SelectedPackage.questionnaire == null)
              {
                this.setTab(Sections.Customer);
              }
              else if(this.SelectedPackage.questionnaire != null)
              {
                this.setTab(Sections.BookingQuestions);
              }
              else
              {
                this.setTab(Sections.Extras);
              }
            }

            this.busyService.idle();
            this.upgradesComplete = true;
          }
        }
        else
        {
          this.getAvailability();
          
          this.messageService.add({severity:'error', summary:'Error', detail: this.httpResponse.messages});
          this.busyService.idle();
        }
      }, error => {
          this.busyService.idle();
        this.messageService.add({severity:'error', summary:'Error', detail: error.message});
      })
    }
    else
    {
      this.showTimer = false;  
    }
  }

  // getOptionalUpgradeQuantities(pu)
  // {
  //   let NumberList: any[] = [];
  //   let Numbers = {}
  //   for(var i = 0; i <= pu.quantityremaining; i++)
  //   {
  //     Numbers = { "name": i.toString(), value: i };
  //     NumberList.push(Numbers);
  //   }
  //   return NumberList;
  // }

  skipUpgrade()
  {
    if(this.SelectedPackage.packageabupgrades != null && this.SelectedPackage.packageabupgrades.length > 0)
    {
      let timedate = this.SelectedDate.getFullYear() + "-" +  (this.SelectedDate.getMonth() + 1).toString().padStart(2, '0') + "-" +  this.SelectedDate.getDate().toString().padStart(2, '0') + "T"+ this.globalTimeSlot.timeString + ":00.000Z"

      this.getOptionalUpgradeAvailability(this.SelectedPackage.packageabupgrades, timedate);

      this.setTab(Sections.OptionalUpgrades);
    }
    else if(this.packageExtras.length == 0 && this.SelectedPackage.questionnaire == null)
    {
      this.setTab(Sections.Customer);
    }
    else if(this.SelectedPackage.questionnaire != null)
    {
      this.setTab(Sections.BookingQuestions);
    }
    else
    {
      this.setTab(Sections.Extras);
    }

    this.busyService.idle();
  }

  doneUpgrade(SelectedUpgrade){

    //this.busyService.busy();

    SelectedUpgrade.upgrade.resources.forEach(pu => {
      pu.isupgrade = true;
      pu.packageupgradeid = SelectedUpgrade.packageupgradeid;
      this.NewBooking.resources.push(pu);
    });

    this.NewBooking.initialbooking = false;
    
    this.http.put<booking_returndata>(bmxurl + "/savebooking", this.NewBooking).subscribe(response => {
      this.httpResponse = (response as booking_returndata);     

      this.BookingResponse = this.httpResponse.data

        this.NewBooking = this.BookingResponse.bookingObj;

        this.validPaymentAmount = this.NewBooking.outstanding;
  
        this.paymentAmount = this.BookingResponse.bookingObj.total;
        let NumPeople: number = 0;
        this.NewBooking.resources[0].admissions.forEach(adm => {
          NumPeople += adm.noofpeople;
        });
  
        this.paymentAmount = this.BookingResponse.bookingObj.total;
        //this.OutstandingBalance = this.BookingResponse.bookingObj.outstanding;
        const formatter = new Intl.NumberFormat('en-GB', {
          style: 'currency',
          currency: this.CurrencySymbol});
  
        this.startTimes = null;
        this.startTimesFiltered = null;

        if(this.SelectedPackage.packageabupgrades != null && this.SelectedPackage.packageabupgrades.length > 0)
        {
          if(this.SelectedPackage.packageabupgrades != null && this.SelectedPackage.packageabupgrades.length > 0)
          {
            let timedate = this.SelectedDate.getFullYear() + "-" +  (this.SelectedDate.getMonth() + 1).toString().padStart(2, '0') + "-" +  this.SelectedDate.getDate().toString().padStart(2, '0') + "T"+ this.globalTimeSlot.timeString + ":00.000Z"

            this.getOptionalUpgradeAvailability(this.SelectedPackage.packageabupgrades, timedate);
          }
          
          this.setTab(Sections.OptionalUpgrades);
        }
        else if(this.packageExtras.length == 0 && this.SelectedPackage.questionnaire == null)
        {
          this.setTab(Sections.Customer);
        }
        else if(this.SelectedPackage.questionnaire != null)
        {
          this.setTab(Sections.BookingQuestions);
        }
        else
        {
          this.setTab(Sections.Extras);
        }

        this.UpgradeHeader = "You selected: " + SelectedUpgrade.upgrade.name;

        this.busyService.idle();

    }, error => {
      this.busyService.idle();
    })

  }

  doneOptionalUpgrade(){

    this.availablePackageOptionalUpgrades.forEach(pu => {
      if(pu.quantity > 0)
      {
        pu.upgrade.resources.forEach(res => {
          res.isupgrade = true;
          res.packageupgradeid = pu.packageupgradeid;
          res.quantity = pu.quantity;
          this.NewBooking.resources.push(res);
        });
      }
    });

    this.NewBooking.initialbooking = false;
    
    this.http.put<booking_returndata>(bmxurl + "/savebooking", this.NewBooking).subscribe(response => {
      this.httpResponse = (response as booking_returndata);     

      if(this.httpResponse.succeeded)
      {
        this.BookingResponse = this.httpResponse.data

        this.NewBooking = this.BookingResponse.bookingObj;

        this.validPaymentAmount = this.NewBooking.outstanding;

        this.paymentAmount = this.BookingResponse.bookingObj.total;
        let NumPeople: number = 0;
        this.NewBooking.resources[0].admissions.forEach(adm => {
          NumPeople += adm.noofpeople;
        });

        this.paymentAmount = this.BookingResponse.bookingObj.total;

        const formatter = new Intl.NumberFormat('en-GB', {
          style: 'currency',
          currency: this.CurrencySymbol});

        this.startTimes = null;
        this.startTimesFiltered = null;

        if(this.packageExtras.length == 0 && this.SelectedPackage.questionnaire == null)
        {
          this.setTab(Sections.Customer);
        }
        else if(this.SelectedPackage.questionnaire != null)
        {
          this.setTab(Sections.BookingQuestions);
        }
        else
        {
          this.setTab(Sections.Extras);
        }

        this.OptionalUpgradeHeader = "You selected: " + this.availablePackageOptionalUpgrades.map(upgrade => upgrade.name).join(", ");
      }
      else
      {
          this.messageService.add({severity:'error', summary:'Error', detail: this.httpResponse.messages});
          this.busyService.idle();
      }

      this.busyService.idle();

    }, error => {
      this.busyService.idle();
    })

  }

  skipOptionalUpgrade()
  {
    if(this.packageExtras.length == 0 && this.SelectedPackage.questionnaire == null)
      {
        this.setTab(Sections.Customer);
      }
      else if(this.SelectedPackage.questionnaire != null)
      {
        this.setTab(Sections.BookingQuestions);
      }
      else
      {
        this.setTab(Sections.Extras);
      }

      this.busyService.idle();
  }

  removeDiscount()
  {
    this.busyService.busy();

    this.NewBooking.discounts = null;
    this.NewBooking.salestype = 0;

    this.http.put<booking_returndata>(bmxurl + "/savebooking", this.NewBooking).subscribe(response => {
      this.httpResponse = (response as booking_returndata);     

      this.BookingResponse = this.httpResponse.data

        this.NewBooking = this.BookingResponse.bookingObj;

        this.validPaymentAmount = this.NewBooking.outstanding;
  
        this.paymentAmount = this.BookingResponse.bookingObj.total;
        let NumPeople: number = 0;
        this.NewBooking.resources[0].admissions.forEach(adm => {
          NumPeople += adm.noofpeople;
        });
  
        this.paymentAmount = this.BookingResponse.bookingObj.total;
        //this.OutstandingBalance = this.BookingResponse.bookingObj.outstanding;
        const formatter = new Intl.NumberFormat('en-GB', {
          style: 'currency',
          currency: this.CurrencySymbol});
  
        this.startTimes = null;
        this.startTimesFiltered = null;
  
        this.messageService.add({ severity: 'success', summary: 'Discount Removed', detail: 'Your discount has been removed' });

        this.busyService.idle();

    }, error => {
      this.busyService.idle();
    })
  }

  doneExtras()
  {
    this.allQuestionsValid = true;

    this.packageExtras.forEach(element => {
      if(element.question != null)
      {
        if((element.question != "" && element.qty > 0) && (element.answer == null || element.answer == "")) 
        {
          this.allQuestionsValid = false;
        }
      }
      if (element.qty == 0)
      {
        element.answer = "";
      }
    });

    if(this.allQuestionsValid)
    {
      this.ExtrasHeader = "You selected: ";

      let cost: number = 0;

      this.packageExtras.forEach(element => {
        if (element.qty == null)
          element.qty = 0;
        
        if(element.qty > 0)
        {
          this.ExtrasHeader += element.name + " x " + element.qty + ", ";
          this.bookingExtras += element.name + " x " + element.qty + ", ";
          cost += element.qty * element.price;
        }
      });

      if(this.ExtrasHeader.length > 14)
      {
        this.ExtrasHeader = this.ExtrasHeader.substring(0, this.ExtrasHeader.length - 2);
      }
      else
      {
        this.ExtrasHeader = "You selected: No Extras";
      }
      this.NewBooking.extras = this.packageExtras;
      this.NewBooking.salestype = 0;
      
      //------------

      this.http.post<booking_returndata>(bmxurl + "/BookingExtra", this.NewBooking).subscribe(response => {
        this.httpResponse = (response as booking_returndata);      

        if(this.httpResponse.succeeded)
        {
          this.BookingResponse = this.httpResponse.data
          
          this.NewBooking = this.BookingResponse;

          const formatter = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: this.CurrencySymbol});

          this.paymentAmount = this.BookingResponse.total;
          this.makeABookingHeader = "Make a Booking - Sales Value: " + formatter.format(this.paymentAmount);
          this.bookingExtras = this.bookingExtras.substring(0, this.bookingExtras.length - 2);

          this.setTab(Sections.Customer);
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Error', detail: this.httpResponse.messages});
          this.busyService.idle();
          
        }
      }, error => {
          this.messageService.add({severity:'error', summary:'Error', detail: error.message});
      })
    }
  }

  doneCustomer()
  {
    this.CustomerAllValid = true;

    if(this.ProvideMinimalPersonalData == "WALKIN")
    {
      if (this.lastName == "" || this.lastName == undefined || this.lastName == null) {
        this.CustomerAllValid = false;
        this.lastNameValid = false;
      }
      else {
        this.lastNameValid = true;
      }
    }
    else if(this.ProvideMinimalPersonalData)
    {
      if (this.firstName == "" || this.firstName == undefined || this.firstName == null) {
        this.CustomerAllValid = false;
        this.firstNameValid = false;
      }
      else {
        this.firstNameValid = true;
      }

      if (this.lastName == "") {
        this.CustomerAllValid = false;
        this.lastNameValid = false;
      }
      else {
        this.lastNameValid = true;
      }

      if (this.email == "") {
        if(this.ProvideMinimalPersonalData == "FULL" || this.ProvideMinimalPersonalData == "LIMITED")
        {
          this.CustomerAllValid = false;
          this.EmailValid = false;
        }
        else
        {
          this.EmailValid = true;
        }
      }
      else {
        this.EmailValid = true;
      }

      if (this.mobile == "") {
        if(this.ProvideMinimalPersonalData == "FULL" || this.ProvideMinimalPersonalData == "LIMITED")
        {
          this.CustomerAllValid = false;
          this.MobileValid = false;
        }
        else
        {
          this.MobileValid = true;
        }
      }
      else {
        this.MobileValid = true;
      }
    }
    else
    {
      if (this.firstName == "") {
        this.CustomerAllValid = false;
        this.firstNameValid = false;
      }
      else {
        this.firstNameValid = true;
      }

      if (this.lastName == "") {
        this.CustomerAllValid = false;
        this.lastNameValid = false;
      }
      else {
        this.lastNameValid = true;
      }

      if (this.address1 == "") {
        this.CustomerAllValid = false;
        this.Address1Valid = false;
      }
      else {
        this.Address1Valid = true;
      }

      if (this.town == "") {
        this.CustomerAllValid = false;
        this.TownValid = false;
      }
      else {
        this.TownValid = true;
      }

      if (this.postCode == "") {
        this.CustomerAllValid = false;
        this.PostCodeValid = false;
      }
      else {
        this.PostCodeValid = true;
      }

      if (this.email == "") {
        this.CustomerAllValid = false;
        this.EmailValid = false;
      }
      else {
        this.EmailValid = true;
      }

      if (this.mobile == "") {
        this.CustomerAllValid = false;
        this.MobileValid = false;
      }
      else {
        this.MobileValid = true;
      }
    }


    //Check for valid email and mobile

    if (this.email != "") {
      if (!this.validateEmail(this.email)) {
        this.CustomerAllValid = false;
        this.EmailFormatValid = false;
      }
      else {
        this.EmailFormatValid = true;
      }
    }

    if(this.mobile != ""){
      if (!this.validateMobile(this.mobile)) {
        this.CustomerAllValid = false;
        this.MobileFormatValid = false;
      }
      else {
        this.MobileFormatValid = true;
      }
    }

    if(this.CustomerAllValid == true)
    {
      this.CustomerHeader = "Customer: " + this.firstName + "  " + this.lastName;

      let newCustomer: Customer = {
        id: null,
        customerid: null,
        firstName: this.firstName,
        lastName: this.lastName,
        fullName: this.firstName + " " + this.lastName,
        address1: this.address1,
        address2: this.address2,
        townCity: this.town,
        postCode: this.postCode,
        email: this.email,
        mobile: this.mobile,
        dob: this.dob,
        venueId: this.VenueID,
        disabled: false,
        bookingid: null
      }

      this.NewBooking.customer = newCustomer;

      this.busyService.busy();
      this.savebooking();
      
      this.setTab(Sections.Notes);
    }
  }

  //Finishes a booking that needs no payment now. DoSummary on its own only draws the summary -
  //the booking stayed marked in progress on the server, which is what the daysheet stripes and
  //what abandoned bookings are cleared on. Posted to /Payment with no payment attached, the same
  //way sending a payment link finishes a booking without taking money. The payments sent to
  ///Payment are only new ones to add, so sending none leaves any already taken alone.
  private completeWithoutPayment() {
    this.busyService.busy();

    const previousPayments = this.NewBooking.payments;

    this.NewBooking.payments = null;
    this.NewBooking.inProgress = false;
    this.stampSeries();

    this.http.post<booking_returndata>(bmxurl + "/Payment", this.NewBooking).subscribe(response => {
      this.busyService.idle();

      if(response.succeeded == true)
      {
        this.NewBooking = response.data;
        this.BookingResponse = response.data;
        this.BookingPayments = response.data.payments ?? [];

        //No money is being taken, but the other dates still have to be completed or they are
        //cleared away as abandoned bookings.
        this.finishSeriesSiblings(null, null, null, null, () => this.DoSummary(response.data));
      }
      else
      {
        this.failedToComplete(previousPayments, (response as any).messages?.[0]);
      }
    }, error => {
      this.busyService.idle();
      this.failedToComplete(previousPayments, error?.message);
    });
  }

  //Puts the booking back as it was and leaves staff on the payment page, where they can defer or
  //take a payment instead.
  private failedToComplete(previousPayments: any, reason: string) {
    this.NewBooking.payments = previousPayments;
    this.NewBooking.inProgress = true;

    this.messageService.add({severity:'error', summary:'Booking not completed', detail: 'The booking could not be completed' + (reason ? ': ' + reason : '.')});
    this.setTab(Sections.Payment);
  }

  doneNotes(){
    //A series gives every other date the customer, extras, answers and notes set up on its first
    //date before payment, so each date is a complete booking.
    if(this.isSeriesBooking)
    {
      //Fetched again once every date has its extras, which re-price it, so payment starts from what
      //the series is really worth.
      this.syncSeriesBookings(() => this.loadSeriesRecord(() => this.saveSeriesNotes(() => this.continueDoneNotes())));
      return;
    }

    this.continueDoneNotes();
  }

  private continueDoneNotes(){
    // Do deposit.
    //this.CalcDeposit(this.BookingResponse.bookingObj.totaladmission - this.DiscountTakenOff);

    //this.NewBooking.totalvenuedeposit = this.BookingResponse.bookingObj.totalvenuedeposit;
    //this.NewBooking.totalpublicdeposit  = this.BookingResponse.bookingObj.totalpublicdeposit ;

    if(this.NewBooking.PublicBooking)
    {
      this.validPaymentAmount = this.NewBooking.totalpublicdeposit - this.NewBooking.totalpayments;
    }
    else{
      this.validPaymentAmount = this.NewBooking.totalvenuedeposit - this.NewBooking.totalpayments;
    }

    //For a series, what's due is every date's deposit, not just the first date's.
    this.refreshSeriesTotals();
    this.stampSeries();

    //No deposit is due - the deposit is zero, or payments already made cover it - so there is
    //nothing for the payment page to take, and the booking is finished and shown as its summary.
    //Payment can still be taken later from the booking itself. An unknown deposit (not a number)
    //still goes to the payment page rather than being skipped.
    const noDepositDue = this.validPaymentAmount != null && !isNaN(this.validPaymentAmount) && this.validPaymentAmount <= 0;

    //A series goes to payment whenever the series still owes anything, deposit or not, so staff
    //always get the chance to take money for it. Only a series with nothing outstanding skips it.
    if(this.isSeriesBooking)
    {
      const seriesOwed = this.seriesOutstanding();

      if(seriesOwed <= 0)
      {
        this.completeWithoutPayment();
        return;
      }

      //No deposit is due, so the box offers what is owed instead of nothing.
      if(noDepositDue)
      {
        this.validPaymentAmount = seriesOwed;
      }

      this.setTab(Sections.Payment);
      return;
    }

    if(noDepositDue || this.NewBooking.outstanding <= 0)
    {
      this.completeWithoutPayment();
      return;
    }

    this.setTab(Sections.Payment);
  }

  // CalcDeposit(passedtotal: number){
  
  //   this.paymentAmount = passedtotal;
  //   let NumPeople: number = 0;
  //   this.NewBooking.resources[0].admissions.forEach(adm => {
  //     NumPeople += adm.noofpeople;
  //   });

  //   if(this.SelectedPackage.venueDepositPolicy == null)
  //   {
  //       this.paymentAmount = passedtotal;
  //   }
  //   else
  //   {
  //     let dp: cDepositpolicy = this.SelectedPackage.venueDepositPolicy;

  //     switch (dp.type)
  //     {
  //       case "Percentage":

  //         //Calculate date difference

  //         const oneDay = 24 * 60 * 60 * 1000;
  //         const creationDate: any = new Date();
  //         const bookingDate: any = new Date(this.NewBooking.startTime);

  //         const diffDays = Math.round(Math.abs((bookingDate - creationDate) / oneDay));

  //         if(diffDays < dp.alternativeamountthreshold)
  //         {
  //           this.validPaymentAmount = parseFloat(((this.paymentAmount * dp.alternativeamount) / 100).toFixed(2));
  //         }
  //         else
  //         {
  //           this.validPaymentAmount = parseFloat(((this.paymentAmount * dp.amount) / 100).toFixed(2));
  //         }
  //         break;
  //       case "PerPerson":
  //         this.validPaymentAmount = NumPeople * dp.amount;
  //         break;
  //       case "Fixed":
  //         this.validPaymentAmount = dp.amount;
  //         break;
  //       case "NoDeposit":
  //         this.validPaymentAmount = 0;
  //         break;
  //       default:
  //         this.validPaymentAmount = this.paymentAmount;
  //     }

  //     if(this.validPaymentAmount > this.paymentAmount)
  //     {
  //       this.validPaymentAmount = this.paymentAmount;
  //     }

  //     this.minimumDiscount = this.validPaymentAmount;
  //     this.maxPayment =  passedtotal;
  //   }

  //   //Add Booking Fee
  //   let BookingFeeValue = 0;
    
  //   if(localStorage.getItem("VenueBookingFee") != null)
  //   {
  //     let venueBookingFee: cBookingfee = (JSON.parse(localStorage.getItem("VenueBookingFee")) as cBookingfee)
     
  //     if (venueBookingFee.bfadminapply)
  //     {
  //       switch (venueBookingFee.bfadmintype)
  //       {
  //         case "PERPERSON":
  //           BookingFeeValue = venueBookingFee.bfadminfee * NumPeople;
  //           break;
  //         case "FIXED":
  //           BookingFeeValue =venueBookingFee.bfadminfee;
  //           break;
  //         case "PERCENTAGE":
  //           BookingFeeValue = parseFloat(((this.BookingResponse.bookingObj.total * venueBookingFee.bfadminfee) / 100).toFixed(2));
  //           break;
  //         default:
  //           BookingFeeValue = 0;
  //       }

  //       if (BookingFeeValue > venueBookingFee.bfadminmax && venueBookingFee.bfadminmax > 0)
  //         BookingFeeValue = venueBookingFee.bfadminmax

  //       if (BookingFeeValue < venueBookingFee.bfadminmin)
  //         BookingFeeValue = venueBookingFee.bfadminmin
  //     }
  //   }

  //   this.BookingFeeAdddedOn = BookingFeeValue;

  //   this.validPaymentAmount += BookingFeeValue

  //   this.MinimumValidPayment = this.validPaymentAmount;
  // }

  validateEmail(email){ 
    var re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/; 
    return re.test(email); 
  }

  validateMobile(mobile){ 
    var re = /^\+?\d{1,3}?[\s\-]?(\(?\d{1,4}\)?[\s\-]?)?[\d\s\-]{5,}$/; 
    return re.test(mobile); 
  }

  deferPayment(){
    this.showDeferReason = true;
  }

  DoSummary(BookingSummary)
  {
    let admissionsText: string = "";
    let extrasText: string = "";

    BookingSummary.resources[0].admissions.forEach(adm => {
      if(adm.noofpeople > 0)
        admissionsText += adm.noofpeople + " x " +  adm.name + ", ";
    });

    if(admissionsText.length > 2)
    admissionsText = admissionsText.substring(0, admissionsText.length - 2);

    if(BookingSummary.extras != null)
    {
      if(BookingSummary.extras.length > 0)
      {
        BookingSummary.extras.forEach(element => {
          if(element.qty > 0)
          {
            if(element.answer != null && element.answer != "")
            {
              extrasText += element.name + " x " + element.qty + " (" + element.question + ": " + element.answer + "), ";
            }
            else
            {
              extrasText += element.name + " x " + element.qty + ", ";
            }
          }
        });
      }
    }

    if(extrasText.length > 2)
    {
      extrasText = extrasText.substring(0, extrasText.length - 2);
    }

    let CustomerName = "";
    let CustomerAddress1 = "";
    let CustomerAddress2 = "";
    let CustomerTownCity = "";
    let CustomerPostCode = "";
    let FullCustomer = "";

    //A booking that came back without a customer used to stop the summary dead on the line
    //below, so nothing after it ran - including the Send Confirmation buttons, which simply
    //never appeared. The summary is now drawn either way, with the customer parts left blank.
    const summaryCustomer: any = BookingSummary.customer ?? {};

    CustomerName = (summaryCustomer.fullName ?? "").trim();

    //Each of these read "CustomerAddress1 = BookingSummary.customer.address1 = ", "" - an
    //assignment rather than a join, so the address printed as ", , , " and, worse, the customer
    //object's own address fields were overwritten with ", " in the process.
    if (summaryCustomer.address1 != null && summaryCustomer.address1 != "") 
    {
      CustomerAddress1 = ", " + summaryCustomer.address1;
    }
    
    if (summaryCustomer.address2 != null && summaryCustomer.address2 != "") 
    {
      CustomerAddress2 = ", " + summaryCustomer.address2;
    }

    if (summaryCustomer.townCity != null && summaryCustomer.townCity != "") 
    {
      CustomerTownCity = ", " + summaryCustomer.townCity;
    }

    if (summaryCustomer.postCode != null && summaryCustomer.postCode != "") 
    {
      CustomerPostCode = ", " + summaryCustomer.postCode;
    }

    FullCustomer = CustomerName + CustomerAddress1 + CustomerAddress2 + CustomerTownCity + CustomerPostCode;

    //A repeatable package books one booking per date, so list them all. The booking passed in is the
    //first date and is the freshest copy of it, so use that rather than the one held in the series.
    let seriesDatesList = null;
    let seriesTotal = 0;

    if(this.isSeriesBooking)
    {
      const bookings = [BookingSummary, ...this.seriesBookings.slice(1)];

      seriesDatesList = bookings.map((item: any) => {
        seriesTotal += Number(item.total) || 0;

        return {
          bookingId: item.bookingId,
          bookingIdHR: item.bookingIdHR,
          startTime: item.startTime,
          total: Number(item.total) || 0
        };
      });

      seriesTotal = Math.round(seriesTotal * 100) / 100;

      //The series record's total is the API's own, so it wins over adding up the dates.
      if(this.seriesRecord != null)
      {
        seriesTotal = Number(this.seriesRecord.total) || 0;
      }
    }

    let newBookingSummary:cBookingsummary = {
      Disabled: BookingSummary.disabled,
      bookingId: BookingSummary.bookingId,
      bookingIdHR: BookingSummary.bookingIdHR,
      admissions: admissionsText,
      startTime: BookingSummary.startTime,
      endTime: BookingSummary.endTime,
      name: BookingSummary.name,
      arrival: BookingSummary.arrival,
      guests: BookingSummary.guests,
      total: BookingSummary.total,
      outstanding: BookingSummary.outstanding,
      paid: Number(BookingSummary.total) - Number(BookingSummary.outstanding),
      totaldiscounts: Number(BookingSummary.totaldiscounts),
      totalbookingfees: Number(BookingSummary.totalbookingfees ?? BookingSummary.bookingfee ?? 0),
      bookingfee: Number(BookingSummary.bookingfee),
      customerName: summaryCustomer.fullName ?? "",
      customerAddress: FullCustomer,
      customerMobile: summaryCustomer.mobile ?? "",
      customerEmail:  summaryCustomer.email ?? "",
      packageName:  BookingSummary.packageName,
      publicBooking: BookingSummary.publicBooking,
      extras: extrasText,
      upgrade: BookingSummary.upgrade,
      upgradetext: BookingSummary.upgradetext,
      addontext: BookingSummary.addontext,
      itinerary: BookingSummary.itinerary,
      notes: BookingSummary.notes,
      totalbookingfee: BookingSummary.totalbookingfee,
      seriesdates: seriesDatesList,
      seriestotal: seriesTotal,
      seriespaid: this.seriesRecord == null ? null : Number(this.seriesRecord.totalpayments) || 0,
      seriesoutstanding: this.seriesRecord == null ? null : Number(this.seriesRecord.outstanding) || 0,
      //Made by the API from seriesid, so it is read off the booking rather than worked out here.
      seriesidhr: (BookingSummary as any).seriesidhr ?? "",

    }

    this.BookingSummary = newBookingSummary;

    //Not every way of finishing a series reads its record again, so it is read here and the
    //summary's series figures follow it once it arrives.
    if(this.isSeriesBooking)
    {
      this.loadSeriesRecord(() => {
        if(this.seriesRecord == null || this.BookingSummary !== newBookingSummary)
        {
          return;
        }

        newBookingSummary.seriestotal = Number(this.seriesRecord.total) || 0;
        newBookingSummary.seriespaid = Number(this.seriesRecord.totalpayments) || 0;
        newBookingSummary.seriesoutstanding = Number(this.seriesRecord.outstanding) || 0;
      });
    }
    
    this.BookingComplete = true;
    this.showTimer = false;

    //Send Booking Notication
    this.http.get(bmxurl + "/bookingnotification/" + this.VenueID + "/" + this.NewBooking.bookingId).subscribe(response => {
      this.httpResponse = (response as any);
      const notificationsEnabled = localStorage.getItem("BookingNotification") == "true";
      if(this.httpResponse.succeeded)
      {
        if(notificationsEnabled)
        {
          this.messageService.add({severity:'success', summary:'Booking Notification', detail: "Booking notification sent successfully"});
        }
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Booking Notification Failed', detail: "Failed to send booking notification: " + this.httpResponse.messages[0]});
      }
    }, error => {
    })

  }

  //True when any extra on offer has a picture. The picture column is only drawn then, so a
  //package with no pictures keeps a plain list rather than a column of empty squares.
  get extrasHaveImages(): boolean {
    return (this.packageExtras ?? []).some(ext => !!ext.imageurl);
  }

  //The description is a required field on an extra, so it is often just the name typed again.
  //Shown only when it says something the name does not.
  showExtraDescription(product: cPackageExtra): boolean {
    const description = (product.description ?? "").trim().toLowerCase();
    const name = (product.name ?? "").trim().toLowerCase();

    return description != "" && description != name;
  }

  sumExtras(){
    this.TotalExtras = 0;

    this.packageExtras.forEach(element => {
      // if(element.allparticipants)
      // {
      //   element.qty = this.totalAdmissions;
      //   this.TotalExtras += Number(element.price) * Number(this.totalAdmissions);
      // }
      // else
      // {
        this.TotalExtras += Number(element.price) * Number(element.qty);
      //}
    });
  }

  addMembership()
  {
    if(this.MembershipID == "" || this.MembershipID == null)
    {
      this.messageService.add({severity:'warn', summary:'Membership ID', detail: "Please enter a Membership ID"});
      return;
    }
    else
    {
      this.busyService.busy();
      let retrievedmembershipid = "";
      this.http.get<any>(bmxurl + "getmembership/" + this.VenueID + "/" + this.MembershipID).subscribe(response => {

        if(response.succeeded == true)
        {
          retrievedmembershipid = response.data.salesid;
          this.MembershipPIN = response.data.membershippin;

          this.http.get(bmxurl + "/validatemembership/" + this.NewBooking.bookingId + "/" + retrievedmembershipid + "/" + this.MembershipPIN).subscribe(response => {
          this.httpResponse =  (response as any);

          if(this.httpResponse.succeeded)
            {
              this.NewBooking = this.httpResponse.data;

              this.CustomerHeader = "Customer: " +  this.firstName + "  " + this.lastName;

              const rawMessage = Array.isArray(this.httpResponse.messages) ? this.httpResponse.messages[0] : this.httpResponse.messages;
              if (typeof rawMessage === 'string' && rawMessage.startsWith('[FAILED]')) {
                this.messageService.add({severity:'error', summary:'Error', detail: rawMessage.substring('[FAILED]'.length).trim()});
              } else {
                this.messageService.add({severity:'success', summary:'Success', detail: this.httpResponse.messages});
              }

              if(this.NewBooking.PublicBooking)
              {
                this.paymentAmount = this.NewBooking.totalpublicdeposit;
              }
              else
              {
                this.paymentAmount = this.NewBooking.totalvenuedeposit;
              }

              if (this.NewBooking.customer != null)
              {
                this.CustomerHeader = "Customer: " + this.NewBooking.customer.firstName + "  " + this.NewBooking.customer.lastName;
              }
              else
              {
                this.messageService.add({severity:'error', summary:'Error', detail: "No customer found"});
              }

              this.setTab(Sections.Notes);
              this.busyService.idle();

            }
            else
            {
              this.messageService.add({severity:'error', summary:'Error', detail: this.httpResponse.messages[0]});
              this.busyService.idle();
            }
          });
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Error', detail: response.messages[0]});
          this.busyService.idle();
        }
      });
    }
  }
  // {
  //   if(this.MembershipID == "" || this.MembershipID == null)
  //   {
  //     this.messageService.add({severity:'warn', summary:'Membership ID', detail: "Please enter a Membership ID"});
  //     return;
  //   }
  //   else
  //   {
  //     this.busyService.busy();
  //     let retrievedmembershipid = "";
  //     this.http.get<any>(bmxurl + "getmembership/" + this.VenueID + "/" + this.MembershipID).subscribe(response => {
  //       if(response.succeeded == true)
  //       {
  //         retrievedmembershipid = response.data.membershipid;
  //         let membershipEnddate  = new Date(response.data.enddate);

  //         if(membershipEnddate < new Date())
  //         {
  //           this.messageService.add({severity:'error', summary:'Error', detail: "Membership has expired"});
  //           this.busyService.idle();
  //           return;
  //         }
  //         else
  //         {
  //           this.busyService.busy();
  //           this.NewBooking.membershipid =retrievedmembershipid;
  //           this.http.post<booking_returndata>(bmxurl + "/savebooking", this.NewBooking).subscribe(response => {
  //             this.httpResponse = (response as booking_returndata);      

  //             if(this.httpResponse.succeeded)
  //             {
  //               this.BookingResponse = this.httpResponse.data
                
  //               if(this.httpResponse.messages.length > 0)
  //               {
  //                 this.messageService.add({severity:'warn', summary:'Warning', detail: this.httpResponse.messages[0]});
  //               }
  //               else{
  //                 this.messageService.add({severity:'success', summary:'Success', detail: "Membership added"});
  //               }
                
  //               this.NewBooking = this.BookingResponse.bookingObj;

  //               let NumPeople: number = 0;
  //               this.NewBooking.resources[0].admissions.forEach(adm => {
  //                 NumPeople += adm.noofpeople;
  //               });
          
  //               this.paymentAmount = this.BookingResponse.bookingObj.total;

  //               if(this.NewBooking.PublicBooking)
  //               {
  //                 this.validPaymentAmount = this.NewBooking.totalpublicdeposit - this.NewBooking.totalpayments;
  //               }
  //               else{
  //                 this.validPaymentAmount = this.NewBooking.totalvenuedeposit - this.NewBooking.totalpayments;
  //               }
          
  //               const formatter = new Intl.NumberFormat('en-GB', {
  //                 style: 'currency',
  //                 currency: this.CurrencySymbol});
          
  //               this.makeABookingHeader = "Make a Booking - Sales Value: " + formatter.format(this.paymentAmount);

  //               if (this.NewBooking.customer != null)
  //               {
  //                 this.CustomerHeader = "Customer: " + this.NewBooking.customer.firstName + "  " + this.NewBooking.customer.lastName;
  //               }
  //               else
  //               {
  //                 this.messageService.add({severity:'error', summary:'Error', detail: "No customer found"});
  //               }

  //               this.setTab(Sections.Notes);
  //               this.busyService.idle();

  //             }
  //             else
  //             {
  //               this.getAvailability();
                
  //               this.messageService.add({severity:'error', summary:'Error', detail: this.httpResponse.messages});
  //               this.busyService.idle();
  //             }
  //           }, error => {
  //         //             this.busyService.idle();
  //             this.messageService.add({severity:'error', summary:'Error', detail: error.message});
  //           })

  //           this.busyService.idle();
  //         }
  //       }
  //       else
  //       {
  //         this.messageService.add({severity:'error', summary:'Error', detail: response.messages});
  //         this.busyService.idle();
  //       }
      
  //       this.MembershipID = "";
  //     }, error => {
  //       this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred getting Membership'});
  //       this.busyService.idle();
  //       this.MembershipID = "";
  //     })
  //   }
  // }

  donePayment(paymentid: string, paymentname : string)
  {

    this.paymentButtonLocked = true;

    //Get number of people
    let NumPeople: number = 0;
    this.NewBooking.resources[0].admissions.forEach(adm => {
      NumPeople += adm.noofpeople;
    });

    this.AllValid = true;
    let AmountDue:number =this.validPaymentAmount;

    if (this.paymentAmount == null || (this.paymentAmount < 0)) {
      this.AllValid = false;
      this.paymentValueValid = false;
    }
    else {
      this.paymentValueValid = true;
      this.AllValid = true;
    }

    if(this.AllValid)
    {
      let newPayment: Payment = {
        id: null,
        PaymentId: null,
        BookingId: this.BookingResponse.bookingId,
        bookingIdHR: this.BookingResponse.bookingIdHR,
        method: paymentname,
        paymenttypeid: paymentid,
        amount: this.validPaymentAmount,
        paymentDate: new Date,
        disabled: false,
        venueid: this.VenueID,
        refunds: null,
        balance: this.validPaymentAmount,
        paymenttype: "booking",
        currency: this.CurrencySymbol,
        tillname: null
      }

      this.NewBooking.payments = [];
      this.NewBooking.payments.push(newPayment);
      this.NewBooking.inProgress = false;
      this.stampSeries();

      if(this.oldDepositValue == 0)
      {
        if(this.NewBooking.PublicBooking)
        {
          this.oldDepositValue = this.NewBooking.totalpublicdeposit;
        }
        else{
          this.oldDepositValue = this.NewBooking.totalvenuedeposit;
        }
      }

      const generalTerminalName = localStorage.getItem(`GeneralTerminalName_${this.VenueID}`) ?? '';
      const isCardPayment = paymentname.toLowerCase().includes('card');

      if (isCardPayment && generalTerminalName) {
        const terminalPayload = {
          venueid: this.VenueID,
          connectedAccountId: localStorage.getItem('RyftSubAccountID') ?? '',
          amount: Math.round(this.validPaymentAmount * 100),
          currency: this.CurrencySymbol.toLowerCase(),
          terminalId: generalTerminalName,
          method: 'BOOKING',
          identifier: this.NewBooking.bookingId ?? ''
        };

        this.initiateBookingTerminalPayment(terminalPayload);
        return;
      }

      //A series is paid as a whole, against the series rather than any one of its bookings.
      if(this.isSeriesBooking)
      {
        this.makeSeriesPayment(newPayment);
        return;
      }

      this.http.post<booking_returndata>(bmxurl + "/Payment", this.NewBooking).subscribe(response => {
        this.BookingResponse = (response as booking_returndata).data

        if(response.succeeded == true)
        {
          setTimeout(() => {
            this.paymentButtonLocked = false;
          }, 1000);

          this.NewBooking = this.BookingResponse;
          this.BookingPayments = this.BookingResponse.payments;

          if(this.NewBooking.PublicBooking)
          {
            this.validPaymentAmount = this.NewBooking.totalpublicdeposit;
          }
          else{
            this.validPaymentAmount = this.NewBooking.totalvenuedeposit;
          }

          this.totalPayments = 0;
          this.BookingPayments.forEach(element => {
            this.totalPayments += element.amount;
          });

          if(this.NewBooking.totalpayments >= this.oldDepositValue)
          {
            this.DoSummary(this.BookingResponse);
          }
          else
          {
            this.NewBooking.totalvenuedeposit = this.BookingResponse.bookingObj.totalvenuedeposit;
            this.NewBooking.totalpublicdeposit  = this.BookingResponse.bookingObj.totalpublicdeposit ;

            if(this.NewBooking.PublicBooking)
            {
              this.validPaymentAmount = this.NewBooking.totalpublicdeposit;// - this.NewBooking.totalpayments;
            }
            else{
              this.validPaymentAmount = this.NewBooking.totalvenuedeposit;// - this.NewBooking.totalpayments;
            }
          }
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Error', detail: this.httpResponse.messages});
          this.paymentButtonLocked = false;
        }
      }, error => {
        this.messageService.add({severity:'error', summary:'Error', detail: error.message});
        this.paymentButtonLocked = false;
      })
    }
  }  
  
  connectTerminalHubBooking(paymentIntentId: string): void {
    this.awaitingTerminalPayment = true;
    this.terminalPaymentResolved = false;

    this.terminalPollingIntervalId = setInterval(() => {
      this.ngZone.run(() => this.pollBookingForPayment());
    }, 10000);

    this.auth.getAccessTokenSilently().subscribe({
      next: (token) => {
        const hub = new HubConnectionBuilder()
          .withUrl(environment.servicestarget + '/venue/' + this.VenueID, {
            accessTokenFactory: () => token
          })
          .build();

        this.terminalHubConnection = hub;

        hub.on(paymentIntentId, (message: string) => {
          this.ngZone.run(() => {
            if (this.terminalPaymentResolved) return;
            this.terminalPaymentResolved = true;
            this.stopTerminalPolling();
            hub.stop();
            this.terminalHubConnection = null;
            this.awaitingTerminalPayment = false;

            if (message === 'succeeded') {
              this.messageService.add({ severity: 'success', summary: 'Payment Succeeded', detail: 'Card payment completed successfully.' });
              this.http.get<booking_returndata>(bmxurl + 'booking/' + this.VenueID + '/' + this.NewBooking.bookingId).subscribe(response => {
                if (response.succeeded) {
                  this.NewBooking = response.data;
                  this.BookingResponse = response.data;
                  this.BookingPayments = response.data.payments ?? [];
                  this.totalPayments = 0;
                  this.BookingPayments.forEach(p => { this.totalPayments += p.amount; });

                  if (this.NewBooking.totalpayments >= this.oldDepositValue) {
                    //A card payment is taken against the first date, so the other dates are
                    //completed without a payment of their own.
                    this.finishSeriesSiblings(null, null, null, null, () => this.DoSummary(this.BookingResponse));
                  } else {
                    this.validPaymentAmount = this.NewBooking.PublicBooking
                      ? this.NewBooking.totalpublicdeposit
                      : this.NewBooking.totalvenuedeposit;
                  }
                }
                this.paymentButtonLocked = false;
              }, () => { this.paymentButtonLocked = false; });
            } else {
              this.paymentFailedMessage = message;
              this.showPaymentFailedDialog = true;
              this.paymentButtonLocked = false;
            }
          });
        });

        hub.start().catch(() => {
          this.terminalHubConnection = null;
        });
      },
      error: () => { /* polling continues */ }
    });
  }

  private pollBookingForPayment(): void {
    if (this.terminalPaymentResolved) {
      this.stopTerminalPolling();
      return;
    }

    this.http.get<booking_returndata>(bmxurl + 'booking/' + this.VenueID + '/' + this.NewBooking.bookingId).subscribe(response => {
      if (this.terminalPaymentResolved) return;

      if (response.succeeded && response.data.totalpayments >= this.oldDepositValue) {
        this.terminalPaymentResolved = true;
        this.stopTerminalPolling();
        if (this.terminalHubConnection) {
          this.terminalHubConnection.stop();
          this.terminalHubConnection = null;
        }
        this.awaitingTerminalPayment = false;

        this.NewBooking = response.data;
        this.BookingResponse = response.data;
        this.BookingPayments = response.data.payments ?? [];
        this.totalPayments = 0;
        this.BookingPayments.forEach(p => { this.totalPayments += p.amount; });

        this.messageService.add({ severity: 'success', summary: 'Payment Received', detail: 'Payment confirmed via terminal.' });
        this.finishSeriesSiblings(null, null, null, null, () => this.DoSummary(this.BookingResponse));
        this.paymentButtonLocked = false;
      }
    });
  }

  private stopTerminalPolling(): void {
    if (this.terminalPollingIntervalId !== null) {
      clearInterval(this.terminalPollingIntervalId);
      this.terminalPollingIntervalId = null;
    }
  }

  private initiateBookingTerminalPayment(terminalPayload: any): void {
    this.http.post<any>(bmxurl + 'StripeTerminalPaymentInit', terminalPayload).subscribe(response => {
      this.httpResponse = response;
      if (this.httpResponse.succeeded) {
        const paymentIntentId: string = this.httpResponse.data?.paymentIntentId ?? this.httpResponse.data?.id ?? '';
        this.connectTerminalHubBooking(paymentIntentId);
      } else {
        const detail = this.httpResponse.messages?.[0] ?? 'Unknown error';
        if (detail.toLowerCase().includes('payment_intent in progress')) {
          this.pendingTerminalPayload = terminalPayload;
          this.pendingTerminalRetry = () => this.initiateBookingTerminalPayment(terminalPayload);
          this.showTerminalBusyDialog = true;
        } else {
          this.messageService.add({severity: 'error', summary: 'Terminal payment failed', detail});
          this.paymentButtonLocked = false;
        }
      }
    }, error => {
      this.messageService.add({severity: 'error', summary: 'Terminal payment failed', detail: error.message});
      this.paymentButtonLocked = false;
    });
  }

  waitForTerminal(): void {
    this.showTerminalBusyDialog = false;
  }

  clearTerminalAndRetryPayment(): void {
    const terminalId = this.pendingTerminalPayload?.terminalId ?? '';
    this.showTerminalBusyDialog = false;
    this.http.get<any>(bmxurl + 'StripeTerminalCancel/' + this.VenueID + '/' + terminalId).subscribe({
      complete: () => {
        this.pendingTerminalRetry?.();
      }
    });
  }

  cancelTerminalPayment(): void {
    this.terminalPaymentResolved = true;
    this.stopTerminalPolling();

    if (this.terminalHubConnection) {
      this.terminalHubConnection.stop();
      this.terminalHubConnection = null;
    }

    const terminalId = localStorage.getItem(`GeneralTerminalName_${this.VenueID}`) ?? '';
    this.http.get<any>(bmxurl + 'StripeTerminalCancel/' + this.VenueID + '/' + terminalId).subscribe({
      complete: () => {
        this.awaitingTerminalPayment = false;
        this.paymentButtonLocked = false;
      }
    });
  }

  sendSMSConfirmation(){
     this.http.get<customer>(bmxurl + "confirmation/" + this.VenueID + "/" + this.NewBooking.bookingId).subscribe(response => {
       this.messageService.add({severity:'success', summary:'Success', detail:'SMS Message sent.'});
     }, error => {
       this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to send the SMS'});
     })
  }

  sendEmailConfirmation(){
     this.http.get<customer>(bmxurl + "confirmationemail/" + this.VenueID + "/" + this.NewBooking.bookingId).subscribe(response => {
       this.messageService.add({severity:'success', summary:'Success', detail:'Email Message sent.'})
     }, error => {
       this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to send the Email'});
     })
  }

  // setTab(tabNumber: number)
  // {
  //   if(tabNumber == Sections.Date)
  //   {
  //     this.dateSelected = true;
  //     this.packageSelected = false;
  //     this.admissionsSelected = false;
  //     this.partyroomsSelected = false;
  //     this.timeSelected = false;
  //     this.customerSelected = false;
  //     this.paymentSelected = false;
  //     this.extraSelected = false;
  //     this.notesSelected = false;
  //     this.bookingQuestionsSelected = true;
  //     this.upgradeSelected = false;

  //     this.dateActive = false;
  //     this.packageActive = true;
  //     this.admissionsActive = true;
  //     this.partyroomsActive = true;
  //     this.timeActive = true;
  //     this.customerActive = true;
  //     this.paymentActive = true;
  //     this.extraActive = true;
  //     this.notesActive = true;
  //     this.bookingQuestionsActive = true;
  //     this.upgradeActive = true;
  //   }
  //   if(tabNumber == Sections.Package) 
  //   {
  //     this.dateSelected = false;
  //     this.packageSelected = true;
  //     this.admissionsSelected = false;
  //     this.partyroomsSelected = false;
  //     this.timeSelected = false;
  //     this.customerSelected = false;
  //     this.paymentSelected = false;
  //     this.extraSelected = false;
  //     this.notesSelected = false;
  //     this.bookingQuestionsSelected = false;
  //     this.upgradeSelected = false;

  //     this.dateActive = false;
  //     this.packageActive = false;
  //     this.admissionsActive = true;
  //     this.partyroomsActive = true;
  //     this.timeActive = true;
  //     this.customerActive = true;
  //     this.paymentActive = true;
  //     this.extraActive = true;
  //     this.notesActive = true;
  //     this.bookingQuestionsActive = true;
  //     this.upgradeActive = true;
  //   }
  //   if(tabNumber == Sections.Admissions)
  //   {
  //     this.dateSelected = false;
  //     this.packageSelected = false;
  //     this.admissionsSelected = true;
  //     this.partyroomsSelected = false;
  //     this.timeSelected = false;
  //     this.customerSelected = false;
  //     this.paymentSelected = false;
  //     this.extraSelected = false;
  //     this.notesSelected = false;
  //     this.bookingQuestionsSelected = false;
  //     this.upgradeSelected = false;

  //     this.dateActive = false;
  //     this.packageActive = false;
  //     this.admissionsActive = false;
  //     this.partyroomsActive = true;
  //     this.timeActive = true;
  //     this.customerActive = true;
  //     this.paymentActive = true;
  //     this.extraActive = true;
  //     this.notesActive = true;
  //     this.bookingQuestionsActive = true;
  //     this.upgradeActive = true;
  //   }
  //   if(tabNumber == Sections.Partyroom)
  //   {
  //     this.dateSelected = false;
  //     this.packageSelected = false;
  //     this.admissionsSelected = false;
  //     this.partyroomsSelected = true;
  //     this.timeSelected = false;
  //     this.customerSelected = false;
  //     this.paymentSelected = false;
  //     this.extraSelected = false;
  //     this.notesSelected = false;
  //     this.bookingQuestionsSelected = false;
  //     this.upgradeSelected = false;

  //     this.dateActive = false;
  //     this.packageActive = false;
  //     this.admissionsActive = false;
  //     this.partyroomsActive = false;
  //     this.timeActive = true;
  //     this.customerActive = true;
  //     this.paymentActive = true;
  //     this.extraActive = true;
  //     this.notesActive = true;
  //     this.bookingQuestionsActive = true;
  //     this.upgradeActive = true;
  //   }
  //   if(tabNumber == Sections.Time) 
  //   {
  //     this.dateSelected = false;
  //     this.packageSelected = false;
  //     this.admissionsSelected = false;
  //     this.partyroomsSelected = false;
  //     this.timeSelected = true;
  //     this.customerSelected = false;
  //     this.paymentSelected = false;
  //     this.extraSelected = false;
  //     this.notesSelected = false;
  //     this.bookingQuestionsSelected = false;
  //     this.upgradeSelected = false;

  //     this.dateActive = false;
  //     this.packageActive = false;
  //     this.admissionsActive = false;
  //     this.partyroomsActive = false;
  //     this.timeActive = false;
  //     this.customerActive = true;
  //     this.paymentActive = true;
  //     this.extraActive = true;
  //     this.notesActive = true;
  //     this.bookingQuestionsActive = true;
  //     this.upgradeActive = true;
  //   }
  //   if(tabNumber == Sections.Upgrades)
  //   {
  //     this.dateSelected = false;
  //     this.packageSelected = false;
  //     this.admissionsSelected = false;
  //     this.partyroomsSelected = false;
  //     this.timeSelected = false;
  //     this.customerSelected = false;
  //     this.paymentSelected = false;
  //     this.extraSelected = false;
  //     this.notesSelected = false;
  //     this.bookingQuestionsSelected = false;
  //     this.upgradeSelected = true;

  //     this.dateActive = false;
  //     this.packageActive = false;
  //     this.admissionsActive = false;
  //     this.partyroomsActive = false;
  //     this.timeActive = false;
  //     this.customerActive = true;
  //     this.paymentActive = true;
  //     this.extraActive = true;
  //     this.notesActive = true;
  //     this.bookingQuestionsActive = true;
  //     this.upgradeActive = false;


  //   }
  //   if(tabNumber == Sections.BookingQuestions) 
  //   {
  //     this.dateSelected = false;
  //     this.packageSelected = false;
  //     this.admissionsSelected = false;
  //     this.partyroomsSelected = false;
  //     this.timeSelected = false;
  //     this.customerSelected = false;
  //     this.paymentSelected = false;
  //     this.extraSelected = false;
  //     this.notesSelected = false;
  //     this.bookingQuestionsSelected = true;
  //     this.upgradeSelected = false;

  //     this.dateActive = false;
  //     this.packageActive = false;
  //     this.admissionsActive = false;
  //     this.partyroomsActive = false;
  //     this.timeActive = false;
  //     this.customerActive = true;
  //     this.paymentActive = true;
  //     this.extraActive = true;
  //     this.notesActive = true;
  //     this.bookingQuestionsActive = false;
  //     this.upgradeActive = false;
  //   }
  //   if(tabNumber == Sections.Customer)
  //   {
  //     this.dateSelected = false;
  //     this.packageSelected = false;
  //     this.admissionsSelected = false;
  //     this.partyroomsSelected = false;
  //     this.timeSelected = false;
  //     this.customerSelected = true;
  //     this.paymentSelected = false;
  //     this.extraSelected = false;
  //     this.notesSelected = false;
  //     this.bookingQuestionsSelected = false;
  //     this.upgradeSelected = false;

  //     this.dateActive = false;
  //     this.packageActive = false;
  //     this.admissionsActive = false;
  //     this.partyroomsActive = false;
  //     this.timeActive = false;
  //     this.customerActive = false;
  //     this.paymentActive = true;
  //     this.extraActive = false;
  //     this.notesActive = true;
  //     this.bookingQuestionsActive = false;
  //     this.upgradeActive = false;
  //   }
  //   if(tabNumber == Sections.Extras)
  //   {
  //     this.dateSelected = false;
  //     this.packageSelected = false;
  //     this.admissionsSelected = false;
  //     this.partyroomsSelected = false;
  //     this.timeSelected = false;
  //     this.customerSelected = false;
  //     this.paymentSelected = false;
  //     this.extraSelected = true;
  //     this.notesSelected = false;
  //     this.bookingQuestionsSelected = false;
  //     this.upgradeSelected = false;

  //     this.dateActive = false;
  //     this.packageActive = false;
  //     this.admissionsActive = false;
  //     this.partyroomsActive = false;
  //     this.timeActive = false;
  //     this.customerActive = true;
  //     this.extraActive = false;
  //     this.notesActive = true;
  //     this.paymentActive = true;
  //     this.bookingQuestionsActive = false;
  //     this.upgradeActive = false;
  //   }
  //   if(tabNumber == Sections.Notes)
  //   {
  //     this.dateSelected = false;
  //     this.packageSelected = false;
  //     this.admissionsSelected = false;
  //     this.partyroomsSelected = false;
  //     this.timeSelected = false;
  //     this.customerSelected = false;
  //     this.extraSelected = false;
  //     this.notesSelected = true;
  //     this.paymentSelected = false;
  //     this.bookingQuestionsSelected = false;
  //     this.upgradeSelected = false;

  //     this.dateActive = false;
  //     this.packageActive = false;
  //     this.admissionsActive = false;
  //     this.partyroomsActive = false;
  //     this.timeActive = false;
  //     this.customerActive = false;
  //     this.extraActive = false;
  //     this.notesActive = false;
  //     this.paymentActive = true;
  //     this.bookingQuestionsActive = false;
  //     this.upgradeActive = false;
  //   }
  //   if(tabNumber == Sections.Payment)
  //   {
  //     if(this.NewBooking.customer == null)
  //     {
  //       this.messageService.add({ severity: 'error', summary: 'Please enter a customer' });
  //       this.setTab(Sections.Customer);
  //       return;
  //     }

  //     this.dateSelected = false;
  //     this.packageSelected = false;
  //     this.admissionsSelected = false;
  //     this.partyroomsSelected = false;
  //     this.timeSelected = false;
  //     this.customerSelected = false;
  //     this.extraSelected = false;
  //     this.notesSelected = false;
  //     this.paymentSelected = true;
  //     this.bookingQuestionsSelected = false;
  //     this.upgradeSelected = false;

  //     this.dateActive = false;
  //     this.packageActive = false;
  //     this.admissionsActive = false;
  //     this.partyroomsActive = false;
  //     this.timeActive = false;
  //     this.customerActive = false;
  //     this.extraActive = false;
  //     this.notesActive = false;
  //     this.paymentActive = false;
  //     this.bookingQuestionsActive = true;
  //     this.upgradeActive = false;
  //   }
  // }

  setTab(tabNumber: number)
  {
    if(tabNumber == Sections.Date)
    {
      this.dateSelected = true;
      this.packageSelected = false;
      this.admissionsSelected = false;
      this.partyroomsSelected = false;
      this.timeSelected = false;
      this.customerSelected = false;
      this.paymentSelected = false;
      this.extraSelected = false;
      this.notesSelected = false;
      this.bookingQuestionsSelected = true;
      this.upgradeSelected = false;
      this.optionalUpgradeSelected = false;

      this.dateActive = false;
      this.packageActive = true;
      this.admissionsActive = true;
      this.partyroomsActive = true;
      this.timeActive = true;
      this.customerActive = true;
      this.paymentActive = true;
      this.extraActive = true;
      this.notesActive = true;
      this.bookingQuestionsActive = true;
      this.upgradeActive = true;
      this.optionalUpgradeActive = true;
    }
    if(tabNumber == Sections.Package) 
    {
      this.dateSelected = false;
      this.packageSelected = true;
      this.admissionsSelected = false;
      this.partyroomsSelected = false;
      this.timeSelected = false;
      this.customerSelected = false;
      this.paymentSelected = false;
      this.extraSelected = false;
      this.notesSelected = false;
      this.bookingQuestionsSelected = false;
      this.upgradeSelected = false;
      this.optionalUpgradeSelected = false;

      this.dateActive = false;
      this.packageActive = false;
      this.admissionsActive = true;
      this.partyroomsActive = true;
      this.timeActive = true;
      this.customerActive = true;
      this.paymentActive = true;
      this.extraActive = true;
      this.notesActive = true;
      this.bookingQuestionsActive = true;
      this.upgradeActive = true;
      this.optionalUpgradeActive = true;
    }
    if(tabNumber == Sections.Admissions)
    {
      this.dateSelected = false;
      this.packageSelected = false;
      this.admissionsSelected = true;
      this.partyroomsSelected = false;
      this.timeSelected = false;
      this.customerSelected = false;
      this.paymentSelected = false;
      this.extraSelected = false;
      this.notesSelected = false;
      this.bookingQuestionsSelected = false;
      this.upgradeSelected = false;
      this.optionalUpgradeSelected = false;

      this.dateActive = false;
      this.packageActive = false;
      this.admissionsActive = false;
      this.partyroomsActive = true;
      this.timeActive = true;
      this.customerActive = true;
      this.paymentActive = true;
      this.extraActive = true;
      this.notesActive = true;
      this.bookingQuestionsActive = true;
      this.upgradeActive = true;
      this.optionalUpgradeActive = true;
    }
    if(tabNumber == Sections.Partyroom)
    {
      this.dateSelected = false;
      this.packageSelected = false;
      this.admissionsSelected = false;
      this.partyroomsSelected = true;
      this.timeSelected = false;
      this.customerSelected = false;
      this.paymentSelected = false;
      this.extraSelected = false;
      this.notesSelected = false;
      this.bookingQuestionsSelected = false;
      this.upgradeSelected = false;
      this.optionalUpgradeSelected = false;

      this.dateActive = false;
      this.packageActive = false;
      this.admissionsActive = false;
      this.partyroomsActive = false;
      this.timeActive = true;
      this.customerActive = true;
      this.paymentActive = true;
      this.extraActive = true;
      this.notesActive = true;
      this.bookingQuestionsActive = true;
      this.upgradeActive = true;
      this.optionalUpgradeActive = true;
    }
    if(tabNumber == Sections.Time) 
    {
      this.dateSelected = false;
      this.packageSelected = false;
      this.admissionsSelected = false;
      this.partyroomsSelected = false;
      this.timeSelected = true;
      this.customerSelected = false;
      this.paymentSelected = false;
      this.extraSelected = false;
      this.notesSelected = false;
      this.bookingQuestionsSelected = false;
      this.upgradeSelected = false;
      this.optionalUpgradeSelected = false;

      this.dateActive = false;
      this.packageActive = false;
      this.admissionsActive = false;
      this.partyroomsActive = false;
      this.timeActive = false;
      this.customerActive = true;
      this.paymentActive = true;
      this.extraActive = true;
      this.notesActive = true;
      this.bookingQuestionsActive = true;
      this.upgradeActive = true;
      this.optionalUpgradeActive = true;
    }
    if(tabNumber == Sections.Upgrades)
    {
      this.dateSelected = false;
      this.packageSelected = false;
      this.admissionsSelected = false;
      this.partyroomsSelected = false;
      this.timeSelected = false;
      this.customerSelected = false;
      this.paymentSelected = false;
      this.extraSelected = false;
      this.notesSelected = false;
      this.bookingQuestionsSelected = false;
      this.upgradeSelected = true;
      this.optionalUpgradeSelected = false;

      this.dateActive = false;
      this.packageActive = false;
      this.admissionsActive = false;
      this.partyroomsActive = false;
      this.timeActive = false;
      this.customerActive = true;
      this.paymentActive = true;
      this.extraActive = true;
      this.notesActive = true;
      this.bookingQuestionsActive = true;
      this.upgradeActive = false;
      this.optionalUpgradeActive = false;


    }
    if(tabNumber == Sections.OptionalUpgrades)
    {
      this.dateSelected = false;
      this.packageSelected = false;
      this.admissionsSelected = false;
      this.partyroomsSelected = false;
      this.timeSelected = false;
      this.customerSelected = false;
      this.paymentSelected = false;
      this.extraSelected = false;
      this.notesSelected = false;
      this.bookingQuestionsSelected = false;
      this.upgradeSelected = false;
      this.optionalUpgradeSelected = true;

      this.dateActive = false;
      this.packageActive = false;
      this.admissionsActive = false;
      this.partyroomsActive = false;
      this.timeActive = false;
      this.customerActive = true;
      this.paymentActive = true;
      this.extraActive = true;
      this.notesActive = true;
      this.bookingQuestionsActive = true;
      this.upgradeActive = false;
      this.optionalUpgradeActive = false;


    }
    if(tabNumber == Sections.BookingQuestions) 
    {
      this.dateSelected = false;
      this.packageSelected = false;
      this.admissionsSelected = false;
      this.partyroomsSelected = false;
      this.timeSelected = false;
      this.customerSelected = false;
      this.paymentSelected = false;
      this.extraSelected = false;
      this.notesSelected = false;
      this.bookingQuestionsSelected = true;
      this.upgradeSelected = false;
      this.optionalUpgradeSelected = false;

      this.dateActive = false;
      this.packageActive = false;
      this.admissionsActive = false;
      this.partyroomsActive = false;
      this.timeActive = false;
      this.customerActive = true;
      this.paymentActive = true;
      this.extraActive = true;
      this.notesActive = true;
      this.bookingQuestionsActive = false;
      this.upgradeActive = false;
      this.optionalUpgradeActive = true;
    }
    if(tabNumber == Sections.Customer)
    {
      if(this.qbook == "true"){
        this.doWalkin()
      }

      this.dateSelected = false;
      this.packageSelected = false;
      this.admissionsSelected = false;
      this.partyroomsSelected = false;
      this.timeSelected = false;
      this.customerSelected = true;
      this.paymentSelected = false;
      this.extraSelected = false;
      this.notesSelected = false;
      this.bookingQuestionsSelected = false;
      this.upgradeSelected = false;
      this.optionalUpgradeSelected = false;

      this.dateActive = false;
      this.packageActive = false;
      this.admissionsActive = false;
      this.partyroomsActive = false;
      this.timeActive = false;
      this.customerActive = false;
      this.paymentActive = true;
      this.extraActive = false;
      this.notesActive = true;
      this.bookingQuestionsActive = false;
      this.upgradeActive = false;
      this.optionalUpgradeActive = true;
    }
    if(tabNumber == Sections.Extras)
    {
      this.dateSelected = false;
      this.packageSelected = false;
      this.admissionsSelected = false;
      this.partyroomsSelected = false;
      this.timeSelected = false;
      this.customerSelected = false;
      this.paymentSelected = false;
      this.extraSelected = true;
      this.notesSelected = false;
      this.bookingQuestionsSelected = false;
      this.upgradeSelected = false;
      this.optionalUpgradeSelected = false;

      this.dateActive = false;
      this.packageActive = false;
      this.admissionsActive = false;
      this.partyroomsActive = false;
      this.timeActive = false;
      this.customerActive = true;
      this.extraActive = false;
      this.notesActive = true;
      this.paymentActive = true;
      this.bookingQuestionsActive = false;
      this.upgradeActive = false;
      this.optionalUpgradeActive = false;
    }
    if(tabNumber == Sections.Notes)
    {
      this.dateSelected = false;
      this.packageSelected = false;
      this.admissionsSelected = false;
      this.partyroomsSelected = false;
      this.timeSelected = false;
      this.customerSelected = false;
      this.extraSelected = false;
      this.notesSelected = true;
      this.paymentSelected = false;
      this.bookingQuestionsSelected = false;
      this.upgradeSelected = false;
      this.optionalUpgradeSelected = false;

      this.dateActive = false;
      this.packageActive = false;
      this.admissionsActive = false;
      this.partyroomsActive = false;
      this.timeActive = false;
      this.customerActive = false;
      this.extraActive = false;
      this.notesActive = false;
      this.paymentActive = true;
      this.bookingQuestionsActive = false;
      this.upgradeActive = false;
      this.optionalUpgradeActive = false;
    }
    if(tabNumber == Sections.Payment)
    {
      if(this.NewBooking.customer == null)
      {
        this.messageService.add({ severity: 'error', summary: 'Please enter a customer' });
        this.setTab(Sections.Customer);
        return;
      }

      this.dateSelected = false;
      this.packageSelected = false;
      this.admissionsSelected = false;
      this.partyroomsSelected = false;
      this.timeSelected = false;
      this.customerSelected = false;
      this.extraSelected = false;
      this.notesSelected = false;
      this.paymentSelected = true;
      this.bookingQuestionsSelected = false;
      this.upgradeSelected = false;
      this.optionalUpgradeSelected = false;

      this.dateActive = false;
      this.packageActive = false;
      this.admissionsActive = false;
      this.partyroomsActive = false;
      this.timeActive = false;
      this.customerActive = false;
      this.extraActive = false;
      this.notesActive = false;
      this.paymentActive = false;
      this.bookingQuestionsActive = true;
      this.upgradeActive = false;
      this.optionalUpgradeActive = false;
    }
  }

  returnHome(){

    this.bookSlot(null);
    this.AbandonBooking();

    this.setTab(Sections.Date);
    this.BookingPayments = [];
    this.totalPayments = 0;

    this.checked = [];

    this.BookingComplete = false;

    this.PackageHeader = "Select a Package";
    this.CalendarHeader = "Select a Date";
    this.AdmissionHeader = "Select your Admissions";
    this.TimeHeader = "Select a Time";
    this.CustomerHeader = "Create a Customer";
    this.PaymentHeader = "Add a Payment";
    this.ExtrasHeader = "Select Extras";

    this.startTimes = null;
    this.startTimesFiltered = null;

    this.SelectedPackage = null;
    this.SelectedDate = null;

    this.firstName = "";
    this.lastName = "";
    this.address1 = "";
    this.address2 = "";
    this.town = "";
    this.postCode = "";
    this.email = "";
    this.mobile = "";
    this.searchCriteria = "";
    this.customersResult = null;
    this.ShowCustomerDetails = false;

    this.selectedPayment = null;
    this.packageExtras = null;
    this.paymentAmount = 0;
    this.makeABookingHeader = "Make a Booking";
    this.NewBooking = {} as booking;
    this.customerSelectedResources = [];
    this.SelectedResources = [];

    this.MinimumValidPayment = 0;
    this.BookingTimeElasped = false;

    this.restartTimer('');
  }

  returnQHome(){
    this.bookSlot(null);
    this.AbandonBooking();

    this.setTab(Sections.Date);
    this.BookingPayments = [];
    this.totalPayments = 0;

    this.checked = [];

    this.BookingComplete = false;

    this.PackageHeader = "Select a Package";
    this.CalendarHeader = "Select a Date";
    this.AdmissionHeader = "Select your Admissions";
    this.TimeHeader = "Select a Time";
    this.CustomerHeader = "Create a Customer";
    this.PaymentHeader = "Add a Payment";
    this.ExtrasHeader = "Select Extras";
    this.SelectedPackage = null;

    this.startTimes = null;
    this.startTimesFiltered = null;

    this.SelectedPackage = null;
    this.SelectedDate = null;

    this.firstName = "";
    this.lastName = "";
    this.address1 = "";
    this.address2 = "";
    this.town = "";
    this.postCode = "";
    this.email = "";
    this.mobile = "";
    this.searchCriteria = "";
    this.customersResult = null;
    this.ShowCustomerDetails = false;

    this.selectedPayment = null;
    this.packageExtras = null;
    this.paymentAmount = 0;
    this.makeABookingHeader = "Make a Booking";
    this.NewBooking = {} as booking;
    this.customerSelectedResources = [];
    this.SelectedResources = [];

    this.MinimumValidPayment = 0;
    this.BookingTimeElasped = false;

    this.restartTimer('');

    this.SelectedDate = new Date();
    this.doneDate();
    this.setTab(Sections.Package);
  }
  
  //---- Repeatable packages ------------------------------------------------------------------------
  //A repeatable package is booked as one ordinary booking per date, all sharing a series id. Once
  //every date is held the first becomes NewBooking, so every step after this - questions, extras,
  //customer, notes, payment - runs on it exactly as for any other booking. The other dates are given
  //the same customer, extras, answers and notes just before payment, and the API shares the one
  //payment across every booking with the series id.

  get isRepeatable(): boolean {
    return this.SelectedPackage != null && this.SelectedPackage.repeatable == true && (this.SelectedPackage.repeatdates ?? []).length > 0;
  }

  get isSeriesBooking(): boolean {
    return this.seriesBookings.length > 0;
  }

  //Different days in a package's repeat dates - a day with several times counts once.
  seriesDayCount(packageItem: any): number {
    return new Set((packageItem?.repeatdates ?? []).map((value: string) => value.substring(0, 10))).size;
  }

  //The same filter the package's extras go through when it is chosen, for the first booked date.
  private refilterSeriesExtras()
  {
    const dayFlags = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    const flag = dayFlags[this.SelectedDate.getDay()];

    this.packageExtras = (this.SelectedPackage.extras ?? []).filter((ext: any) => ext[flag] == true && ext.disabled == false);

    this.packageExtras.forEach(ext => {
      ext.qty = 0;
    });

    this.PackageHasExtras = this.packageExtras.length > 0;
  }

  private seriesTodayString(): string {
    const now = new Date();

    return now.getFullYear() + "-" + ('00' + (now.getMonth() + 1)).slice(-2) + "-" + ('00' + now.getDate()).slice(-2);
  }

  //Once the first date has gone, all the dates can no longer be booked together.
  get seriesAllAllowed(): boolean {
    const today = this.seriesTodayString();

    return (this.SelectedPackage?.repeatdates ?? []).every(date => date.substring(0, 10) >= today);
  }

  get seriesPeople(): number {
    return (this.SelectedAdmissions ?? []).reduce((sum, adm) => sum + (Number(adm.noofpeople) || 0), 0);
  }

  get seriesChosenDates(): seriesdate[] {
    if(this.seriesMode == "BLOCK")
    {
      return this.seriesChosenBlock?.dates ?? [];
    }

    if(this.seriesMode == "ALL")
    {
      return this.seriesDates;
    }

    if(this.seriesMode == "SOME")
    {
      return this.seriesDates.filter(item => item.ticked);
    }

    return [];
  }

  get seriesUnresolved(): number {
    return this.seriesChosenDates.filter(item => item.chosen == null).length;
  }

  get seriesFullDates(): seriesdate[] {
    return this.seriesDates.filter(item => item.times.length == 0);
  }

  get seriesAllTicked(): boolean {
    return this.seriesMode == "SOME" && this.seriesDates.length > 0 && this.seriesDates.every(item => item.ticked);
  }

  //Every time free on at least one date, with how many dates it is free on.
  get seriesTimeOptions(): { time: string, count: number }[] {
    const counts = new Map<string, number>();

    this.seriesDates.forEach(item => {
      item.times.forEach(slot => counts.set(slot.timeString, (counts.get(slot.timeString) ?? 0) + 1));
    });

    return Array.from(counts.entries())
      .map(([time, count]) => ({ time: time, count: count }))
      .sort((one, two) => one.time.localeCompare(two.time));
  }

  //---- Fixed blocks ------------------------------------------------------------------------
  //A block is a fixed run of the package's dates. It is taken whole or not at all, so it is only
  //offered when every date in it has a time free.

  get isBlockPackage(): boolean {
    return this.SelectedPackage?.repeatmode == 'BLOCKS'
      && (this.SelectedPackage?.repeatblocks ?? []).length > 0;
  }

  //Built from seriesDates, which already holds the availability for every date of the package,
  //so a block costs no extra calls - it is the same answers read a different way.
  private buildSeriesBlocks() {
    this.seriesBlocks = [];
    this.seriesChosenBlockId = "";

    if(!this.isBlockPackage) {
      return;
    }

    const today = this.seriesTodayString();

    this.seriesBlocks = (this.SelectedPackage.repeatblocks ?? []).map((block: any) => {
      const wanted = [...(block.dates ?? [])].sort();
      //A block's dates as this screen knows them. A date the package lists but that is not in
      //seriesDates has already gone by, which is what makes a block unbookable below.
      const dates = wanted
        .map(value => this.seriesDates.find(item => item.date.substring(0, 10) == value.substring(0, 10)
          && item.packageTimes.includes(value.substring(11, 16))))
        .filter(item => item != null);

      const passed = wanted.filter(value => value.substring(0, 10) < today).length;
      const full = dates.filter(item => item.times.length == 0);

      return {
        blockid: block.blockid,
        name: block.name,
        wanted: wanted,
        dates: dates,
        sessions: wanted.length,
        passed: passed,
        full: full,
        //Whole or nothing: every date still to come, and every one of them with a time free.
        available: passed == 0 && dates.length == wanted.length && full.length == 0,
        rangeText: this.seriesBlockRange(wanted)
      } as seriesblock;
    });
  }

  private seriesBlockRange(dates: string[]): string {
    if(dates.length == 0) {
      return "";
    }

    const day = (value: string) => value.substring(8, 10) + "/" + value.substring(5, 7) + "/" + value.substring(0, 4);

    return dates.length == 1 ? day(dates[0]) : day(dates[0]) + " to " + day(dates[dates.length - 1]);
  }

  //Why a block cannot be taken, in the venue's terms rather than a bare "unavailable".
  seriesBlockReason(block: seriesblock): string {
    if(block.available) {
      return "";
    }

    if(block.passed > 0) {
      return "This run has already started.";
    }

    if(block.dates.length != block.wanted.length) {
      return "Some of this run's dates are no longer offered.";
    }

    const names = block.full.map(item => item.date.substring(8, 10) + "/" + item.date.substring(5, 7));

    return names.length == 1
      ? names[0] + " has no times left, so the run can't be booked."
      : names.join(", ") + " have no times left, so the run can't be booked.";
  }

  //What one run costs: the run price, which is what allsessionsprice now means. Where a venue
  //has not set one, it falls back to the per-session price times the sessions in the run so a
  //run is never offered at nothing.
  seriesBlockPrice(block: seriesblock): number {
    let total = 0;

    (this.SelectedAdmissions ?? []).forEach((adm: any) => {
      const people = Number(adm.noofpeople) || 0;
      const runPrice = Number(adm.allsessionsprice) || 0;

      total += runPrice > 0
        ? people * runPrice
        : people * (Number(adm.persessionprice) || 0) * block.sessions;
    });

    return Math.round(total * 100) / 100;
  }

  //---- Picking rules on a free-pick package --------------------------------------------------

  //Most dates the customer may take. 0 on the package means no limit.
  get seriesMaxDates(): number {
    return Number(this.SelectedPackage?.repeatmaxdates) || 0;
  }

  //How many dates earn the run price. 0 means picking dates never reaches it.
  get seriesRunPriceFrom(): number {
    return Number(this.SelectedPackage?.repeatblockpricefrom) || 0;
  }

  get seriesTickedCount(): number {
    return this.seriesDates.filter(item => item.ticked).length;
  }

  get seriesAtMaxDates(): boolean {
    return this.seriesMaxDates > 0 && this.seriesTickedCount >= this.seriesMaxDates;
  }

  //Whether what is ticked has reached the run price.
  get seriesOnRunPrice(): boolean {
    return this.seriesRunPriceFrom > 0 && this.seriesTickedCount >= this.seriesRunPriceFrom;
  }

  get seriesChosenBlock(): seriesblock {
    return this.seriesBlocks.find(block => block.blockid == this.seriesChosenBlockId) ?? null;
  }

  //Picking a block takes every date in it at once. Nothing is part-chosen - that is the point of
  //a block - so the ticks the free-pick mode uses are set from the block rather than by hand.
  chooseSeriesBlock(block: seriesblock) {
    if(!block.available) {
      return;
    }

    if(this.seriesChosenBlockId == block.blockid) {
      return;
    }

    this.resetSeriesHolds();

    this.seriesChosenBlockId = block.blockid;
    this.seriesMode = "BLOCK";
    this.seriesPreferredTime = "";

    this.seriesDates.forEach(item => {
      item.ticked = block.dates.indexOf(item) > -1;

      if(!item.ticked) {
        item.chosen = null;
      }
    });

    //One time per date still has to be settled; the earliest free one on each is the sensible
    //opening answer and the customer can change any of them.
    block.dates.forEach(item => {
      if(item.chosen == null && item.times.length > 0) {
        item.chosen = item.times[0];
      }
    });
  }

  //Each admission has its own session prices, so the estimate adds up what was chosen rather than
  //one price per person. The API works out the real price when the dates are held.
  private seriesPriceFor(mode: string, dates: number): number {
    let total = 0;

    (this.SelectedAdmissions ?? []).forEach((adm: any) => {
      const people = Number(adm.noofpeople) || 0;

      const runPrice = Number(adm.allsessionsprice) || 0;
      const runFrom = this.seriesRunPriceFrom;

      //Taking the lot, or taking enough of them, is charged at the run price.
      total += (mode == "ALL" || (runFrom > 0 && dates >= runFrom))
        ? people * runPrice
        : people * (Number(adm.persessionprice) || 0) * dates;
    });

    return Math.round(total * 100) / 100;
  }

  //An estimate for staff while choosing.
  get seriesEstimate(): number {
    if(this.seriesMode == "BLOCK")
    {
      const block = this.seriesChosenBlock;

      return block == null ? 0 : this.seriesBlockPrice(block);
    }

    return this.seriesPriceFor(this.seriesMode, this.seriesChosenDates.length);
  }

  //What all the dates would cost for the admissions chosen, shown on the All dates choice.
  get seriesAllDatesPrice(): number {
    return this.seriesPriceFor("ALL", this.seriesDates.length);
  }

  //What one date costs for the admissions chosen, shown on the Choose dates choice.
  get seriesPerDatePrice(): number {
    return this.seriesPriceFor("SOME", 1);
  }

  get seriesCanHold(): boolean {
    if(this.seriesHolding || this.seriesMode == "")
    {
      return false;
    }

    if(this.seriesChosenDates.length == 0 || this.seriesUnresolved > 0)
    {
      return false;
    }

    if(this.seriesMode == "BLOCK")
    {
      const block = this.seriesChosenBlock;

      return block != null && block.available;
    }

    return this.seriesMode == "SOME" || this.seriesFullDates.length == 0;
  }

  seriesTrackTime(index: number, option: { time: string }): string {
    return option.time;
  }

  private seriesMinutes(time: string): number {
    const parts = (time ?? "0:0").split(":");

    return Number(parts[0]) * 60 + Number(parts[1]);
  }

  //A date's free times, nearest to the preferred time first.
  seriesAlternatives(item: seriesdate): AvailableTimes[] {
    if(this.seriesPreferredTime == "")
    {
      return item.times;
    }

    const preferred = this.seriesMinutes(this.seriesPreferredTime);

    return [...item.times].sort((one, two) =>
      (Math.abs(this.seriesMinutes(one.timeString) - preferred) - Math.abs(this.seriesMinutes(two.timeString) - preferred))
      || one.timeString.localeCompare(two.timeString));
  }

  //The same request getAvailability sends, for one of the package's dates.
  private seriesAvailabilityRequest(date: string): AvailabilityReq {
    return {
      ...this.AvailabilityReq,
      Admissions: [...this.SelectedAdmissions],
      packageId: this.SelectedPackage.packageId,
      venueid: this.VenueID,
      StartTime: date.substring(0, 10) + "T00:00:00.000Z",
      DiagnosticMode: true,
      Resources: this.customerSelectedResources,
      useintervalavailability: this.UseIntervalAvailability
    } as AvailabilityReq;
  }

  //Why a date came back with nothing bookable. The availability call answers with a slot per time
  //and a Reason on the ones it turned down, so that is repeated rather than guessed at.
  private seriesReason(times: AvailableTimes[], packageTimes: string[]): string {
    const offered = times ?? [];

    if (offered.length == 0) {
      return "Availability returned no times at all for this date.";
    }

    const free = offered.filter(slot => slot.timeAvailable);

    if (free.length == 0) {
      //Every time was turned down, so say why. The same reason usually applies to all of them.
      const reasons = Array.from(new Set(offered.map(slot => (slot.Reason ?? "").toString().trim()).filter(r => r != "")));

      return reasons.length == 0
        ? "Every time on this date is full."
        : "Every time on this date is unavailable: " + reasons.join("; ");
    }

    //Times were free, just not the ones this package runs at. Worth spelling out, because it
    //means the package's repeat times and the times the venue offers do not line up.
    return "This package runs at " + packageTimes.join(", ")
      + " on this date, but availability offered " + Array.from(new Set(free.map(slot => slot.timeString))).sort().join(", ")
      + ".";
  }

  //Free times only, each time once, earliest first - as startTimesFiltered is built for one date -
  //and only the times the package runs at on that date. The package's Start Times aren't used.
  private seriesFreeTimes(times: AvailableTimes[], packageTimes: string[]): AvailableTimes[] {
    const seen = new Set<string>();
    const free: AvailableTimes[] = [];

    (times ?? []).forEach(slot => {
      if(slot.timeAvailable && packageTimes.includes(slot.timeString) && !seen.has(slot.timeString))
      {
        seen.add(slot.timeString);
        free.push(slot);
      }
    });

    return free.sort((one, two) => one.timeString.localeCompare(two.timeString));
  }

  private fetchSeriesTimes(item: seriesdate, done: () => void)
  {
    this.http.post<availabletimes_returndata>(bmxurl + "/Availability", item.request).subscribe(response => {
      if (!response.succeeded) {
        item.times = [];
        item.reason = (response.messages ?? []).join("; ") || "The availability check failed for this date.";
        done();
        return;
      }

      item.times = this.seriesFreeTimes(response.data, item.packageTimes);
      item.reason = item.times.length > 0 ? "" : this.seriesReason(response.data, item.packageTimes);
      done();
    }, () => {
      item.times = [];
      item.reason = "The availability check could not be reached for this date.";
      this.messageService.add({severity:'error', summary:'Error', detail: 'Availability could not be checked for ' + item.date.substring(0, 10) + '.'});
      done();
    });
  }

  //Checks every upcoming date of the package at once, in place of the single date's times.
  loadSeriesAvailability()
  {
    this.seriesMode = "";
    this.seriesPreferredTime = "";
    this.seriesBookings = [];
    this.seriesId = null;
    this.seriesRecord = null;

    const today = this.seriesTodayString();

    //Each repeat date carries a time, and a day can have several. One entry per day, holding that
    //day's times. The date picked on the first step isn't used.
    const timesByDay = new Map<string, string[]>();

    [...(this.SelectedPackage.repeatdates ?? [])].sort().forEach(value => {
      const day = value.substring(0, 10);

      if(day >= today)
      {
        timesByDay.set(day, [...(timesByDay.get(day) ?? []), value.substring(11, 16)]);
      }
    });

    this.seriesDates = Array.from(timesByDay.entries()).map(([day, times]) => ({
      date: day + "T00:00:00.000Z",
      packageTimes: times,
      times: [],
      chosen: null,
      ticked: false,
      held: null,
      heldResponse: null,
      failed: false,
      reason: "",
      request: this.seriesAvailabilityRequest(day)
    }));

    //doneAdmissions went busy before coming here; this is the matching idle.
    if(this.seriesDates.length == 0)
    {
      this.busyService.idle();
      return;
    }

    this.seriesLoading = true;
    let waiting = this.seriesDates.length;

    this.seriesDates.forEach(item => {
      this.fetchSeriesTimes(item, () => {
        waiting--;

        if(waiting == 0)
        {
          //Every date has answered, so which blocks are whole can now be worked out.
          this.buildSeriesBlocks();
          this.seriesLoading = false;
          this.busyService.idle();
        }
      });
    });
  }

  //Changing how the series is booked lets go of anything already held for it.
  private resetSeriesHolds()
  {
    if(this.isSeriesBooking)
    {
      this.AbandonBooking();
      this.NewBooking = {} as booking;
    }
    else
    {
      this.abandonSeriesBookings();
    }
  }

  chooseSeriesMode(mode: string)
  {
    if(mode == this.seriesMode || (mode == "ALL" && !this.seriesAllAllowed))
    {
      return;
    }

    this.resetSeriesHolds();

    this.seriesMode = mode;
    this.seriesPreferredTime = "";

    this.seriesDates.forEach(item => {
      item.chosen = null;
      item.ticked = false;
      item.failed = false;
    });
  }

  chooseSeriesPreferredTime(time: string)
  {
    this.seriesPreferredTime = time;

    this.seriesDates.forEach(item => {
      if(item.held == null)
      {
        item.chosen = item.times.find(slot => slot.timeString == time) ?? null;
        item.failed = false;
      }
    });
  }

  chooseSeriesTime(item: seriesdate, slot: AvailableTimes)
  {
    if(item.held == null)
    {
      item.chosen = slot;
      item.failed = false;
    }
  }

  toggleSeriesDate(item: seriesdate)
  {
    if(item.times.length == 0 || item.held != null)
    {
      return;
    }

    //Untick always allowed; ticking stops at the package's limit.
    if(!item.ticked && this.seriesAtMaxDates)
    {
      this.messageService.add({
        severity: 'warn',
        summary: 'That is the most you can take',
        detail: 'This package allows up to ' + this.seriesMaxDates + ' dates. Untick one to choose a different date.'
      });
      return;
    }

    item.ticked = !item.ticked;

    if(!item.ticked)
    {
      item.chosen = null;
    }
  }

  //A date with no times left means all the dates can't be booked, so the booking moves to Choose
  //dates, keeping the times already picked and showing the new price before anything is held.
  switchSeriesToSome()
  {
    this.resetSeriesHolds();

    this.seriesMode = "SOME";

    this.seriesDates.forEach(item => {
      item.ticked = item.times.length > 0;

      if(!item.ticked)
      {
        item.chosen = null;
      }
    });
  }

  //Every date ticked on Choose dates: offer the all-dates price instead.
  switchSeriesToAll()
  {
    if(!this.seriesAllAllowed)
    {
      return;
    }

    this.resetSeriesHolds();

    this.seriesMode = "ALL";
    this.seriesPreferredTime = this.seriesDates.find(item => item.chosen != null)?.chosen?.timeString ?? "";
  }

  holdSeriesDates()
  {
    if(!this.seriesCanHold)
    {
      return;
    }

    const toHold = this.seriesChosenDates.filter(item => item.held == null);

    if(toHold.length == 0)
    {
      this.afterSeriesHeld();
      return;
    }

    //The hold timer starts with the first date held, not while staff were still choosing.
    if(!this.seriesDates.some(item => item.held != null))
    {
      this.seriesId = uuidv4();
      this.restartTimer(this.SelectedPackage.bookingtimeout);
      this.showTimer = true;
      this.PBWStartTime = new Date();
    }

    this.SelectedPackage.resources.forEach(res => {
      res.admissions = this.SelectedAdmissions;
    });

    this.seriesHolding = true;
    this.busyService.busy();
    this.holdSeriesDate(toHold, 0);
  }

  //One date at a time, each as bookSlot holds a single date, tagged with the series.
  private holdSeriesDate(toHold: seriesdate[], index: number)
  {
    if(index >= toHold.length)
    {
      this.seriesHolding = false;
      this.busyService.idle();
      this.afterSeriesHeld();
      return;
    }

    const item = toHold[index];
    const slot = item.chosen;

    const heldBooking: any = {
      bookingIdHR: null,
      venuedate: this.VenueID + "_" + slot.time.toString().substring(0, 10).replace(/-/g, ""),
      packageId: this.SelectedPackage.packageId,
      guests: 0,
      startTime: slot.time,
      PackageName: this.SelectedPackage.name,
      venueId: this.VenueID,
      payments: null,
      customer: null,
      resources: slot.resources,
      Disabled: false,
      outstanding: 0,
      name: "",
      inProgress: true,
      availabilityreq: item.request,
      initialbooking: true,
      salestype: 0,
      currency: this.CurrencySymbol,
      bookingtimeout: this.SelectedPackage.bookingtimeout == 0 ? 300 : this.SelectedPackage.bookingtimeout,
      seriesid: this.seriesId,
      seriestype: this.seriesMode,
      seriesblockid: this.seriesMode == "BLOCK" ? this.seriesChosenBlockId : null
    };

    (heldBooking.resources ?? []).forEach(res => {
      res.inProgress = true;
    });

    this.http.post<booking_returndata>(bmxurl + "/savebooking", heldBooking).subscribe(response => {
      if(response.succeeded)
      {
        item.heldResponse = response.data;
        item.held = (response.data as any).bookingObj;
        item.failed = false;
        this.holdSeriesDate(toHold, index + 1);
        return;
      }

      this.holdFailedOn(item, toHold, index);
    }, () => {
      this.holdFailedOn(item, toHold, index);
    });
  }

  //One date could not be held. For a block that ends the whole thing - a half-held block is
  //exactly what a block is meant to prevent - so everything already taken is let go and the
  //customer is put back to choosing. For the other modes only that date goes back, as before.
  private holdFailedOn(item: seriesdate, toHold: seriesdate[], index: number)
  {
    if(this.seriesMode != "BLOCK")
    {
      this.seriesHoldFailed(item);
      this.holdSeriesDate(toHold, index + 1);
      return;
    }

    const block = this.seriesChosenBlock;
    const takenMeanwhile = item.date.substring(8, 10) + "/" + item.date.substring(5, 7);

    //Let go of every date of this block that was taken before the one that failed.
    this.abandonSeriesBookings();

    this.seriesHolding = false;
    this.busyService.idle();
    this.seriesMode = "";
    this.seriesChosenBlockId = "";

    this.messageService.add({
      severity: 'warn',
      summary: 'Run no longer free',
      detail: takenMeanwhile + ' was taken while the run was being held, so '
        + (block == null ? 'the run' : block.name) + ' has been let go. Nothing has been booked - choose another run.'
    });

    //The times are read again so the blocks on screen show what is actually left.
    this.refreshSeriesAvailability();
  }

  //Re-checks every date and works the blocks out again, without disturbing what has been chosen
  //elsewhere on the booking.
  private refreshSeriesAvailability()
  {
    if(this.seriesDates.length == 0)
    {
      return;
    }

    this.seriesLoading = true;
    this.busyService.busy();

    let waiting = this.seriesDates.length;

    this.seriesDates.forEach(item => {
      item.chosen = null;
      item.ticked = false;

      this.fetchSeriesTimes(item, () => {
        waiting--;

        if(waiting == 0)
        {
          this.buildSeriesBlocks();
          this.seriesLoading = false;
          this.busyService.idle();
        }
      });
    });
  }

  //Someone else took the time between checking and holding. Only this date goes back to choosing,
  //with fresh times; the dates already held stay held.
  private seriesHoldFailed(item: seriesdate)
  {
    item.failed = true;
    item.chosen = null;
    this.fetchSeriesTimes(item, () => {});
  }

  private afterSeriesHeld()
  {
    const chosen = this.seriesChosenDates;
    const waiting = chosen.filter(item => item.held == null).length;

    if(waiting > 0)
    {
      this.messageService.add({severity:'warn', summary:'Choose another time', detail: waiting + (waiting == 1 ? ' date was' : ' dates were') + ' taken by someone else while you were choosing. Pick another time, then hold the dates again.'});
      return;
    }

    const lead = chosen[0];

    this.seriesBookings = chosen.map(item => item.held);
    this.NewBooking = lead.held;
    this.BookingResponse = lead.heldResponse;
    this.globalTimeSlot = lead.chosen;

    const leadDate = lead.date.substring(0, 10).split("-");
    this.SelectedDate = new Date(Number(leadDate[0]), Number(leadDate[1]) - 1, Number(leadDate[2]));

    this.TimeHeader = "You selected: " + chosen.length + (chosen.length == 1 ? " date" : " dates");

    //The date picked on the first step isn't used for a repeatable package - its own dates are.
    const lastDate = chosen[chosen.length - 1].date.substring(0, 10).split("-");
    const shortDate = (parts: string[]) => new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2])).toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
    this.CalendarHeader = "Package dates: " + shortDate(leadDate) + (chosen.length > 1 ? " to " + shortDate(lastDate) : "");

    //Extras are offered by day of the week, so work them out for the first booked date rather than
    //the date picked on the first step.
    this.refilterSeriesExtras();

    this.refreshSeriesTotals();
    this.stampSeries();
    this.upgradesComplete = true;

    //Every date now exists, so the API can give the series' value. The figures above stand until it does.
    this.loadSeriesRecord(() => {});

    //Where bookSlot goes next, without upgrades: they aren't offered on repeatable packages yet.
    if(this.packageExtras.length == 0 && this.SelectedPackage.questionnaire == null)
    {
      this.setTab(Sections.Customer);
    }
    else if(this.SelectedPackage.questionnaire != null)
    {
      this.setTab(Sections.BookingQuestions);
    }
    else
    {
      this.setTab(Sections.Extras);
    }
  }

  //The sales value and what's due now, across every date. The first date is read from NewBooking,
  //which the later steps keep replacing with what the API sends back.
  private refreshSeriesTotals()
  {
    if(!this.isSeriesBooking)
    {
      return;
    }

    let total = 0;
    let due = 0;

    if(this.seriesRecord != null)
    {
      //The API's series record is the one place the money across every date is kept, so its total
      //is used as it is. What's due now is the deposit still owed - never more than the series owes.
      total = Number(this.seriesRecord.total) || 0;
      due = this.seriesDepositDue();
      due = Math.max(0, Math.min(due, Number(this.seriesRecord.outstanding) || 0));
    }
    else
    {
      const bookings = [this.NewBooking, ...this.seriesBookings.slice(1)];

      bookings.forEach((item: any) => {
        total += Number(item.total) || 0;

        const deposit = item.PublicBooking ? item.totalpublicdeposit : item.totalvenuedeposit;
        due += (Number(deposit) || 0) - (Number(item.totalpayments) || 0);
      });
    }

    this.paymentAmount = Math.round(total * 100) / 100;
    this.validPaymentAmount = Math.round(due * 100) / 100;

    const formatter = new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: this.CurrencySymbol});

    this.makeABookingHeader = "Make a Booking - Sales Value: " + formatter.format(this.paymentAmount);
  }

  //What the whole series still owes: its record's outstanding, or every date's own outstanding
  //added up when the record couldn't be had.
  seriesOutstanding(): number
  {
    if(this.seriesRecord != null)
    {
      return Math.round((Number(this.seriesRecord.outstanding) || 0) * 100) / 100;
    }

    const bookings: any[] = [this.NewBooking, ...this.seriesBookings.slice(1)];
    const owed = bookings.reduce((running, item: any) => running + (Number(item.outstanding) || 0), 0);

    return Math.round(owed * 100) / 100;
  }

  //The deposit still owed on the whole series. The series record carries its own, and - as with a
  //single booking's totalvenuedeposit - it is already net of what has been paid, so it is used as
  //it is and never has the payments taken off again. Only when the record has no deposit of its own
  //is it worked out: every date's deposit added up, less what the series has been paid.
  private seriesDepositDue(): number
  {
    const ownDeposit = this.NewBooking?.PublicBooking ? this.seriesRecord?.totalpublicdeposit : this.seriesRecord?.totalvenuedeposit;

    if(ownDeposit != null && !isNaN(Number(ownDeposit)))
    {
      return Math.round(Number(ownDeposit) * 100) / 100;
    }

    const recordBookings = this.seriesRecord?.bookings ?? [];
    const bookings: any[] = recordBookings.length > 0 ? recordBookings : [this.NewBooking, ...this.seriesBookings.slice(1)];

    const deposits = bookings.reduce((running, item: any) => {
      const deposit = item.PublicBooking ? item.totalpublicdeposit : item.totalvenuedeposit;
      return running + (Number(deposit) || 0);
    }, 0);

    const paid = Number(this.seriesRecord?.totalpayments) || 0;

    return Math.round((deposits - paid) * 100) / 100;
  }

  //Pays the series as a whole: POST /SeriesPayment takes the series id and the one payment, and the
  //API shares it across the dates. The payment is made out to the series rather than to a booking,
  //because it belongs to every date and not the first.
  private makeSeriesPayment(newPayment: Payment)
  {
    newPayment.BookingId = null;
    newPayment.bookingIdHR = (this.seriesRecord as any)?.seriesidhr ?? (this.NewBooking as any).seriesidhr ?? null;
    newPayment.seriesid = this.seriesId;
    newPayment.isseriespayment = true;

    const seriesPayment: seriespayment = {
      seriesid: this.seriesId,
      payment: newPayment
    };

    this.busyService.busy();

    this.http.post<booking_returndata>(bmxurl + "/SeriesPayment", seriesPayment).subscribe(response => {
      this.busyService.idle();

      if(response.succeeded != true)
      {
        this.messageService.add({severity:'error', summary:'Error', detail: (response as any).messages?.[0] ?? 'The payment could not be taken.'});
        this.paymentButtonLocked = false;
        return;
      }

      //Sent back as the series, which is the freshest copy of what has been paid.
      if(response.data?.seriesid != null)
      {
        this.seriesRecord = response.data;
      }

      //The series payment pays and completes every date itself, so nothing is sent to the bookings
      //here - the series is only read again for what each date and the series now stand at.
      this.loadSeriesRecord(() => {
        setTimeout(() => {
          this.paymentButtonLocked = false;
        }, 1000);

        this.takeSeriesRecordBookings();

        this.BookingPayments = this.seriesRecord?.payments ?? this.NewBooking.payments ?? [];
        this.totalPayments = this.BookingPayments.reduce((running, item) => running + (Number(item.amount) || 0), 0);

        //Paid enough when no deposit is still owed on the series, or it owes nothing at all.
        if(this.seriesDepositDue() <= 0 || this.seriesOutstanding() <= 0)
        {
          this.DoSummary(this.NewBooking);
          return;
        }

        //Otherwise stay on payment with the rest of the deposit, or what is owed once it's covered.
        this.refreshSeriesTotals();

        if(!(this.validPaymentAmount > 0))
        {
          this.validPaymentAmount = this.seriesOutstanding();
        }
      });
    }, error => {
      this.busyService.idle();
      this.messageService.add({severity:'error', summary:'Error', detail: error.message});
      this.paymentButtonLocked = false;
    });
  }

  //Swaps the copies of each date held here for the ones in the series record, matched by booking
  //id, so the first date and the summary's list of dates show what the series payment did to them.
  private takeSeriesRecordBookings()
  {
    const fresh = this.seriesRecord?.bookings ?? [];

    if(fresh.length == 0)
    {
      return;
    }

    const byId = new Map<string, any>();
    fresh.forEach((item: any) => byId.set(item.bookingId, item));

    this.seriesBookings = this.seriesBookings.map(item => byId.get(item?.bookingId) ?? item);

    const lead = byId.get(this.NewBooking?.bookingId);

    if(lead != null)
    {
      this.NewBooking = lead;
      this.BookingResponse = lead;
      this.stampSeries();
    }
  }

  //Puts what was typed on the Notes step onto the series with PUT /SeriesBooking - the series keeps
  //one set of notes for every date. Never holds the booking up: a failure is only reported, and the
  //notes can be added on Edit Series afterwards.
  private saveSeriesNotes(done: () => void)
  {
    if(this.seriesRecord == null)
    {
      this.messageService.add({severity:'warn', summary:'Notes not saved to the series', detail:'The series could not be read, so its notes were not saved. Add them on Edit Series once the booking is made.'});
      done();
      return;
    }

    const updated: seriesbooking = { ...this.seriesRecord, notes: this.NewBooking.notes ?? "" };

    this.busyService.busy();

    this.http.put<any>(bmxurl + "SeriesBooking", updated).subscribe(response => {
      this.busyService.idle();

      if(response?.succeeded === false)
      {
        this.messageService.add({severity:'warn', summary:'Notes not saved to the series', detail:'Add them on Edit Series once the booking is made.'});
      }
      else
      {
        this.seriesRecord = updated;
      }

      done();
    }, () => {
      this.busyService.idle();
      this.messageService.add({severity:'warn', summary:'Notes not saved to the series', detail:'Add them on Edit Series once the booking is made.'});
      done();
    });
  }

  //POST /SeriesVoucherValidate puts the voucher against the series as a whole. The series is then
  //read again: if the voucher has covered the deposit (or everything), the booking is finished
  //without a payment, as a single booking is; otherwise what is still due goes in the payment box.
  private sendSeriesVoucher()
  {
    const pin = Number((this.voucherpin ?? "").toString().trim());

    if((this.voucherCode ?? "").trim() == "" || isNaN(pin))
    {
      this.messageService.add({ severity: 'error', summary: 'Not Added', detail: 'Enter the gift voucher code and its PIN.' });
      return;
    }

    const request: seriesvouchervalidate = {
      vouchercode: this.voucherCode.trim(),
      voucherpin: pin,
      venueid: this.VenueID,
      seriesid: this.seriesId
    };

    this.busyService.busy();

    this.http.post<any>(bmxurl + "/SeriesVoucherValidate", request).subscribe(response => {
      this.busyService.idle();

      if(response?.succeeded !== true)
      {
        this.messageService.add({ severity: 'error', summary: 'Not Added', detail: response?.messages?.[0] ?? 'The voucher could not be used.' });
        return;
      }

      this.messageService.add({ severity: 'success', summary: 'Voucher Added', detail: 'Your voucher has been added' });
      this.showVoucher = false;
      this.voucherCode = "";
      this.voucherpin = "";

      this.loadSeriesRecord(() => {
        this.takeSeriesRecordBookings();

        this.BookingPayments = this.seriesRecord?.payments ?? this.BookingPayments;
        this.totalPayments = (this.BookingPayments ?? []).reduce((running, item) => running + (Number(item.amount) || 0), 0);

        if(this.seriesRecord != null && (this.seriesDepositDue() <= 0 || this.seriesOutstanding() <= 0))
        {
          this.completeWithoutPayment();
          return;
        }

        if(!(this.validPaymentAmount > 0))
        {
          this.validPaymentAmount = this.seriesOutstanding();
        }
      });
    }, error => {
      this.busyService.idle();
      this.messageService.add({ severity: 'error', summary: 'Not Added', detail: error?.error?.messages?.[0] ?? error?.message });
    });
  }

  //Puts a discount on the series, then reads the series again for what is now due. When the
  //discount leaves nothing owing, the booking is finished without a payment, as for one booking.
  private sendSeriesDiscount(endpoint: string, request: any)
  {
    this.busyService.busy();

    this.http.post<any>(bmxurl + endpoint, request).subscribe(response => {
      this.busyService.idle();

      if(response?.succeeded !== true)
      {
        this.messageService.add({ severity: 'error', summary: 'Not Added', detail: response?.messages?.[0] ?? 'The discount could not be added.' });
        return;
      }

      this.messageService.add({ severity: 'success', summary: 'Discount Added', detail: 'Your discount has been added' });
      this.showDiscount = false;
      this.discountCode = "";
      this.chosenDiscountAmount = 0;

      this.loadSeriesRecord(() => {
        this.takeSeriesRecordBookings();

        if(this.seriesRecord != null && this.seriesOutstanding() <= 0)
        {
          this.completeWithoutPayment();
          return;
        }

        if(!(this.validPaymentAmount > 0))
        {
          this.validPaymentAmount = this.seriesOutstanding();
        }
      });
    }, error => {
      this.busyService.idle();
      this.messageService.add({ severity: 'error', summary: 'Not Added', detail: error?.message });
    });
  }

  //Fetches the API's record of the whole series and refreshes the figures from it. Always carries
  //on, even when the record can't be had, because the figures can still be added up from the dates.
  private loadSeriesRecord(done: () => void)
  {
    if(!this.isSeriesBooking || this.seriesId == null)
    {
      done();
      return;
    }

    this.busyService.busy();

    this.http.get<any>(bmxurl + "SeriesBooking/" + this.VenueID + "/" + this.seriesId).subscribe(response => {
      this.busyService.idle();

      //Sent either wrapped like the other endpoints or as the record itself.
      const record: seriesbooking = response?.data !== undefined ? response.data : response;

      if(response?.succeeded === false || record == null || record.seriesid == null)
      {
        this.seriesRecord = null;
      }
      else
      {
        this.seriesRecord = record;
      }

      this.refreshSeriesTotals();
      done();
    }, () => {
      this.busyService.idle();
      this.seriesRecord = null;
      done();
    });
  }

  //The API needs to know a booking belongs to a series when it is paid for or finished, so it can
  //share the payment and finish every date. Set again just before each of those calls, because
  //NewBooking is replaced by whatever the API sends back, which won't carry the id until the API
  //stores it.
  private stampSeries()
  {
    if(!this.isSeriesBooking)
    {
      return;
    }

    this.NewBooking.seriesid = this.seriesId;
    this.NewBooking.seriestype = this.seriesMode;
    this.NewBooking.seriesblockid = this.seriesMode == "BLOCK" ? this.seriesChosenBlockId : null;
  }

  //Every date of a series is a booking in its own right, and a booking left in progress is swept
  //away as abandoned - which is why the later dates were being disabled. So finishing the first
  //date has to finish them all. Shares is what each date is paid, index 0 being the first date,
  //which the caller has already paid; pass null when no money is being taken.
  private finishSeriesSiblings(shares: number[], method: string, paymenttypeid: string, flags: any, done: () => void)
  {
    const others = this.seriesBookings.slice(1);

    if(!this.isSeriesBooking || others.length == 0)
    {
      done();
      return;
    }

    this.busyService.busy();

    let waiting = others.length;
    let failed = 0;

    const finishedOne = () => {
      waiting--;

      if(waiting > 0)
      {
        return;
      }

      this.busyService.idle();

      if(failed > 0)
      {
        this.messageService.add({severity:'error', summary:'Some dates were not completed', detail: failed + (failed == 1 ? ' date' : ' dates') + ' could not be completed and may be cancelled automatically. Open the booking and check every date.'});
      }

      done();
    };

    others.forEach((sibling, index) => {
      const share = shares == null ? 0 : (shares[index + 1] ?? 0);

      const toFinish: any = {
        ...sibling,
        inProgress: false,
        seriesid: this.seriesId,
        seriestype: this.seriesMode,
        awaitingpayment: flags?.awaitingpayment == true,
        deferredpayment: flags?.deferredpayment == true,
        //Only new payments go to /Payment, so a date with no share of the money is sent none.
        payments: null
      };

      if(share > 0)
      {
        toFinish.payments = [{
          id: null,
          PaymentId: null,
          BookingId: sibling.bookingId,
          bookingIdHR: sibling.bookingIdHR,
          method: method,
          paymenttypeid: paymenttypeid,
          amount: share,
          paymentDate: new Date,
          disabled: false,
          venueid: this.VenueID,
          refunds: null,
          balance: share,
          paymenttype: "booking",
          currency: this.CurrencySymbol,
          tillname: null
        }];
      }

      this.http.post<booking_returndata>(bmxurl + "/Payment", toFinish).subscribe(response => {
        if(response.succeeded)
        {
          this.seriesBookings[index + 1] = response.data;
        }
        else
        {
          failed++;
        }

        finishedOne();
      }, () => {
        failed++;
        finishedOne();
      });
    });
  }

  //Copies what was set up on the first date onto every other date, then carries on.
  private syncSeriesBookings(done: () => void)
  {
    const others = this.seriesBookings.slice(1);

    if(others.length == 0)
    {
      done();
      return;
    }

    this.busyService.busy();

    let waiting = others.length;
    let failed = 0;

    others.forEach((sibling, index) => {
      this.syncSeriesBooking(sibling, updated => {
        if(updated != null)
        {
          this.seriesBookings[index + 1] = updated;
        }
        else
        {
          failed++;
        }

        waiting--;

        if(waiting == 0)
        {
          this.busyService.idle();

          if(failed > 0)
          {
            this.messageService.add({severity:'error', summary:'Not every date was updated', detail: failed + (failed == 1 ? ' date' : ' dates') + ' could not be given the customer, extras and answers. Press Next again to retry.'});
            return;
          }

          done();
        }
      });
    });
  }

  //Extras first, because saving them re-prices the booking; then customer and notes; then answers.
  private syncSeriesBooking(sibling: any, finished: (updated: any) => void)
  {
    const saveCustomerAndAnswers = (current: any) => {
      //A copy, sent the way a chosen customer first is - without the first date's booking id on it.
      current.customer = this.NewBooking.customer == null ? null : { ...this.NewBooking.customer, bookingid: null };
      current.notes = this.NewBooking.notes;
      current.seriesid = this.seriesId;
      current.seriestype = this.seriesMode;

      this.http.post<booking_returndata>(bmxurl + "/savebooking", current).subscribe(saveResponse => {
        if(!saveResponse.succeeded)
        {
          finished(null);
          return;
        }

        const saved = (saveResponse.data as any).bookingObj;

        if(this.SelectedPackage.questionnaire == null)
        {
          finished(saved);
          return;
        }

        const answers = JSON.parse(JSON.stringify(this.SelectedPackage.questionnaire));
        answers.bookingid = saved.bookingId;

        //Each person row gets its own id on each date, rather than every date sharing the first
        //date's ids.
        (answers.bookingquestions ?? []).forEach(question => {
          (question.answers?.birthdayanswers ?? []).forEach(row => {
            row.id = uuidv4();
          });
        });

        this.http.post<booking_returndata>(bmxurl + "/questionanswers", answers).subscribe(answerResponse => {
          finished(answerResponse.succeeded ? saved : null);
        }, () => finished(null));
      }, () => finished(null));
    };

    if(!this.PackageHasExtras)
    {
      saveCustomerAndAnswers(sibling);
      return;
    }

    const withExtras = {
      ...sibling,
      extras: this.NewBooking.extras == null ? null : JSON.parse(JSON.stringify(this.NewBooking.extras)),
      salestype: 0
    };

    this.http.post<booking_returndata>(bmxurl + "/BookingExtra", withExtras).subscribe(extraResponse => {
      if(!extraResponse.succeeded)
      {
        finished(null);
        return;
      }

      saveCustomerAndAnswers(extraResponse.data);
    }, () => finished(null));
  }

  //Lets go of every held date of the series except the one that is NewBooking, which
  //AbandonBooking lets go of itself.
  private abandonSeriesBookings()
  {
    const leadId = this.NewBooking?.bookingId;

    this.seriesDates.forEach(item => {
      const heldId = item.held?.bookingId;

      if(heldId != null && heldId != leadId)
      {
        this.http.post(bmxurl + "abandonbooking/" + this.VenueID, { bookingid: heldId, jwt: null }).subscribe(() => {}, () => {
          this.messageService.add({ severity: 'error', summary: 'Failure', detail: 'Failed to abandon booking.' });
        });
      }

      item.held = null;
      item.heldResponse = null;
    });

    this.seriesBookings = [];
    this.seriesId = null;
    this.seriesRecord = null;
  }

  AbandonBooking() {
    this.abandonSeriesBookings();

    if (this.NewBooking != null && this.NewBooking.bookingId != null) {
      if (this.NewBooking.bookingId != null) {
        let abandonBooking: any = {
          bookingid: this.NewBooking.bookingId,
          jwt: null
        };
        //Booking Exists, abandon it
        this.http.post(bmxurl + "abandonbooking/" + this.VenueID, abandonBooking).subscribe(response => {
        }, error => {
          this.messageService.add({ severity: 'error', summary: 'Failure', detail: 'Failed to abandon booking.' });
        });
      }
    }
  }

  getAvailability(){
    this.busyService.busy();
    let totalNoOfPeople: number = 0;

    this.AvailabilityReq.Admissions = [] as admission[];

     this.SelectedAdmissions.forEach(adm => {
    
       this.AvailabilityReq.Admissions.push(adm);
      //totalNoOfPeople += adm.noofpeople;
      
    });

    this.AvailabilityReq.packageId = this.SelectedPackage.packageId;
    //AvailabilityReq.NoOfPeople =  totalNoOfPeople;
    this.AvailabilityReq.venueid = this.VenueID;
    this.AvailabilityReq.StartTime =  this.SelectedDate.getFullYear() + "-" +  (this.SelectedDate.getMonth() + 1) + "-" +  this.SelectedDate.getDate() + "T00:00:00.000Z";
    this.AvailabilityReq.DiagnosticMode = true;
    this.AvailabilityReq.Resources = this.customerSelectedResources;
    this.AvailabilityReq.useintervalavailability = this.UseIntervalAvailability;

    this.http.post<availabletimes_returndata>(bmxurl + "/Availability", this.AvailabilityReq).subscribe(response => {
      if((response as availabletimes_returndata).succeeded)
      {
        this.startTimes =(response as availabletimes_returndata).data
        let found: Boolean = false;

      this.startTimesFiltered = [];
        this.startTimes.forEach(element => {
          if(element.timeAvailable)
          {
            this.startTimesFiltered.forEach(innerelement => {
              if(innerelement.time == element.time)
                found = true;
            });

            if(!found)
            {
              this.startTimesFiltered.push(element);
            }
            found = false;
          }
        });

        if(this.timetobetried != "")
        {
          let timefound = false;

          this.startTimes.forEach(element => {
            //let timetocheck = new Date(element.time);
            //let sTimetocheck = timetocheck.getHours().toString().padStart(2, '0') + ":" + timetocheck.getMinutes().toString().padStart(2, '0');
            
            if(element.timeString == this.timetobetried && element.timeAvailable)
            {
              timefound = true;
              this.timetobetried = "";
              this.bookSlot(element);
            }
          });

          if(!timefound){
            this.messageService.add({severity:'error', summary:'Error', detail: "The time you selected in 'Book this time' is no longer available. Please select another time."});
          }
        }

        if (this.startTimesFiltered.length > 0) {
          this.pendingScrollToFirstTime = true;
        }

        this.busyService.idle();
    }
    else
    {
      this.messageService.add({severity:'error', summary:'Error', detail: (response as availabletimes_returndata).messages[0]});
      this.busyService.idle();
    }

    }, error => {
      this.busyService.idle();
  })
  this.busyService.idle();

  }

  getOptionalUpgradeAvailability(packageabupgrades: packageabupgrade[], startTime: string)
  {

    this.availablePackageOptionalUpgrades = [];
   // this.busyService.busy();

    let totalNoOfPeople: number = 0;

    this.AvailabilityReq.Admissions = [] as admission[];

    this.SelectedAdmissions.forEach(adm => {
       this.AvailabilityReq.Admissions.push(adm);
    });

    this.AvailabilityReq.packageId = this.SelectedPackage.packageId;
    this.AvailabilityReq.venueid = this.VenueID;
    this.AvailabilityReq.DiagnosticMode = true;
    this.AvailabilityReq.StartTime = startTime;//this.SelectedDate.getFullYear() + "-" +  (this.SelectedDate.getMonth() + 1).toString().padStart(2, '0') + "-" +  this.SelectedDate.getDate().toString().padStart(2, '0') + "T"+ startTime + ":00.000Z";
    this.AvailabilityReq.IgnoreExistingBooking = true;
    this.AvailabilityReq.ExistingBookingID = this.NewBooking.bookingId;
    this.AvailabilityReq.useintervalavailability = this.UseIntervalAvailability;

    //First Upgrade
    if(packageabupgrades.length > 0)
    {  
      this.AvailabilityReq.Resources = [];//JSON.parse(JSON.stringify(this.customerSelectedResources)); 
      packageabupgrades[0].upgrade.resources.forEach(res => { 
        this.AvailabilityReq.Resources.push(res);
      });
      this.http.post<any>(bmxurl + "/Availability", this.AvailabilityReq).subscribe(response => {       
        if((response as any).succeeded)
        {
         if(response.data.length > 0 && response.data[0].timeAvailable)
         {
          packageabupgrades[0].upgrade.resources = [];

          response.data[0].resources.forEach(res => {
            if(res.isupgrade == true)   
            {
              packageabupgrades[0].quantityremaining = response.data[0].quantityRemaining;
              packageabupgrades[0].upgrade.resources.push(res);
            }
          });
            
          this.availablePackageOptionalUpgrades.push(packageabupgrades[0]);
          this.optioanlUpgradeavaibilitydone[0] = true;
          this.showOptionalUpgradesScreen = true;

          this.availablePackageOptionalUpgrades = this.availablePackageOptionalUpgrades.sort((a, b) => (a.order > b.order) ? 1 : -1);

          this.globalService.setOptionalUpgradesComplete(this.optioanlUpgradeavaibilitydone);
          this.globalService.showOptionalUpgradeScreen(this.showOptionalUpgradesScreen);

          this.setTab(Sections.OptionalUpgrades);
            
          this.busyService.idle();
         }
         else
         {
            this.busyService.idle();
            this.upgradeavaibilitydone[0] = true;
            this.showTheUpgradeScreen[0] = false;

            this.globalService.setUpgradesComplete(this.upgradeavaibilitydone);
            this.globalService.showUpgradeScreen(this.showTheUpgradeScreen);

            if(this.packageExtras.length == 0 && this.SelectedPackage.questionnaire == null)
            {
              this.setTab(Sections.Customer);
            }
            else if(this.SelectedPackage.questionnaire != null)
            {
              this.setTab(Sections.BookingQuestions);
            }
            else
            {
              this.setTab(Sections.Extras);
            }
         }
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Error', detail: (response as availabletimes_returndata).messages[0]});
          this.busyService.idle();
        }
      }, error => {
        this.busyService.idle();
      });
    }
    else
    {
      if(this.packageExtras.length == 0 && this.SelectedPackage.questionnaire == null)
      {
        this.setTab(Sections.Customer);
      }
      else if(this.SelectedPackage.questionnaire != null)
      {
        this.setTab(Sections.BookingQuestions);
      }
      else
      {
        this.setTab(Sections.Extras);
      }

      this.upgradeavaibilitydone[0] = true;
      this.upgradeavaibilitydone[1] = true;
      this.upgradeavaibilitydone[2] = true;
      
      this.showTheUpgradeScreen[0] = false;
      this.showTheUpgradeScreen[1] = false;
      this.showTheUpgradeScreen[2] = false;

       this.globalService.setOptionalUpgradesComplete(this.optioanlUpgradeavaibilitydone);
      this.globalService.showOptionalUpgradeScreen(this.showOptionalUpgradesScreen);

      this.showUpgrade = false;
      this.busyService.idle();
    }

    //Second Upgrade

    this.AvailabilityReq2.Admissions = [] as admission[];

    this.SelectedAdmissions.forEach(adm => {
       this.AvailabilityReq2.Admissions.push(adm);
    });

    this.AvailabilityReq2.packageId = this.SelectedPackage.packageId;
    this.AvailabilityReq2.venueid = this.VenueID;
    this.AvailabilityReq2.DiagnosticMode = true;
    this.AvailabilityReq2.StartTime = startTime;//this.SelectedDate.getFullYear() + "-" +  (this.SelectedDate.getMonth() + 1).toString().padStart(2, '0') + "-" +  this.SelectedDate.getDate().toString().padStart(2, '0') + "T"+ startTime + ":00.000Z";
    this.AvailabilityReq2.IgnoreExistingBooking = true;
    this.AvailabilityReq2.ExistingBookingID = this.NewBooking.bookingId;
    this.AvailabilityReq2.useintervalavailability = this.UseIntervalAvailability;


    if(packageabupgrades.length > 1)
    {  
      this.AvailabilityReq2.Resources = JSON.parse(JSON.stringify(this.customerSelectedResources)); 
      packageabupgrades[1].upgrade.resources.forEach(res1 => { 
        this.AvailabilityReq2.Resources.push(res1);
      });
      this.http.post<any>(bmxurl + "/Availability", this.AvailabilityReq2).subscribe(response => {       
        if((response as any).succeeded)
        {
          if(response.data.length > 0 && response.data[0].timeAvailable)
          {

            packageabupgrades[1].upgrade.resources = [];
  
            response.data[0].resources.forEach(res => {
              if(res.isupgrade == true)   
              {
                packageabupgrades[1].quantityremaining = response.data[0].quantityRemaining;
                packageabupgrades[1].upgrade.resources.push(res);
              }
            });
            
            // if(packageabupgrades[1].optional)
            // {
              this.availablePackageOptionalUpgrades.push(packageabupgrades[1]);

              this.availablePackageOptionalUpgrades = this.availablePackageOptionalUpgrades.sort((a, b) => (a.order > b.order) ? 1 : -1);

              this.upgradeavaibilitydone[1] = true;
              this.showTheUpgradeScreen[1] = true;
             
              this.globalService.setUpgradesComplete(this.optioanlUpgradeavaibilitydone);
              this.globalService.showUpgradeScreen(this.showOptionalUpgradesScreen);

              this.setTab(Sections.OptionalUpgrades);
            //}

            this.busyService.idle();
          }
          else
          {
            this.optioanlUpgradeavaibilitydone[1] = true;
            this.showOptionalUpgradesScreen = false;

            this.globalService.setOptionalUpgradesComplete(this.optioanlUpgradeavaibilitydone);
            this.globalService.showOptionalUpgradeScreen(this.showOptionalUpgradesScreen);

            this.busyService.idle();
          }
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Error', detail: (response as availabletimes_returndata).messages[0]});
          this.busyService.idle();
        }
      }, error => {
        this.busyService.idle();
      });
    }
    else
    {
      this.upgradeavaibilitydone[1] = true;
    }

    //Third Upgrade

    this.AvailabilityReq3.Admissions = [] as admission[];

    this.SelectedAdmissions.forEach(adm => {
       this.AvailabilityReq3.Admissions.push(adm);
    });

    this.AvailabilityReq3.packageId = this.SelectedPackage.packageId;
    this.AvailabilityReq3.venueid = this.VenueID;
    this.AvailabilityReq3.DiagnosticMode = true;
    this.AvailabilityReq3.StartTime = startTime;//this.SelectedDate.getFullYear() + "-" +  (this.SelectedDate.getMonth() + 1).toString().padStart(2, '0') + "-" +  this.SelectedDate.getDate().toString().padStart(2, '0') + "T"+ startTime + ":00.000Z";
    this.AvailabilityReq3.IgnoreExistingBooking = true;
    this.AvailabilityReq3.ExistingBookingID = this.NewBooking.bookingId;
    this.AvailabilityReq3.useintervalavailability = this.UseIntervalAvailability;

    if(packageabupgrades.length > 2)
    {  
      this.AvailabilityReq3.Resources = JSON.parse(JSON.stringify(this.customerSelectedResources)); 
      packageabupgrades[2].upgrade.resources.forEach(res2 => { 
        this.AvailabilityReq3.Resources.push(res2);
      });
      this.http.post<any>(bmxurl + "/Availability", this.AvailabilityReq3).subscribe(response => {       
        if((response as any).succeeded)
        {
          if(response.data.length > 0 && response.data[0].timeAvailable)
          {

            packageabupgrades[2].upgrade.resources = [];
  
            response.data[0].resources.forEach(res => {
              if(res.isupgrade == true)   
              {
                packageabupgrades[2].quantityremaining = response.data[0].quantityRemaining;
                packageabupgrades[2].upgrade.resources.push(res);
              }
            });

            // if(packageabupgrades[2].optional)
            // {
              this.availablePackageOptionalUpgrades.push(packageabupgrades[2]);

              this.availablePackageOptionalUpgrades = this.availablePackageOptionalUpgrades.sort((a, b) => (a.order > b.order) ? 1 : -1);

              this.optioanlUpgradeavaibilitydone[2] = true;
              this.showOptionalUpgradesScreen = false;

              this.globalService.setUpgradesComplete(this.optioanlUpgradeavaibilitydone);
              this.globalService.showUpgradeScreen(this.showOptionalUpgradesScreen);

              this.setTab(Sections.OptionalUpgrades);
            //}

            this.busyService.idle();
          }
          else
          {
            this.upgradeavaibilitydone[2] = true;
            this.showTheUpgradeScreen[2] = false;

            this.globalService.setUpgradesComplete(this.upgradeavaibilitydone);
            this.globalService.showUpgradeScreen(this.showTheUpgradeScreen);

            this.busyService.idle();
          }
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Error', detail: (response as availabletimes_returndata).messages[0]});
          this.busyService.idle();
        }
      }, error => {
        this.busyService.idle();
      });
    }
    else
    {
      this.upgradeavaibilitydone[2] = true;
    }
  }

  getUpgradeAvailability(packageupgrades: packageupgrade[], startTime: string)
  {

    this.availablePackageUpgrades = [];

   // this.busyService.busy();

    let totalNoOfPeople: number = 0;

    this.AvailabilityReq.Admissions = [] as admission[];

    this.SelectedAdmissions.forEach(adm => {
       this.AvailabilityReq.Admissions.push(adm);
    });

    this.AvailabilityReq.packageId = this.SelectedPackage.packageId;
    this.AvailabilityReq.venueid = this.VenueID;
    this.AvailabilityReq.DiagnosticMode = true;
    this.AvailabilityReq.StartTime = startTime;//this.SelectedDate.getFullYear() + "-" +  (this.SelectedDate.getMonth() + 1).toString().padStart(2, '0') + "-" +  this.SelectedDate.getDate().toString().padStart(2, '0') + "T"+ startTime + ":00.000Z";
    this.AvailabilityReq.IgnoreExistingBooking = true;
    this.AvailabilityReq.ExistingBookingID = this.NewBooking.bookingId;
    this.AvailabilityReq.useintervalavailability = this.UseIntervalAvailability;

    //First Upgrade
    if(packageupgrades.length > 0)
    {  
      this.AvailabilityReq.Resources = JSON.parse(JSON.stringify(this.customerSelectedResources)); 
      packageupgrades[0].upgrade.resources.forEach(res => { 
        this.AvailabilityReq.Resources.push(res);
      });
      this.http.post<availabletimes_returndata>(bmxurl + "/Availability", this.AvailabilityReq).subscribe(response => {       
        if((response as availabletimes_returndata).succeeded)
        {
         if(response.data.length > 0 && response.data[0].timeAvailable)
         {
          packageupgrades[0].upgrade.resources = [];

          response.data[0].resources.forEach(res => {
            if(res.isupgrade == true)   
            {
              packageupgrades[0].upgrade.resources.push(res);
            }
          });
            
            this.availablePackageUpgrades.push(packageupgrades[0]);
            this.upgradeavaibilitydone[0] = true;
            this.showTheUpgradeScreen[0] = true;

            this.availablePackageUpgrades = this.availablePackageUpgrades.sort((a, b) => (a.order > b.order) ? 1 : -1);

            this.globalService.setUpgradesComplete(this.upgradeavaibilitydone);
            this.globalService.showUpgradeScreen(this.showTheUpgradeScreen);

            this.setTab(Sections.Upgrades);
            
            this.busyService.idle();
         }
         else
         {
            this.busyService.idle();
            //this.availablePackageUpgrades.push(packageupgrades[0]);
            this.upgradeavaibilitydone[0] = true;
            this.showTheUpgradeScreen[0] = false;

            this.globalService.setUpgradesComplete(this.upgradeavaibilitydone);
            this.globalService.showUpgradeScreen(this.showTheUpgradeScreen);

            if(this.packageExtras.length == 0 && this.SelectedPackage.questionnaire == null)
            {
              this.setTab(Sections.Customer);
            }
            else if(this.SelectedPackage.questionnaire != null)
            {
              this.setTab(Sections.BookingQuestions);
            }
            else
            {
              this.setTab(Sections.Extras);
            }
         }
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Error', detail: (response as availabletimes_returndata).messages[0]});
          this.busyService.idle();
        }
      }, error => {
        this.busyService.idle();
      });
    }
    else
    {
      if(this.packageExtras.length == 0 && this.SelectedPackage.questionnaire == null)
      {
        this.setTab(Sections.Customer);
      }
      else if(this.SelectedPackage.questionnaire != null)
      {
        this.setTab(Sections.BookingQuestions);
      }
      else
      {
        this.setTab(Sections.Extras);
      }

      this.upgradeavaibilitydone[0] = true;
      this.upgradeavaibilitydone[1] = true;
      this.upgradeavaibilitydone[2] = true;
      
      this.showTheUpgradeScreen[0] = false;
      this.showTheUpgradeScreen[1] = false;
      this.showTheUpgradeScreen[2] = false;

      this.globalService.setUpgradesComplete(this.upgradeavaibilitydone);
      this.globalService.showUpgradeScreen(this.showTheUpgradeScreen);

      this.showUpgrade = false;
      this.busyService.idle();
    }

    //Second Upgrade

    this.AvailabilityReq2.Admissions = [] as admission[];

    this.SelectedAdmissions.forEach(adm => {
       this.AvailabilityReq2.Admissions.push(adm);
    });

    this.AvailabilityReq2.packageId = this.SelectedPackage.packageId;
    this.AvailabilityReq2.venueid = this.VenueID;
    this.AvailabilityReq2.DiagnosticMode = true;
    this.AvailabilityReq2.StartTime = startTime;//this.SelectedDate.getFullYear() + "-" +  (this.SelectedDate.getMonth() + 1).toString().padStart(2, '0') + "-" +  this.SelectedDate.getDate().toString().padStart(2, '0') + "T"+ startTime + ":00.000Z";
    this.AvailabilityReq2.IgnoreExistingBooking = true;
    this.AvailabilityReq2.ExistingBookingID = this.NewBooking.bookingId;
    this.AvailabilityReq2.useintervalavailability = this.UseIntervalAvailability;


    if(packageupgrades.length > 1)
    {  
      this.AvailabilityReq2.Resources = JSON.parse(JSON.stringify(this.customerSelectedResources)); 
      packageupgrades[1].upgrade.resources.forEach(res1 => { 
        this.AvailabilityReq2.Resources.push(res1);
      });
      this.http.post<availabletimes_returndata>(bmxurl + "/Availability", this.AvailabilityReq2).subscribe(response => {       
        if((response as availabletimes_returndata).succeeded)
        {
          if(response.data.length > 0 && response.data[0].timeAvailable)
          {

            packageupgrades[1].upgrade.resources = [];
  
            response.data[0].resources.forEach(res => {
              if(res.isupgrade == true)   
              {
                packageupgrades[1].upgrade.resources.push(res);
              }
            });
            
            this.availablePackageUpgrades.push(packageupgrades[1]);

            this.availablePackageUpgrades = this.availablePackageUpgrades.sort((a, b) => (a.order > b.order) ? 1 : -1);

            this.upgradeavaibilitydone[1] = true;
            this.showTheUpgradeScreen[1] = true;
            this.globalService.setUpgradesComplete(this.upgradeavaibilitydone);
            this.globalService.showUpgradeScreen(this.showTheUpgradeScreen);
            
            this.setTab(Sections.Upgrades);

            this.busyService.idle();
          }
          else
          {
            this.upgradeavaibilitydone[1] = true;
            this.showTheUpgradeScreen[1] = false;

            this.globalService.setUpgradesComplete(this.upgradeavaibilitydone);
            this.globalService.showUpgradeScreen(this.showTheUpgradeScreen);

            this.busyService.idle();
          }
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Error', detail: (response as availabletimes_returndata).messages[0]});
          this.busyService.idle();
        }
      }, error => {
        this.busyService.idle();
      });
    }
    else
    {
      this.upgradeavaibilitydone[1] = true;
    }

    //Third Upgrade

    this.AvailabilityReq3.Admissions = [] as admission[];

    this.SelectedAdmissions.forEach(adm => {
       this.AvailabilityReq3.Admissions.push(adm);
    });

    this.AvailabilityReq3.packageId = this.SelectedPackage.packageId;
    this.AvailabilityReq3.venueid = this.VenueID;
    this.AvailabilityReq3.DiagnosticMode = true;
    this.AvailabilityReq3.StartTime = startTime;//this.SelectedDate.getFullYear() + "-" +  (this.SelectedDate.getMonth() + 1).toString().padStart(2, '0') + "-" +  this.SelectedDate.getDate().toString().padStart(2, '0') + "T"+ startTime + ":00.000Z";
    this.AvailabilityReq3.IgnoreExistingBooking = true;
    this.AvailabilityReq3.ExistingBookingID = this.NewBooking.bookingId;
    this.AvailabilityReq3.useintervalavailability = this.UseIntervalAvailability;

    if(packageupgrades.length > 2)
    {  
      this.AvailabilityReq3.Resources = JSON.parse(JSON.stringify(this.customerSelectedResources)); 
      packageupgrades[2].upgrade.resources.forEach(res2 => { 
        this.AvailabilityReq3.Resources.push(res2);
      });
      this.http.post<availabletimes_returndata>(bmxurl + "/Availability", this.AvailabilityReq3).subscribe(response => {       
        if((response as availabletimes_returndata).succeeded)
        {
          if(response.data.length > 0 && response.data[0].timeAvailable)
          {

            packageupgrades[2].upgrade.resources = [];
  
            response.data[0].resources.forEach(res => {
              if(res.isupgrade == true)   
              {
                packageupgrades[2].upgrade.resources.push(res);
              }
            });

            this.availablePackageUpgrades.push(packageupgrades[2]);

            this.availablePackageUpgrades = this.availablePackageUpgrades.sort((a, b) => (a.order > b.order) ? 1 : -1);

            this.upgradeavaibilitydone[2] = true;
            this.showTheUpgradeScreen[2] = true;
            this.globalService.setUpgradesComplete(this.upgradeavaibilitydone);
            this.globalService.showUpgradeScreen(this.showTheUpgradeScreen);

            this.setTab(Sections.Upgrades);

            this.busyService.idle();
          }
          else
          {
            this.upgradeavaibilitydone[2] = true;
            this.showTheUpgradeScreen[2] = false;

            this.globalService.setUpgradesComplete(this.upgradeavaibilitydone);
            this.globalService.showUpgradeScreen(this.showTheUpgradeScreen);

            this.busyService.idle();
          }
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Error', detail: (response as availabletimes_returndata).messages[0]});
          this.busyService.idle();
        }
      }, error => {
        this.busyService.idle();
      });
    }
    else
    {
      this.upgradeavaibilitydone[2] = true;
    }
  }

  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }

  addMs = (date: Date, ms: number): Date => {
    const result = new Date(date);
    result.setMilliseconds(result.getMilliseconds() + ms);
    return result;
  };

  printConfirmation()
  {
    //this.confHTML = "https://email.wannabook.online/print/" + this.VenueID + "/" + this.NewBooking.bookingId;
    this.showPrintConfirmations = true;
    this.http.get(bmxurl + "print/" + this.VenueID + "/" + this.NewBooking.bookingId).subscribe(response => {
      this.confHTML = (response as conf_returndata).data.toString();
    }, error => {
      this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to get Payment Types.'});
    })

  }

  switchToToday(){
    this.SelectedDate = new Date();
    this.doneDate();
  }

  switchTomorrow(){
    let tomorrow = new Date();
    tomorrow.setDate(new Date().getDate() + 1);

    this.SelectedDate = tomorrow;
    this.doneDate();
  }

  switchToSaturday()
  {
    let saturday = new Date();
    let overflow = 0;

    while(saturday.getDay() != 6 && overflow <= 7)
    {
      saturday.setDate(saturday.getDate() + 1);
      overflow ++;
    }

    this.SelectedDate = saturday;
    this.doneDate();
  }

  switchToSunday()
  {
    let sunday = new Date();
    let overflow = 0;

    while(sunday.getDay() != 0 && overflow <= 7)
    {
      sunday.setDate(sunday.getDate() + 1);
      overflow ++;
    }

    this.SelectedDate = sunday;
    this.doneDate();
  }
}

enum Sections {
  Date = 0,
  Package = 1,
  Admissions = 2,
  Partyroom = 3,
  Time = 4,
  Customer = 5,
  Extras = 6,
  Notes = 7,
  Payment = 8,
  BookingQuestions = 9,
  Upgrades = 10,
  OptionalUpgrades = 11
}

//One date of a repeatable package while it is being booked.
//One fixed block of a repeatable package, resolved against the availability already fetched for
//every date. Taken whole or not at all.
interface seriesblock {
  blockid: string;
  name: string;
  //The dates the package says are in this block, as they are stored on it.
  wanted: string[];
  //Those dates as this screen knows them, which is fewer if any have gone by.
  dates: seriesdate[];
  sessions: number;
  //How many of its dates are in the past.
  passed: number;
  //Those with nothing free on them.
  full: seriesdate[];
  available: boolean;
  rangeText: string;
}

interface seriesdate {
  //The package date, that day at midnight.
  date: string;
  //Free times on that date.
  times: AvailableTimes[];
  chosen: AvailableTimes | null;
  //Choose dates: whether this date is wanted.
  ticked: boolean;
  //The held in-progress booking, once held.
  held: any;
  heldResponse: any;
  //The time was taken by someone else when it came to holding it.
  failed: boolean;
  request: AvailabilityReq;
  //The times the package runs at on this date, from its repeat dates.
  packageTimes: string[];
  //Why this date has no times, in the API's own words where it gave a reason. Without this the
  //screen could only say there were none, which says nothing about what to put right.
  reason: string;
}


